import * as i1 from '@angular/common';
import { CommonModule, formatNumber, DOCUMENT, getLocaleNumberSymbol, NumberSymbol, NgClass, NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, LOCALE_ID, Injectable, Inject, Pipe, signal, computed, input, output, ViewChild, Directive, forwardRef, HostListener, NgModule, importProvidersFrom } from '@angular/core';
import * as i2$2 from '@angular/material/icon';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { toSignal } from '@angular/core/rxjs-interop';
import * as i3 from '@polaris-customerweb/sharedcomponents.user-profile';
import * as i1$2 from '@polaris-customerweb/sharedcomponents.core';
import { defaultCulture, UtilService, supportedCultures, WINDOW, CacheCollection, LogLevel, logLevelName, getSupportedCulture, WebComponentHttpClient, WEB_COMPONENT_HTTP_INTERCEPTORS, LanguageInterceptor, WebComponentNoInterceptHttpClient } from '@polaris-customerweb/sharedcomponents.core';
import { toLower, isArray, merge, isFinite as isFinite$1, clamp, orderBy, floor, has, get, isNumber, every, some, cloneDeep, compact, attempt, defaults, capitalize, set, camelCase } from 'lodash-es';
import { map, takeWhile, tap } from 'rxjs/operators';
import * as i1$1 from '@polaris-customerweb/sharedcomponents.config';
import { siteUrlFactory, SkuInterceptor, provideConfig } from '@polaris-customerweb/sharedcomponents.config';
import { decode } from '@googlemaps/polyline-codec';
import { findTimeZone, getZonedTime } from 'timezone-support';
import { Subject, filter, startWith, switchMap, of, firstValueFrom, BehaviorSubject, map as map$1, from, catchError, NEVER, defer, exhaustMap, throwError, share, Observable } from 'rxjs';
import { v4 } from 'uuid';
import * as i2$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import * as i2 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { HttpParams, HttpErrorResponse } from '@angular/common/http';
import * as i3$1 from '@angular/platform-browser';
import * as i1$3 from '@angular/cdk/layout';
import * as i3$2 from '@polaris-customerweb/sharedcomponents.auth';
import { AuthInterceptor } from '@polaris-customerweb/sharedcomponents.auth';
import * as mqtt from 'mqtt';
import { lineString } from '@turf/helpers';
import turfLineLength from '@turf/length';
import center from '@turf/center';

class ButtonComponent {
    constructor() {
        this.align = 'center';
        this.disabled = false;
        this.elementId = '';
        this.expanded = false;
        this.fullWidth = false;
        this.iconClass = '';
        this.maxWidth = false;
        this.text = '';
        this.textColor = 'primary';
        this.variant = 'primary';
        this.clicked = new EventEmitter();
    }
    onClick(event) {
        if (!this.disabled) {
            this.clicked.emit(event);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: ButtonComponent, isStandalone: true, selector: "pii-button", inputs: { align: "align", disabled: "disabled", elementId: "elementId", expanded: "expanded", fullWidth: "fullWidth", iconClass: "iconClass", iconName: "iconName", maxWidth: "maxWidth", text: "text", textColor: "textColor", variant: "variant" }, outputs: { clicked: "clicked" }, ngImport: i0, template: "<div\n  class=\"button-container\"\n  [id]=\"elementId\"\n  [ngClass]=\"{ fullWidth: fullWidth, expanded: expanded, maxWidth: maxWidth }\"\n>\n  <a\n    href=\"javascript:void(0)\"\n    [class]=\"variant + ' ' + align\"\n    [ngClass]=\"{ disabled: disabled, two: iconName && text, 'icon-only': iconName && !text }\"\n    (click)=\"onClick($event)\"\n  >\n    @if (iconName) {\n      <mat-icon [svgIcon]=\"'pii:' + iconName\" [class]=\"iconClass\" />\n    }\n    @if (text) {\n      <span [class]=\"textColor\">{{ text }}</span>\n    }\n  </a>\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.button-container{display:flex}.button-container.fullWidth{justify-content:stretch}.button-container.fullWidth a{width:100%}.button-container.maxWidth a{width:max-content}.button-container a{font-size:1.1rem;line-height:1.1rem;align-items:center;border-radius:5px;cursor:pointer;display:grid;font-weight:700;grid-template-columns:auto;justify-content:center;padding:10px 15px;text-align:center;text-decoration:none}.button-container.expanded a{padding:15px}.button-container a.two{gap:8px;grid-template-columns:auto auto}.button-container a.icon-only{padding:8px}.button-container a.icon-only mat-icon{height:21px;width:21px}.button-container a.left{justify-content:flex-start}.button-container a.right{justify-content:flex-end}.button-container .black{color:#000}.button-container a.primary{background-color:var(--primary-color);box-shadow:0 2px 6px 0 var(--shadow-color);color:#fff}.button-container a.primary:hover{background-color:var(--primary-color-button-hover)}.button-container a.primary:active{background-color:var(--primary-color-button-active)}.button-container a.secondary{background-color:#fff;box-shadow:0 2px 6px 0 var(--shadow-color);color:var(--primary-color)}.button-container a.secondary:hover{box-shadow:0 4px 8px 0 var(--shadow-color)}.button-container a.secondary:active{background-color:#d8d8d8}.button-container a.outlined{background-color:#fff;border:1px solid #d8d8d8;box-shadow:none;color:var(--primary-color)}.button-container a.outlined:hover{border:1px solid var(--primary-color)}.button-container a.outlined:active{background-color:#d8d8d8;border:1px solid rgb(128,128,128)}.button-container a.disabled{background-color:#d8d8d8!important;border:0;box-shadow:none!important;color:#fff!important;cursor:not-allowed}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ imports: [CommonModule, MatIcon], selector: 'pii-button', standalone: true, template: "<div\n  class=\"button-container\"\n  [id]=\"elementId\"\n  [ngClass]=\"{ fullWidth: fullWidth, expanded: expanded, maxWidth: maxWidth }\"\n>\n  <a\n    href=\"javascript:void(0)\"\n    [class]=\"variant + ' ' + align\"\n    [ngClass]=\"{ disabled: disabled, two: iconName && text, 'icon-only': iconName && !text }\"\n    (click)=\"onClick($event)\"\n  >\n    @if (iconName) {\n      <mat-icon [svgIcon]=\"'pii:' + iconName\" [class]=\"iconClass\" />\n    }\n    @if (text) {\n      <span [class]=\"textColor\">{{ text }}</span>\n    }\n  </a>\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.button-container{display:flex}.button-container.fullWidth{justify-content:stretch}.button-container.fullWidth a{width:100%}.button-container.maxWidth a{width:max-content}.button-container a{font-size:1.1rem;line-height:1.1rem;align-items:center;border-radius:5px;cursor:pointer;display:grid;font-weight:700;grid-template-columns:auto;justify-content:center;padding:10px 15px;text-align:center;text-decoration:none}.button-container.expanded a{padding:15px}.button-container a.two{gap:8px;grid-template-columns:auto auto}.button-container a.icon-only{padding:8px}.button-container a.icon-only mat-icon{height:21px;width:21px}.button-container a.left{justify-content:flex-start}.button-container a.right{justify-content:flex-end}.button-container .black{color:#000}.button-container a.primary{background-color:var(--primary-color);box-shadow:0 2px 6px 0 var(--shadow-color);color:#fff}.button-container a.primary:hover{background-color:var(--primary-color-button-hover)}.button-container a.primary:active{background-color:var(--primary-color-button-active)}.button-container a.secondary{background-color:#fff;box-shadow:0 2px 6px 0 var(--shadow-color);color:var(--primary-color)}.button-container a.secondary:hover{box-shadow:0 4px 8px 0 var(--shadow-color)}.button-container a.secondary:active{background-color:#d8d8d8}.button-container a.outlined{background-color:#fff;border:1px solid #d8d8d8;box-shadow:none;color:var(--primary-color)}.button-container a.outlined:hover{border:1px solid var(--primary-color)}.button-container a.outlined:active{background-color:#d8d8d8;border:1px solid rgb(128,128,128)}.button-container a.disabled{background-color:#d8d8d8!important;border:0;box-shadow:none!important;color:#fff!important;cursor:not-allowed}\n"] }]
        }], propDecorators: { align: [{
                type: Input
            }], disabled: [{
                type: Input
            }], elementId: [{
                type: Input
            }], expanded: [{
                type: Input
            }], fullWidth: [{
                type: Input
            }], iconClass: [{
                type: Input
            }], iconName: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], text: [{
                type: Input
            }], textColor: [{
                type: Input
            }], variant: [{
                type: Input
            }], clicked: [{
                type: Output
            }] } });

class Condition {
    constructor(contract = {}) {
        this.contract = contract;
    }
    get description() {
        return this.contract.description ?? '';
    }
    get icon() {
        switch (this.contract.type) {
            case 'Closed':
                return 'pii:closed';
            case 'Dry':
                return 'pii:dry';
            case 'Dusty':
                return 'pii:dusty';
            case 'FallenTree':
                return 'pii:tree';
            case 'Good':
                return this.rideType === 'SNO' ? 'pii:sno-good' : 'pii:orv-good';
            case 'Hazard':
                return 'pii:hazard';
            case 'Hole':
                return 'pii:hole';
            case 'Mud':
                return 'pii:mud';
            case 'OK':
                return this.rideType === 'SNO' ? 'pii:sno-ok' : 'pii:orv-ok';
            case 'Flooded':
            case 'OpenWater':
                return 'pii:flooded';
            case 'Poor':
                return this.rideType === 'SNO' ? 'pii:sno-poor' : 'pii:orv-poor';
            case 'Rocks':
            case 'Rocky':
                return 'pii:rocky';
            case 'Washout':
                return 'pii:washout';
            default:
                return '';
        }
    }
    get id() {
        return this.contract.id ?? '';
    }
    get reportedByRiderId() {
        return this.contract.reportedByRiderId ?? '';
    }
    get reportedTime() {
        return this.contract.reportedTime ? new Date(this.contract.reportedTime) : new Date();
    }
    get rideType() {
        return this.contract.rideType ?? 'Unknown';
    }
    get type() {
        return this.contract.type ?? 'Unknown';
    }
    get typeName() {
        return this.contract.type === 'OK' ? 'OK' : (this.contract.type?.replace(/([A-Z])/g, ' $1').trim() ?? '');
    }
}

class DateTimeService {
    constructor(locale) {
        this.locale = locale;
        this._MS_PER_DAY = 86400000;
        this.getRelativeTime = (time) => {
            const diffTime = Math.abs(new Date().valueOf() - new Date(time).valueOf());
            const day = diffTime / (24 * 60 * 60 * 1000);
            let years = day / 365;
            let months = (years % 1) * 12;
            let weeks = (months % 1) * 4;
            let days = (weeks % 1) * 7;
            let hours = (days % 1) * 24;
            let minutes = (hours % 1) * 60;
            let seconds = (minutes % 1) * 60;
            let mSeconds = (seconds % 1) * 10;
            [years, months, weeks, days, hours, minutes, seconds, mSeconds] = [
                Math.floor(years),
                Math.floor(months),
                Math.floor(weeks),
                Math.floor(days),
                Math.floor(hours),
                Math.floor(minutes),
                Math.floor(seconds),
                Math.floor(mSeconds),
            ];
            if (years !== 0) {
                return years > 1 ? $localize `${years} years ago` : $localize `Last year`;
            }
            else if (months !== 0) {
                return months > 1 ? $localize `${months} months ago` : $localize `Last month`;
            }
            else if (weeks !== 0) {
                return weeks > 1 ? $localize `${weeks} weeks ago` : $localize `Last week`;
            }
            else if (days !== 0) {
                return days > 1 ? $localize `${days} days ago` : $localize `Yesterday`;
            }
            else if (hours !== 0) {
                return $localize `${hours} hour${hours > 1 ? 's' : ''} ago`;
            }
            else if (minutes !== 0) {
                return $localize `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
            }
            else {
                return $localize `Just now`;
            }
        };
        this.getRelativeDate = (time) => {
            const isoDateTime = new Date(time);
            const isoDateTimeNow = new Date(new Date().getTime());
            const dayDiff = isoDateTimeNow.getDate() - isoDateTime.getDate();
            const monthDiff = isoDateTimeNow.getMonth() - isoDateTime.getMonth();
            const yearDiff = isoDateTimeNow.getFullYear() - isoDateTime.getFullYear();
            if ((dayDiff === 1 && monthDiff === 0 && yearDiff === 0) || (dayDiff === 0 && monthDiff >= 1 && yearDiff >= 1)) {
                return $localize `Yesterday at ${isoDateTime.toLocaleString(defaultCulture, {
                    hour: '2-digit',
                    hour12: true,
                    minute: '2-digit',
                })}`;
            }
            else if (dayDiff === 0 && monthDiff === 0 && yearDiff === 0) {
                return $localize `Today at ${isoDateTime.toLocaleString(defaultCulture, {
                    hour: '2-digit',
                    hour12: true,
                    minute: '2-digit',
                })}`;
            }
            else {
                return isoDateTime.toLocaleString(defaultCulture, {
                    day: '2-digit',
                    hour: '2-digit',
                    hour12: true,
                    minute: '2-digit',
                    month: 'long',
                    year: 'numeric',
                });
            }
        };
    }
    getRelativeWeekday(date) {
        const now = new Date();
        const day = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
        const diff = Math.floor((day - today) / this._MS_PER_DAY);
        if (diff < -7) {
            return Intl.DateTimeFormat(this.locale, { day: 'numeric', month: 'numeric', year: 'numeric' }).format(date);
        }
        else if (diff < -1) {
            return `${$localize `last`} ${new Intl.DateTimeFormat(this.locale, { weekday: 'long' }).format(date)}`;
        }
        else if (diff < 0) {
            return $localize `Yesterday`;
        }
        else if (diff < 1) {
            return $localize `Today`;
        }
        else if (diff < 2) {
            return $localize `Tomorrow`;
        }
        else if (diff < 7) {
            return new Intl.DateTimeFormat(this.locale, { weekday: 'long' }).format(date);
        }
        else {
            return Intl.DateTimeFormat(this.locale, { day: 'numeric', month: 'numeric', year: 'numeric' }).format(date);
        }
    }
    getRelativeWeekdayOrMonth(date) {
        const now = new Date();
        const day = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
        const diff = Math.floor((day - today) / this._MS_PER_DAY);
        if (diff < -7) {
            return Intl.DateTimeFormat(this.locale, { day: '2-digit', month: '2-digit' }).format(date);
        }
        else if (diff < -1) {
            return Intl.DateTimeFormat(this.locale, { day: '2-digit', month: '2-digit' }).format(date);
        }
        else if (diff < 0) {
            return $localize `Yesterday`;
        }
        else if (diff < 1) {
            return $localize `Today`;
        }
        else if (diff < 2) {
            return $localize `Tomorrow`;
        }
        else if (diff < 7) {
            return new Intl.DateTimeFormat(this.locale, { weekday: 'long' }).format(date);
        }
        else {
            return Intl.DateTimeFormat(this.locale, { day: '2-digit', month: '2-digit' }).format(date);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DateTimeService, deps: [{ token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DateTimeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DateTimeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }] });

class RelativeWeekdayPipe {
    constructor(dateTimeService) {
        this.dateTimeService = dateTimeService;
    }
    transform(value) {
        return this.dateTimeService.getRelativeWeekday(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RelativeWeekdayPipe, deps: [{ token: DateTimeService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: RelativeWeekdayPipe, isStandalone: true, name: "relativeWeekday" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RelativeWeekdayPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'relativeWeekday',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: DateTimeService }] });

class RemoveWhiteSpacePipe {
    transform(value) {
        if (!value) {
            return value;
        }
        return value.replace(/ /g, '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RemoveWhiteSpacePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: RemoveWhiteSpacePipe, isStandalone: true, name: "removewhitespace" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RemoveWhiteSpacePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'removewhitespace',
                    standalone: true,
                }]
        }] });

class SnapshotService {
    getSnapshotUrl(snapshots, sizes, mapType) {
        let snapshotOfMapType;
        let snapshotRegardlessOfMapType;
        for (const size of sizes) {
            if (mapType) {
                snapshotOfMapType = snapshots.find((snapshot) => toLower(snapshot.size) === toLower(size) && snapshot.mapType === mapType);
                if (snapshotOfMapType) {
                    break;
                }
            }
            // Get snapshot for this size regardless of map type even if map type
            // is set, in case there is no snapshot matching desired map type.
            snapshotRegardlessOfMapType = snapshots.find((snapshot) => toLower(snapshot.size) === toLower(size));
            if (!mapType && snapshotRegardlessOfMapType) {
                break;
            }
        }
        const foundSnapshot = snapshotOfMapType || snapshotRegardlessOfMapType;
        return foundSnapshot?.url || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SnapshotService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SnapshotService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SnapshotService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class SnapshotToUrlPipe {
    constructor(snapshotService) {
        this.snapshotService = snapshotService;
    }
    transform(snapshots, sizes, type) {
        if (!isArray(snapshots)) {
            return '';
        }
        if (typeof sizes === 'string') {
            sizes = [sizes];
        }
        if (!isArray(sizes)) {
            return '';
        }
        return this.snapshotService.getSnapshotUrl(snapshots, sizes, type);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SnapshotToUrlPipe, deps: [{ token: SnapshotService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: SnapshotToUrlPipe, isStandalone: true, name: "snapshotToUrl" }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SnapshotToUrlPipe, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SnapshotToUrlPipe, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }, {
            type: Pipe,
            args: [{
                    name: 'snapshotToUrl',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: SnapshotService }] });

class StringPipe {
    transform(value, radix = 10) {
        if (value == null) {
            return '';
        }
        if (typeof value === 'number') {
            return value.toString(radix);
        }
        return String(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: StringPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: StringPipe, isStandalone: true, name: "string" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: StringPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'string',
                    standalone: true,
                }]
        }] });

class ConversionService {
    constructor() {
        this.acresPerSqKm = 247.10538146717;
        this.degreesFPerDegreesC = 1.8;
        this.degreesOffset = 32;
        this.feetPerMeter = 3.28084;
        this.metersPerKm = 1000;
        this.metersPerMile = ConversionService.metersPerMile;
        this.kmPerMile = ConversionService.kmPerMile;
        this.kpaPerPsi = 6.8947572931783;
        this.sqFeetPerSqMeter = 10.76391041671;
        this.sqMetersPerAcre = 4046.8564224;
        this.sqMetersPerHectare = 10000;
        this.sqMetersPerSqKm = 1000000;
        this.sqMetersPerSqMile = 2589988.110336;
        this.cardinalNorth = $localize `North`;
        this.cardinalNortheast = $localize `Northeast`;
        this.cardinalEast = $localize `East`;
        this.cardinalSoutheast = $localize `Southeast`;
        this.cardinalSouth = $localize `South`;
        this.cardinalSouthwest = $localize `Southwest`;
        this.cardinalWest = $localize `West`;
        this.cardinalNorthwest = $localize `Northwest`;
        this.cardinalNorthAbbr = $localize `:Cardinal direction North abbreviated:N`;
        this.cardinalNortheastAbbr = $localize `:Cardinal direction Northeast abbreviated:NE`;
        this.cardinalEastAbbr = $localize `:Cardinal direction East abbreviated:E`;
        this.cardinalSoutheastAbbr = $localize `:Cardinal direction Southeast abbreviated:SE`;
        this.cardinalSouthAbbr = $localize `:Cardinal direction South abbreviated:S`;
        this.cardinalSouthwestAbbr = $localize `:Cardinal direction Southwest abbreviated:SW`;
        this.cardinalWestAbbr = $localize `:Cardinal direction West abbreviated:W`;
        this.cardinalNorthwestAbbr = $localize `:Cardinal direction Northwest abbreviated:NW`;
        this.cardinalDirections = [this.cardinalNorth, this.cardinalEast, this.cardinalSouth, this.cardinalWest];
        this.cardinalAndInterCardinalDirections = [
            this.cardinalNorth,
            this.cardinalNortheast,
            this.cardinalEast,
            this.cardinalSoutheast,
            this.cardinalSouth,
            this.cardinalSouthwest,
            this.cardinalWest,
            this.cardinalNorthwest,
        ];
        this.cardinalDirectionsAbbr = [
            this.cardinalNorthAbbr,
            this.cardinalEastAbbr,
            this.cardinalSouthAbbr,
            this.cardinalWestAbbr,
        ];
        this.cardinalAndInterCardinalDirectionsAbbr = [
            this.cardinalNorthAbbr,
            this.cardinalNortheastAbbr,
            this.cardinalEastAbbr,
            this.cardinalSoutheastAbbr,
            this.cardinalSouthAbbr,
            this.cardinalSouthwestAbbr,
            this.cardinalWestAbbr,
            this.cardinalNorthwestAbbr,
        ];
        this.unitNormalizationMap = new Map([
            ['acre', 'acre'],
            ['c', 'C'],
            ['celsius', 'C'],
            ['f', 'F'],
            ['fahrenheit', 'F'],
            ['feet', 'ft'],
            ['foot', 'ft'],
            ['ft', 'ft'],
            ['kilometer', 'km'],
            ['kilometers', 'km'],
            ['kilopascal', 'kPa'],
            ['km', 'km'],
            ['km2', 'sqKm'],
            ['kpa', 'kPa'],
            ['kwh/km', 'kWh/km'],
            ['kwh/mi', 'kWh/mi'],
            ['m', 'm'],
            ['meter', 'm'],
            ['meters', 'm'],
            ['mi', 'mi'],
            ['mile', 'mi'],
            ['miles', 'mi'],
            ['psi', 'psi'],
            ['sqkm', 'sqKm'],
        ]);
        this.imperialUnits = ['acre', 'F', 'ft', 'kWh/mi', 'mi', 'psi'];
        this.metricUnits = ['C', 'km', 'kPa', 'kWh/km', 'm', 'sqKm'];
    }
    static { this.kmPerMile = 1.609344; }
    static { this.metersPerMile = 1609.344; }
    static { this.radiansPerDegree = Math.PI / 180; }
    static { this.degreesPerRadian = 180 / Math.PI; }
    /**
     * @description Converts degrees into radians.
     * @param degrees - Degrees
     * @returns Radians
     */
    static degreesToRadians(degrees) {
        return degrees * ConversionService.radiansPerDegree;
    }
    static kmToMiles(kilometers) {
        return kilometers / ConversionService.kmPerMile;
    }
    static milesToKm(miles) {
        return miles * ConversionService.kmPerMile;
    }
    static milesToMeters(miles) {
        return miles * ConversionService.metersPerMile;
    }
    // #region length
    feetToMeters(feet) {
        return feet / this.feetPerMeter;
    }
    kmToMeters(kilometers) {
        return kilometers * this.metersPerKm;
    }
    kmToMiles(kilometers) {
        if (!this.isValidNumber(kilometers)) {
            return kilometers;
        }
        return ConversionService.kmToMiles(kilometers);
    }
    metersToFeet(meters) {
        if (!this.isValidNumber(meters)) {
            return meters;
        }
        return meters * this.feetPerMeter;
    }
    metersToMiles(meters) {
        return meters / this.metersPerMile;
    }
    metersToKm(meters) {
        return meters / this.metersPerKm;
    }
    milesToKm(miles) {
        return ConversionService.milesToKm(miles);
    }
    milesToMeters(miles) {
        return ConversionService.milesToMeters(miles);
    }
    // #endregion
    // #region area
    acresToSqKm(acres) {
        return acres / this.acresPerSqKm;
    }
    acresToSqMeters(acres) {
        return acres * this.sqMetersPerAcre;
    }
    sqKmToAcres(sqKilometers) {
        if (!this.isValidNumber(sqKilometers)) {
            return sqKilometers;
        }
        return sqKilometers * this.acresPerSqKm;
    }
    sqMetersToAcres(sqMeters) {
        return sqMeters / this.sqMetersPerAcre;
    }
    sqMetersToSqFeet(sqMeters) {
        return sqMeters * this.sqFeetPerSqMeter;
    }
    sqMetersToHectares(sqMeters) {
        return sqMeters / this.sqMetersPerHectare;
    }
    sqMetersToSqKm(sqMeters) {
        return sqMeters / this.sqMetersPerSqKm;
    }
    sqMetersToSqMiles(sqMeters) {
        return sqMeters / this.sqMetersPerSqMile;
    }
    // #endregion
    // #region temp
    celsiusToFahrenheit(tempC) {
        if (!this.isValidNumber(tempC)) {
            return tempC;
        }
        return tempC * this.degreesFPerDegreesC + this.degreesOffset;
    }
    fahrenheitToCelsius(tempF) {
        if (!this.isValidNumber(tempF)) {
            return tempF;
        }
        return (tempF - this.degreesOffset) / this.degreesFPerDegreesC;
    }
    // #endregion
    // #region pressure
    kpaToPsi(kpa) {
        if (!this.isValidNumber(kpa)) {
            return kpa;
        }
        return kpa / this.kpaPerPsi;
    }
    psiToKpa(psi) {
        if (!this.isValidNumber(psi)) {
            return psi;
        }
        return psi * this.kpaPerPsi;
    }
    // #endregion
    // #region efficiency
    kwhPerKmToKwhPerMile(kwhPerKm) {
        if (!this.isValidNumber(kwhPerKm)) {
            return kwhPerKm;
        }
        return kwhPerKm * this.kmPerMile;
    }
    kwhPerMileToKwhPerKm(kwhPerMile) {
        if (!this.isValidNumber(kwhPerMile)) {
            return kwhPerMile;
        }
        return kwhPerMile / this.kmPerMile;
    }
    // #endregion
    isMetricUnit(unit) {
        return this.metricUnits.includes(unit);
    }
    isImperialUnit(unit) {
        return this.imperialUnits.includes(unit);
    }
    normalizeUnit(unit) {
        return this.unitNormalizationMap.get(unit.toLowerCase());
    }
    toImperial(value, sourceUnit) {
        switch (sourceUnit) {
            case 'C':
                return {
                    unit: 'F',
                    value: this.celsiusToFahrenheit(value),
                };
            case 'km':
                return {
                    unit: 'mi',
                    value: this.kmToMiles(value),
                };
            case 'kPa':
                return {
                    unit: 'psi',
                    value: this.kpaToPsi(value),
                };
            case 'kWh/km':
                return {
                    unit: 'kWh/mi',
                    value: this.kwhPerKmToKwhPerMile(value),
                };
            case 'm':
                return {
                    unit: 'ft',
                    value: this.metersToFeet(value),
                };
            case 'sqKm':
                return {
                    unit: 'acre',
                    value: this.sqKmToAcres(value),
                };
            default:
                throw new Error(`unrecognized unit "${sourceUnit}" converting to imperial`);
        }
    }
    toMetric(value, sourceUnit) {
        switch (sourceUnit) {
            case 'F':
                return {
                    unit: 'C',
                    value: this.fahrenheitToCelsius(value),
                };
            case 'mi':
                return {
                    unit: 'km',
                    value: this.milesToKm(value),
                };
            case 'psi':
                return {
                    unit: 'kPa',
                    value: this.psiToKpa(value),
                };
            case 'kWh/mi':
                return {
                    unit: 'kWh/km',
                    value: this.kwhPerMileToKwhPerKm(value),
                };
            case 'ft':
                return {
                    unit: 'm',
                    value: this.feetToMeters(value),
                };
            case 'acre':
                return {
                    unit: 'sqKm',
                    value: this.acresToSqKm(value),
                };
            default:
                throw new Error(`unrecognized unit "${sourceUnit}" converting to metric`);
        }
    }
    normalizeCoordinates(coordinates) {
        // Possible values:
        // "40,7128 ; -74,0060",
        // "40,7128, -74,0060"
        // "40,7128 -74,0060"
        const coordinatesRegex = /^-?\d+(,\d+)?\s*[;, \u00A0]\s*-?\d+(,\d+)?$/;
        if (!coordinatesRegex.test(coordinates))
            return coordinates;
        return coordinates
            .replace(/(\d+),(\d+)/g, '$1.$2') // Replace comma with dot for decimal numbers
            .replace(/\s*;\s*/g, ', ') // Replace semicolon with comma and space
            .replace(/(\d)\s+(-?\d)/g, '$1, $2'); // Replace spaces between numbers with comma and space
    }
    /**
     *  Converts an angle in radians to a compass direction
     * @param radians the angle in radians (0 radians corresponds to North)
     * @param abbreviated whether to use the abbreviated version of the direction
     * @param directionType the set of directions to use
     * @returns the direction the angle corresponds to
     */
    radiansToDirection(radians, abbreviated = false, directionType = 'fourWind') {
        return this.degreesToDirection(radians * ConversionService.degreesPerRadian, abbreviated, directionType);
    }
    /**
     *  Converts an angle in degrees to a compass direction
     * @param degrees the angle in degrees (0 degrees corresponds to North)
     * @param abbreviated whether to use the abbreviated version of the direction
     * @param directionType the set of directions to use
     * @returns the direction the angle corresponds to
     */
    degreesToDirection(degrees, abbreviated = false, directionType = 'fourWind') {
        if (!degrees) {
            return '';
        }
        // Normalize the degrees to be between [0, 360)
        degrees %= 360;
        if (degrees < 0) {
            degrees += 360;
        }
        // Select the direction array based on inputs
        let directions = this.cardinalDirections;
        if (directionType === 'fourWind') {
            directions = abbreviated ? this.cardinalDirectionsAbbr : this.cardinalDirections;
        }
        else {
            directions = abbreviated ? this.cardinalAndInterCardinalDirectionsAbbr : this.cardinalAndInterCardinalDirections;
        }
        // Get the portion of degrees each cardinal direction takes up of 360 degrees
        const sectorDegrees = 360 / directions.length;
        // Get the input degrees to a float between 0 and the length of directions array
        const mappedDegrees = degrees / sectorDegrees;
        // Round the mapped degrees to the closest index in directions
        const closestIndex = Math.round(mappedDegrees) % directions.length;
        return directions[closestIndex];
    }
    isValidNumber(num) {
        return typeof num === 'number' && !Number.isNaN(num);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConversionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class FormattedValue {
    constructor(data = {}) {
        this.rawUnits = '';
        this.rawValue = '';
        merge(this, {
            rawUnits: data.units,
            rawValue: data.value,
        });
    }
    get invalid() {
        return !this.isValid;
    }
    get isArray() {
        return Array.isArray(this.rawValue);
    }
    get isValid() {
        return typeof this.value === 'string' && this.value.length > 0;
    }
    get units() {
        return Array.isArray(this.rawUnits) ? this.rawUnits[0] : this.rawUnits;
    }
    get units2() {
        return Array.isArray(this.rawUnits) ? this.rawUnits[1] : '';
    }
    get value() {
        return Array.isArray(this.rawValue) ? this.rawValue[0] : this.rawValue;
    }
    get value2() {
        return Array.isArray(this.rawValue) ? this.rawValue[1] : '';
    }
}

class ValueDisplayService {
    constructor(locale) {
        this.locale = locale;
    }
    getFormattedInt(value, units) {
        const formatted = isFinite$1(value) ? this.toFixed(value, 0) : null;
        return new FormattedValue({
            units,
            value: formatted,
        });
    }
    getFormattedMinPrecision(value, units) {
        const formatted = isFinite$1(value) ? this.toMinPrecision(value) : null;
        return new FormattedValue({
            units,
            value: formatted,
        });
    }
    getFormattedSinglePrecision(value, units) {
        const formatted = isFinite$1(value) ? this.toFixed(value, 1) : null;
        return new FormattedValue({
            units,
            value: formatted,
        });
    }
    /**
     * @description Round a number using banker's (Gaussian) rounding rules.
     * Midway values are rounded to the even number, so both 1.5 and 2.5
     * round to 2 and -1.5 rounds -2.
     * Math.round rounds toward positive infinity, so 1.5 becomes 2, 2.5 becomes
     * 3 and -1.5 becomes -1.
     * @param value The number to round.
     * @param places The number of places to round to. Defaults to zero.
     * @returns The rounded number.
     */
    round(value, places = 0) {
        if (!isFinite$1(value)) {
            throw new Error('value must be a finite number');
        }
        // Force places to same range as Number.prototype.toFixed.
        places = clamp(places, 0, 100);
        return this.roundShifted(value, places) / 10 ** places;
    }
    /**
     * @description A toFixed implementation that uses banker's (Gaussian)
     * rounding rules. Midway values are rounded to the even number, so both
     * 1.5 and 2.5 round to 2 and -1.5 rounds -2.
     * Number.prototype.toFixed rounds to the number with the smallest floating
     * point error or toward positive infinity if error is the same for both.
     * So 0.25 and 0.35 are rounded to 0.3 but 0.55 is rounded to 0.6.
     * See https://262.ecma-international.org/5.1/#sec-15.7.4.5.
     * @param value The number to round.
     * @param places The number of places to round to. Defaults to two.
     * @returns A string representation of the number with the specified number
     * of decimal places.
     */
    toFixed(value, places = 2) {
        if (!isFinite$1(value)) {
            throw new Error('value must be a finite number');
        }
        // Force places to same range as Number.prototype.toFixed.
        places = clamp(places, 0, 100);
        const rounded = this.roundShifted(value, places);
        const roundedString = String(rounded);
        if (places === 0) {
            return formatNumber(Number(roundedString), this.locale, `1.${places}-${places}`);
        }
        const index = places * -1;
        const leftFill = roundedString.length === places ? '0' : '';
        return formatNumber(Number(`${leftFill}${roundedString.slice(0, index)}.${roundedString.slice(index)}`), this.locale, `1.${places}-${places}`);
    }
    /**
     * @description Convert a number to its string representation, showing one
     * decimal place if the value is between -10 and 10 and no decimal places
     * otherwise.
     * @param value The number to represent.
     * @returns A string representation of the number to preferred precision
     * based on value.
     */
    toMinPrecision(value) {
        if (!isFinite$1(value)) {
            throw new Error('value must be a finite number');
        }
        const places = value > -9.95 && value < 9.95 ? 1 : 0;
        return this.toFixed(value, places);
    }
    roundShifted(value, places = 0) {
        const shifted = value * 10 ** places;
        const truncated = Math.trunc(shifted);
        const remainder = Math.abs(shifted) % 1;
        const sign = value > 0 ? 1 : -1;
        // Account for floating point errors when shifting the input value.
        // See https://en.wikipedia.org/wiki/IEEE_754
        // and https://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html.
        const epsilon = 1e-8;
        const isHalf = remainder > 0.5 - epsilon && remainder < 0.5 + epsilon;
        let modifier;
        if (!isHalf) {
            modifier = remainder < 0.5 ? 0 : sign;
        }
        else {
            const isEven = truncated % 2 === 0;
            modifier = isEven ? 0 : sign;
        }
        return truncated + modifier;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ValueDisplayService, deps: [{ token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ValueDisplayService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ValueDisplayService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }] });

class DistanceDisplayService {
    constructor(conversionService, valueDisplayService) {
        this.conversionService = conversionService;
        this.valueDisplayService = valueDisplayService;
    }
    getMeasurementFormat(distanceInMeters, isMetric = true, format = 'MiKm', isNotRounded = false) {
        if (!isFinite$1(distanceInMeters)) {
            return new FormattedValue();
        }
        const forceFeetMeters = format.toLowerCase() === 'ftm';
        const useLongNames = format.toLowerCase() === 'mileskilometers';
        const { distance: value, units } = this.getFormattedDistance(distanceInMeters, isMetric, forceFeetMeters, useLongNames, isNotRounded);
        return new FormattedValue({ units, value });
    }
    // rules are as follows
    // 0 ft → 500 ft → 0.1 mi
    // 0 m → 99 m → 0.1 km
    // For values under 10, show one decimal place: 0.2 mi, 1.2 mi, 9.2 km
    // For values greater than or equal to 10, round to a whole number: 10 mi, 11, km
    getFormattedDistance(meters, isMetric, forceFeetMeters = false, useLongNames = false, isNotRounded = false) {
        let distance;
        let useSmallUnits = false;
        if (isMetric) {
            if (meters === 0) {
                useSmallUnits = forceFeetMeters;
                distance = '0';
            }
            else if (forceFeetMeters || meters < 99.5) {
                distance = this.valueDisplayService.toFixed(meters, 0);
                useSmallUnits = true;
            }
            else {
                const km = this.conversionService.metersToKm(meters);
                distance = isNotRounded ? this.valueDisplayService.toFixed(km, 1) : this.valueDisplayService.toMinPrecision(km);
            }
        }
        else {
            const ft = this.conversionService.metersToFeet(meters);
            if (meters === 0) {
                useSmallUnits = forceFeetMeters;
                distance = '0';
            }
            else if (forceFeetMeters || ft < 500.5) {
                distance = this.valueDisplayService.toFixed(ft, 0);
                useSmallUnits = true;
            }
            else {
                const mi = this.conversionService.metersToMiles(meters);
                distance = isNotRounded ? this.valueDisplayService.toFixed(mi, 1) : this.valueDisplayService.toMinPrecision(mi);
            }
        }
        const units = this.getUnits(isMetric, useSmallUnits, useLongNames, distance === '1');
        return { distance, units };
    }
    getUnits(isMetric, useSmallUnits, useLongNames, isSingular) {
        if (isMetric) {
            if (useSmallUnits) {
                if (useLongNames) {
                    return isSingular ? $localize `meter` : $localize `meters`;
                }
                return $localize `m`;
            }
            if (useLongNames) {
                return isSingular ? $localize `kilometer` : $localize `kilometers`;
            }
            return $localize `km`;
        }
        if (useSmallUnits) {
            if (useLongNames) {
                return isSingular ? $localize `foot` : $localize `feet`;
            }
            return $localize `ft`;
        }
        if (useLongNames) {
            return isSingular ? $localize `mile` : $localize `miles`;
        }
        return $localize `mi`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DistanceDisplayService, deps: [{ token: ConversionService }, { token: ValueDisplayService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DistanceDisplayService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DistanceDisplayService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ConversionService }, { type: ValueDisplayService }] });

class ToDistanceUnitsPipe {
    constructor(conversionService, distanceDisplayService, profileService) {
        this.conversionService = conversionService;
        this.distanceDisplayService = distanceDisplayService;
        this.profileService = profileService;
    }
    transform(distance, format = 'MiKm', inputUnits) {
        return this.profileService
            .getIsMetric$()
            .pipe(map((isMetric) => this.getMeasurementFormat(distance, isMetric, format, inputUnits)));
    }
    getMeasurementFormat(input, isMetric, format, inputUnits) {
        let meters = typeof input === 'string' ? parseFloat(input) : input;
        if (!isFinite$1(meters)) {
            return '';
        }
        // Convert to meters since all other calculations will be based on that.
        if (inputUnits === 'miles') {
            meters = this.conversionService.milesToMeters(meters);
        }
        else if (inputUnits === 'kilometers') {
            meters = this.conversionService.kmToMeters(meters);
        }
        const { units } = this.distanceDisplayService.getMeasurementFormat(meters, isMetric, format);
        return units;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ToDistanceUnitsPipe, deps: [{ token: ConversionService }, { token: DistanceDisplayService }, { token: i3.UserProfileService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: ToDistanceUnitsPipe, isStandalone: true, name: "toDistanceUnits" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ToDistanceUnitsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toDistanceUnits',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: ConversionService }, { type: DistanceDisplayService }, { type: i3.UserProfileService }] });

class ToDistancePipe {
    constructor(conversionService, distanceDisplayService, profileService) {
        this.conversionService = conversionService;
        this.distanceDisplayService = distanceDisplayService;
        this.profileService = profileService;
    }
    transform(input, format = 'MiKm', inputUnits) {
        return this.profileService.getIsMetric$().pipe(map((isMetric) => {
            return this.getMeasurementFormat(input, isMetric, format, inputUnits);
        }));
    }
    getMeasurementFormat(input, isMetric, format, inputUnits) {
        let meters = typeof input === 'string' ? parseFloat(input) : input;
        if (!isFinite$1(meters)) {
            return '--';
        }
        // Convert to meters since all other calculations will be based on that.
        if (inputUnits === 'miles') {
            meters = this.conversionService.milesToMeters(meters);
        }
        else if (inputUnits === 'kilometers') {
            meters = this.conversionService.kmToMeters(meters);
        }
        const { value } = this.distanceDisplayService.getMeasurementFormat(meters, isMetric, format);
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ToDistancePipe, deps: [{ token: ConversionService }, { token: DistanceDisplayService }, { token: i3.UserProfileService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: ToDistancePipe, isStandalone: true, name: "toDistance" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ToDistancePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toDistance',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: ConversionService }, { type: DistanceDisplayService }, { type: i3.UserProfileService }] });

class CartesianPoint {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    clone() {
        return new CartesianPoint(this.x, this.y);
    }
}

const metersPerRadian = 6371008; // mean radius of the earth in meters
function getSquareSegmentDistance(coordinate, segmentStart, segmentEnd) {
    const [targetLng, targetLat] = coordinate;
    let [startLng, startLat] = segmentStart;
    const [endLng, endLat] = segmentEnd;
    let distanceLng = endLng - startLng;
    let distanceLat = endLat - startLat;
    if (distanceLng !== 0 || distanceLat !== 0) {
        const t = ((targetLng - startLng) * distanceLng + (targetLat - startLat) * distanceLat) /
            (distanceLng * distanceLng + distanceLat * distanceLat);
        if (t > 1) {
            startLng = endLng;
            startLat = endLat;
        }
        else if (t > 0) {
            startLng += distanceLng * t;
            startLat += distanceLat * t;
        }
    }
    distanceLng = targetLng - startLng;
    distanceLat = targetLat - startLat;
    return distanceLng * distanceLng + distanceLat * distanceLat;
}
/**
 * @description Converts earth radians to meters.
 * @param radians - Radians
 * @returns Distance in meters
 */
function radiansToMeters(radians) {
    return radians * metersPerRadian;
}
function distanceBetweenPointsInMeters(lat1, lng1, lat2, lng2) {
    const radians = GeoCoordinate.pointsToRadians(lat1, lng1, lat2, lng2);
    return radiansToMeters(radians);
}
/**
 * @param points
 * @param targetPosition
 * @description - Returns the nearest point to a target position in a collection of points.
 */
function findClosestPoint(points, targetPosition) {
    let ret = points[0];
    let closestDist = Infinity;
    const targetLng = targetPosition[0];
    const targetLat = targetPosition[1];
    points.forEach((point) => {
        const dist = GeoCoordinate.pointsToRadians(point[1], point[0], targetLat, targetLng);
        if (dist < closestDist) {
            closestDist = dist;
            ret = point;
        }
    });
    return ret;
}
function findIntersectedSegmentIndices(coordinates, coordinate) {
    if (coordinates.length < 2) {
        return [];
    }
    if (coordinates.length === 2) {
        return [0, 1];
    }
    const targetLng = coordinate[0];
    const targetLat = coordinate[1];
    let shortestOffset = Infinity;
    let result = [];
    for (let i = 0, len = coordinates.length; i < len - 1; i++) {
        const [lng1, lat1] = coordinates[i];
        const [lng2, lat2] = coordinates[i + 1];
        const targetIsBetweenSegmentLng = (targetLng < lng1 || targetLng < lng2) && (targetLng > lng1 || targetLng > lng2);
        const targetIsBetweenSegmentLat = (targetLat < lat1 || targetLat < lat2) && (targetLat > lat1 || targetLat > lat2);
        if (targetIsBetweenSegmentLng || targetIsBetweenSegmentLat) {
            const offset = getSquareSegmentDistance(coordinate, [lng1, lat1], [lng2, lat2]);
            if (offset < shortestOffset) {
                shortestOffset = offset;
                result = [i, i + 1];
            }
        }
    }
    return result;
}
function findClosestGeoCoordinate(points, targetPosition) {
    const pointsArray = points.map((x) => [x.longitude, x.latitude]);
    const targetPositionArray = [targetPosition.longitude, targetPosition.latitude];
    const closestPointNumArray = findClosestPoint(pointsArray, targetPositionArray);
    const index = pointsArray.indexOf(closestPointNumArray);
    return points[index];
}
function getCoordinateDistanceFromLineInDegrees(coordinate, segmentStart, segmentEnd) {
    return Math.sqrt(getSquareSegmentDistance(coordinate, segmentStart, segmentEnd));
}
function polylineStringToGeoCoordinates(polyline) {
    if (!polyline) {
        return [];
    }
    const coords = decode(polyline);
    if (coords.length === 0) {
        return [];
    }
    return coords.map((coord) => new GeoCoordinate(coord[1], coord[0]));
}
function findIndexToInsertPoint(points, newPoint) {
    if (points.length === 0) {
        return 0;
    }
    if (points.length < 3) {
        return 1;
    }
    const nearestPoint = findClosestPoint(points, newPoint);
    const firstIndex = points.indexOf(nearestPoint);
    if (firstIndex === 0) {
        return 1;
    }
    if (firstIndex === points.length - 1) {
        return points.length - 1;
    }
    const secondNearestPoint = findClosestPoint([points[firstIndex - 1], points[firstIndex + 1]], newPoint);
    return Math.max(firstIndex, points.indexOf(secondNearestPoint));
}
/**
 * @description Convert a latitude coordinate to a valid value if outside the valid range. This method assumes invalid values
 * are caused by crossing one of the poles, so 91 degrees becomes 89 degrees.
 * @param lat latitude in degrees
 */
function getBoundLat(lat) {
    const min = -90;
    const max = 90;
    const range = 180;
    if (lat >= min && lat <= max) {
        return lat;
    }
    const wrapCount = Math.abs(Math.trunc(lat / range));
    // if wrapCount is odd, reverse sign
    // eslint-disable-next-line no-bitwise
    const sign = wrapCount & 1 ? Math.sign(lat) * -1 : Math.sign(lat);
    const offSetLat = lat - min;
    const remain = Math.abs(offSetLat % range);
    return Math.abs(range - remain + min) * sign;
}
/**
 * @description Convert a longitude coordinate to a valid value if outside the valid range. This method assumes invalid values
 * are caused by crossing the international date line, so 181 degrees becomes -179 degrees.
 * @param lng longitude in degrees
 */
function getBoundLng(lng) {
    const min = -180;
    const max = 180;
    if (lng >= min && lng <= max) {
        return lng;
    }
    const range = max - min;
    const offSetLng = lng - min;
    return UtilService.modulo(offSetLng, range) + min;
}
function arePointsEquivalent(pointA, pointB, maxDelta) {
    if (maxDelta === undefined) {
        maxDelta = 1e-6;
    }
    const latDiff = pointA.latitude - pointB.latitude;
    const lngDiff = pointA.longitude - pointB.longitude;
    return Math.abs(latDiff) < maxDelta && Math.abs(lngDiff) < maxDelta;
}
function getCenterBetweenPoints(coordinates1, coordinates2) {
    return GeoCoordinate.getCenterBetweenPoints(coordinates1, coordinates2);
}
function pointsToRadians(lat1, lng1, lat2, lng2) {
    return GeoCoordinate.pointsToRadians(lat1, lng1, lat2, lng2);
}
// remove once GeoService references have been replaced with individual function imports
/** @deprecated - import individual functions instead */
//eslint-disable-next-line @typescript-eslint/no-extraneous-class
class GeoService {
    static distanceBetweenPointsInMeters(lat1, lng1, lat2, lng2) {
        return distanceBetweenPointsInMeters(lat1, lng1, lat2, lng2);
    }
    static findClosestPoint(points, targetPosition) {
        return findClosestPoint(points, targetPosition);
    }
    static findIntersectedSegmentIndices(coordinates, coordinate) {
        return findIntersectedSegmentIndices(coordinates, coordinate);
    }
    static findClosestGeoCoordinate(points, targetPosition) {
        return findClosestGeoCoordinate(points, targetPosition);
    }
    static getCoordinateDistanceFromLineInDegrees(coordinate, segmentStart, segmentEnd) {
        return getCoordinateDistanceFromLineInDegrees(coordinate, segmentStart, segmentEnd);
    }
    static polylineStringToGeoCoordinates(polyline) {
        return polylineStringToGeoCoordinates(polyline);
    }
    static radiansToMeters(radians) {
        return radiansToMeters(radians);
    }
    static findIndexToInsertPoint(points, newPoint) {
        return findIndexToInsertPoint(points, newPoint);
    }
    static getBoundLat(lat) {
        return getBoundLat(lat);
    }
    static getBoundLng(lng) {
        return getBoundLng(lng);
    }
    static arePointsEquivalent(pointA, pointB, maxDelta) {
        return arePointsEquivalent(pointA, pointB, maxDelta);
    }
    static getCenterBetweenPoints(coordinates1, coordinates2) {
        return getCenterBetweenPoints(coordinates1, coordinates2);
    }
    static pointsToRadians(lat1, lng1, lat2, lng2) {
        return pointsToRadians(lat1, lng1, lat2, lng2);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeoService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeoService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class GeoCoordinate {
    constructor(longitude = 0, latitude = 0) {
        if (typeof longitude === 'number' && typeof latitude === 'number') {
            this.longitude = longitude;
            this.latitude = latitude;
        }
        else {
            throw new Error('Longitude and latitude must be numbers');
        }
    }
    get isNullLocation() {
        return this.longitude === 0 && this.latitude === 0;
    }
    /**
     * @description - GeoCoordinate is is within +/-90 degrees latitude and
     * +/-180 degrees latitude
     */
    get isValid() {
        return GeoCoordinate.isValidLatitude(this.latitude) && GeoCoordinate.isValidLongitude(this.longitude);
    }
    get lng() {
        return this.longitude;
    }
    get lat() {
        return this.latitude;
    }
    /**
     * Validates that the latitude provided is in the correct range
     * @param latitude - Latitude
     * @returns If latitude is valid
     */
    static isValidLatitude(latitude) {
        return typeof latitude === 'number' && latitude >= -90 && latitude <= 90;
    }
    /**
     * @description Validates that the longitude provided is in the correct range
     * @param longitude - Longitude
     * @returns If longitude is valid
     */
    static isValidLongitude(longitude) {
        return typeof longitude === 'number' && longitude >= -180 && longitude <= 180;
    }
    /**
     * @description Finds the distance between two points in radians
     * @param lat1 - Latitude 1
     * @param lng1 - Longitude 1
     * @param lat2 - Latitude 2
     * @param lng2 - Longitude 2
     * @returns Distance in Radians
     */
    static pointsToRadians(lat1, lng1, lat2, lng2) {
        // convert coordinates to radians
        lat1 = ConversionService.degreesToRadians(lat1);
        lng1 = ConversionService.degreesToRadians(lng1);
        lat2 = ConversionService.degreesToRadians(lat2);
        lng2 = ConversionService.degreesToRadians(lng2);
        // find the differences between the coordinates
        const diffLat = lat2 - lat1;
        const diffLng = lng2 - lng1;
        // here's the heavy lifting
        const dist = Math.pow(Math.sin(diffLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(diffLng / 2), 2);
        // great circle distance in radians
        return 2 * Math.atan2(Math.sqrt(dist), Math.sqrt(1 - dist));
    }
    /**
     * @description Returns distance between two geographic coordinates in meters
     * @param pointA - Point A
     * @param pointB - Point B
     * @returns Distance in meters
     */
    static pointDistanceInMeters(pointA, pointB) {
        const distanceInRadians = this.pointsToRadians(pointA.latitude, pointA.longitude, pointB.latitude, pointB.longitude);
        const distanceInMeters = radiansToMeters(distanceInRadians);
        return distanceInMeters;
    }
    /**
     * @description Get center between two points
     * @param coordinates1 - Coordinates 1
     * @param coordinates2 - Coordinates 2
     * @returns Array
     */
    static getCenterBetweenPoints(coordinates1, coordinates2) {
        return [(coordinates1[0] + coordinates2[0]) / 2, (coordinates1[1] + coordinates2[1]) / 2];
    }
    static fromLongitudeAndLatitude(longitude, latitude) {
        return new GeoCoordinate(longitude, latitude);
    }
    static fromCoordinateArray(coordinates = []) {
        return new GeoCoordinate(coordinates[0], coordinates[1]);
    }
    static fromMapboxLngLat(lngLat) {
        return new GeoCoordinate(lngLat.lng, lngLat.lat);
    }
    /**
     * @description Get geoCoordinate represented by x and y coordinates on a 0,0 (upper left) to 1,1 (lower right)
     * Mercator grid.
     * @param x X coordinate
     * @param y Y coordinate
     */
    static fromNormalizedPoint(x, y) {
        // To get the Mercator coordinates, shift and expand to range [-1, 1], then scale
        const mercatorX = x * 2.0 - 1.0;
        const lng = mercatorX * 180;
        // To get the Mercator coordinates, shift and expand to range [-1, 1], and flip the y axis
        const mercatorY = 1.0 - y * 2.0;
        // Convert the Mercator coordinate to latitude
        const lat = (Math.atan(Math.sinh(mercatorY * Math.PI)) * 180) / Math.PI;
        // Return new position.
        return new GeoCoordinate(lng, lat);
    }
    // Temporary method for ease of Typescript conversion
    static convert(lngOrLngLat, lat) {
        if (typeof lngOrLngLat === 'number' && typeof lat === 'number') {
            return this.fromLongitudeAndLatitude(lngOrLngLat, lat);
        }
        else if (Array.isArray(lngOrLngLat)) {
            return this.fromCoordinateArray(lngOrLngLat);
        }
        else if (typeof lngOrLngLat.lng === 'number' && typeof lngOrLngLat.lat === 'number') {
            return this.fromMapboxLngLat(lngOrLngLat);
        }
        else {
            return new GeoCoordinate();
        }
    }
    /**
     * Parses a string representing long lat values to a Geocoordinate.
     * Handles decimal values as well as degree/minute/seconds values
     * e.g.
     *   40°26'46.302"N, 40°26'46.302"W
     *   45°00'40.0"N 93°06'52.2"W
     *   40.999, -40.3423
     * @param value
     */
    static fromLngLatString(value) {
        // run query through regex, if match
        // attempt to pull 2 decimals out, if successful then if within bounds consider query a geocoordinate, if fail
        // attempt to parse degrees to decimal, if successful then consider query a geocoordinate, if fail default to existing search
        //pull optionally comma separated values from query
        const coords = value.split(/[\s,]+\s*/);
        // exit early if not two values
        if (coords.length !== 2) {
            return null;
        }
        // try to parse two decimals
        const latAsFloat = Number(coords[0]);
        const lngAsFloat = Number(coords[1]);
        if (!isNaN(latAsFloat) && !isNaN(lngAsFloat)) {
            if (Math.abs(latAsFloat) <= 90 && Math.abs(lngAsFloat) <= 180) {
                return new GeoCoordinate(parseFloat(lngAsFloat.toFixed(6)), parseFloat(latAsFloat.toFixed(6)));
            }
            else {
                return null;
            }
        }
        // try to parse two deg/min/sec values into decimal
        const [latFromDms, lngFromDms] = coords.map((coord) => GeoCoordinate.degreesMinutesSecondsToDecimal(coord));
        if (!isNaN(latFromDms) || !isNaN(lngFromDms))
            return new GeoCoordinate(lngFromDms, latFromDms);
        return null;
    }
    static degreesMinutesSecondsToDecimal(value) {
        const dmsRe = /^(-?\d+(?:\.\d+)?)[°:d]?\s?(?:(\d+(?:\.\d+)?)['′ʹ:]?\s?(?:(\d+(?:\.\d+)?)["″ʺ]?)?)?\s?([NSEW])?/i;
        let output = NaN;
        const dmsMatch = dmsRe.exec(value);
        if (dmsMatch) {
            const degrees = Number(dmsMatch[1]);
            const minutes = typeof dmsMatch[2] !== 'undefined' ? Number(dmsMatch[2]) / 60 : 0;
            const seconds = typeof dmsMatch[3] !== 'undefined' ? Number(dmsMatch[3]) / 3600 : 0;
            const hemisphere = dmsMatch[4] || null;
            if (hemisphere !== null && /[SW]/i.test(hemisphere)) {
                output = -Math.abs(degrees) - minutes - seconds;
            }
            else {
                output = degrees + minutes + seconds;
            }
        }
        return parseFloat(output.toFixed(6));
    }
    clone() {
        return new GeoCoordinate(this.lng, this.lat);
    }
    toCoordinateArray() {
        return [this.longitude, this.latitude];
    }
    /**
     * @description Returns geoCoordinate represented as X,Y on a 0,0 (upper left) to 1,1 (lower right) Mercator grid.
     */
    toNormalizedPoint() {
        // http://en.wikipedia.org/wiki/Mercator_projection
        // Get Mercator (x,y) normalized to the interval [-1, 1] (divide by pi)
        // Since Mercator x is converted to radians (multiply by pi/180) and then normalized (multiply by 1/pi),
        // this reduces to division by 180
        const mercatorX = this.lng / 180;
        const sinLatitude = Math.sin((this.lat * Math.PI) / 180);
        const mercatorY = (0.5 * Math.log((1 + sinLatitude) / (1 - sinLatitude))) / Math.PI;
        // Shift and shrink to range [0, 1] and flip the Y axis
        return new CartesianPoint((1 + mercatorX) / 2, (1 - mercatorY) / 2);
    }
    toGeoJsonGeometryPoint() {
        return {
            coordinates: this.toCoordinateArray(),
            type: 'Point',
        };
    }
    distanceFrom(pointB) {
        return GeoCoordinate.pointDistanceInMeters(this, pointB);
    }
    distanceFromRadians(pointB) {
        return GeoCoordinate.pointsToRadians(this.lat, this.lng, pointB.lat, pointB.lng);
    }
    centerBetween(pointB) {
        return GeoCoordinate.fromCoordinateArray(GeoCoordinate.getCenterBetweenPoints(this.toCoordinateArray(), pointB.toCoordinateArray()));
    }
    toString() {
        return `${this.lat}, ${this.lng}`;
    }
    toShortString(places = 4) {
        return `${this.lat.toFixed(places)}, ${this.lng.toFixed(places)}`;
    }
    toShortLocaleString(places = 4, locale) {
        return `${this.toShortLocaleLat(places, locale)}, ${this.toShortLocaleLng(places, locale)}`;
    }
    toShortLocaleLat(places = 4, locale) {
        return formatNumber(Number(this.lat.toFixed(places)), locale, `1.${places}-${places}`);
    }
    toShortLocaleLng(places = 4, locale) {
        return formatNumber(Number(this.lng.toFixed(places)), locale, `1.${places}-${places}`);
    }
    toDmsString() {
        return `${this.toDms(this.lat)}, ${this.toDms(this.lng, false)}`;
    }
    toDms(decimal, isLat = true) {
        if (!isFinite(decimal)) {
            throw new Error('Invalid decimal degree value');
        }
        const degrees = Math.floor(Math.abs(decimal));
        const minutesFloat = (Math.abs(decimal) - degrees) * 60;
        const minutes = Math.floor(minutesFloat);
        const seconds = (minutesFloat - minutes) * 60;
        const direction = decimal >= 0 ? (isLat ? 'N' : 'E') : isLat ? 'S' : 'W';
        return `${degrees}°${minutes}'${seconds.toFixed(2)}"${direction}`;
    }
}

class LocaleNumberCoordinateFormatPipe {
    constructor(configService) {
        this.configService = configService;
    }
    // create function that would replace "34,0522, -118,2437" to "34.0522, -118.2437", "34, -118,2437" to "34, -118.2437", "34,123, -118" to "34.123, -118", "34, -118" to "34, -118"
    transform(value) {
        if (!value)
            return '';
        const coordinateRegex = /^-?\d+([.,]\d+)?(, -?\d+([.,]\d+)?){1,2}$/;
        const locale = this.configService.cultureCode;
        if (typeof value === 'string' && coordinateRegex.test(value)) {
            const checkedValue = value.replace(/(\d+),(\d+)/g, '$1.$2');
            const [lat, lon] = checkedValue.split(',').map((coord) => coord.trim());
            const latitudeDecimalLength = lat.toString().split('.')[1]?.length || 0;
            const longitudeDecimalLength = lon.toString().split('.')[1]?.length || 0;
            const latitude = new Intl.NumberFormat(locale, { minimumFractionDigits: latitudeDecimalLength })
                .format(Number(lat))
                .replace(/\u00A0/g, ' ');
            const longitude = new Intl.NumberFormat(locale, { minimumFractionDigits: longitudeDecimalLength })
                .format(Number(lon))
                .replace(/\u00A0/g, ' ');
            return `${latitude}, ${longitude}`;
        }
        else if (value instanceof GeoCoordinate) {
            const latitudeDecimalLength = value.latitude.toString().split('.')[1]?.length || 0;
            const longitudeDecimalLength = value.longitude.toString().split('.')[1]?.length || 0;
            const latitude = new Intl.NumberFormat(locale, { minimumFractionDigits: latitudeDecimalLength })
                .format(value.latitude)
                .replace(/\u00A0/g, ' ');
            const longitude = new Intl.NumberFormat(locale, { minimumFractionDigits: longitudeDecimalLength })
                .format(value.longitude)
                .replace(/\u00A0/g, ' ');
            return `${latitude}, ${longitude}`;
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LocaleNumberCoordinateFormatPipe, deps: [{ token: i1$1.ConfigService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: LocaleNumberCoordinateFormatPipe, isStandalone: true, name: "localeNumberCoordinateFormat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LocaleNumberCoordinateFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'localeNumberCoordinateFormat',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1$1.ConfigService }] });

// created a custom pipe to handle number-string values with texts and symbols, e.g., "75 Codes" or "75°".
class LocaleNumberFormatPipe {
    constructor(configService) {
        this.configService = configService;
    }
    // create function that would replace "34,0522, -118,2437" to "34.0522, -118.2437", "34, -118,2437" to "34, -118.2437", "34,123, -118" to "34.123, -118", "34, -118" to "34, -118"
    transform(value) {
        const locale = this.configService.cultureCode;
        if (!value)
            return '';
        if (typeof value === 'string' && !/\d/.test(value))
            return value;
        const unit = value.toString().replace(/.*\d+(\.\d+)?/, '');
        const valueString = value.toString().replace(/[^\d.-]/g, '');
        const decimalLength = valueString.split('.')[1]?.length || 0;
        return (new Intl.NumberFormat(locale, { minimumFractionDigits: decimalLength })
            .format(Number(valueString))
            .replace(/\u00A0/g, ' ') + unit);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LocaleNumberFormatPipe, deps: [{ token: i1$1.ConfigService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: LocaleNumberFormatPipe, isStandalone: true, name: "localeNumberFormat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LocaleNumberFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'localeNumberFormat',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1$1.ConfigService }] });

class TimeDisplayService {
    constructor(locale, datePipe) {
        this.locale = locale;
        this.datePipe = datePipe;
    }
    getHoursMinutes(minutes) {
        if (!isFinite$1(minutes)) {
            return new FormattedValue();
        }
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = Math.floor(minutes % 60);
        const units = hours ? ['hr', 'min'] : 'min';
        const value = hours ? [String(hours), String(remainingMinutes)] : String(remainingMinutes);
        return new FormattedValue({
            units,
            value,
        });
    }
    getUpdateTime(time, justNowThresholdInSeconds = 0) {
        // All our supported browsers include Intl, return empty string for
        // unsupported browsers.
        if (typeof Intl === 'undefined') {
            return '';
        }
        const timeMs = typeof time === 'number' ? time : time.getTime();
        const deltaSeconds = Math.round((timeMs - Date.now()) / 1000);
        if (Math.abs(deltaSeconds) <= justNowThresholdInSeconds) {
            return $localize `Just now`;
        }
        const cutoffs = [
            60,
            3600,
            86400,
            604800, // 86400 * 7,
            2592000, // 86400 * 30,
            31556952, // 86400 * 365.2425,
            Infinity,
        ];
        const units = ['second', 'minute', 'hour', 'day', 'week', 'month', 'year'];
        const unitIndex = cutoffs.findIndex((cutoff) => cutoff > Math.abs(deltaSeconds));
        const divisor = unitIndex ? cutoffs[unitIndex - 1] : 1;
        const relativeTime = new Intl.RelativeTimeFormat(this.locale, {
            numeric: 'auto',
        });
        const formatted = relativeTime.format(Math.round(deltaSeconds / divisor), units[unitIndex]);
        return formatted[0].toUpperCase() + formatted.slice(1);
    }
    getPreciseUpdateTime(timeStamp, displayTimezone = true) {
        const _MS_PER_DAY = 86400000;
        const dateTime = new Date(timeStamp);
        const dateToday = new Date();
        const dateTimeUTC = Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
        const dateTodayUTC = Date.UTC(dateToday.getFullYear(), dateToday.getMonth(), dateToday.getDate());
        const diffDays = Math.floor((dateTodayUTC - dateTimeUTC) / _MS_PER_DAY);
        const browserTimeZone = findTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
        const { zone } = getZonedTime(new Date(timeStamp), browserTimeZone);
        let updatedTime;
        if (diffDays === 0) {
            updatedTime = $localize `at ${this.datePipe.transform(dateTime, 'h:mm')} ${this.datePipe
                .transform(dateTime, 'a')
                ?.toLowerCase()} ${displayTimezone ? zone?.abbreviation : ''}`;
        }
        else if (diffDays === 1) {
            updatedTime = $localize `yesterday at ${this.datePipe.transform(dateTime, 'h:mm')} ${this.datePipe
                .transform(dateTime, 'a')
                ?.toLowerCase()} ${displayTimezone ? zone?.abbreviation : ''}`;
        }
        else if (diffDays > 1 && diffDays < 7) {
            updatedTime = $localize `${this.datePipe.transform(dateTime, 'EEEE', this.locale)} at ${this.datePipe.transform(dateTime, 'h:mm')} ${this.datePipe.transform(dateTime, 'a')?.toLowerCase()} ${displayTimezone ? zone?.abbreviation : ''}`;
        }
        else {
            updatedTime = $localize `${this.datePipe.transform(dateTime, 'shortDate')} at ${this.datePipe.transform(dateTime, 'h:mm')} ${this.datePipe.transform(dateTime, 'a')?.toLowerCase()} ${displayTimezone ? zone?.abbreviation : ''}`;
        }
        return updatedTime;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TimeDisplayService, deps: [{ token: LOCALE_ID }, { token: i1.DatePipe }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TimeDisplayService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TimeDisplayService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }, { type: i1.DatePipe }] });

class UpdateTimePipe {
    constructor(timeDisplayService) {
        this.timeDisplayService = timeDisplayService;
    }
    transform(value, justNowThresholdInSeconds = 0) {
        return this.timeDisplayService.getUpdateTime(value, justNowThresholdInSeconds);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UpdateTimePipe, deps: [{ token: TimeDisplayService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: UpdateTimePipe, isStandalone: true, name: "updateTime" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UpdateTimePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'updateTime',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: TimeDisplayService }] });

class RideTypeService {
    constructor(userStoreService) {
        this.userStoreService = userStoreService;
        this.rideTypeChangedSubject = new Subject();
        this.rideTypeSignal = signal('None');
        this.$rideType = this.rideTypeSignal.asReadonly();
        this.$isSnoRideType = computed(() => this.$rideType() === 'SNO');
        this.rideTypeChanged$ = new Subject();
        this.rideTypeChanged$ = this.rideTypeChangedSubject.asObservable();
    }
    setRideType(rideType) {
        this.userStoreService.set('currentRideType', rideType);
        this.rideTypeSignal.set(rideType);
        this.rideTypeChangedSubject.next();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RideTypeService, deps: [{ token: i1$2.UserStoreService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RideTypeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RideTypeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.UserStoreService }] });

class UuidService {
    static { this.empty = '00000000-0000-0000-0000-000000000000'; }
    static generate() {
        return v4();
    }
    generate() {
        return UuidService.generate();
    }
    isEmpty(uuid) {
        if (!uuid) {
            return true;
        }
        if (uuid.trim() === '') {
            return true;
        }
        return uuid === UuidService.empty;
    }
    isUuid(uuid) {
        const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return pattern.test(uuid);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UuidService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UuidService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UuidService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ConditionService {
    constructor(rideTypeService) {
        this.rideTypeService = rideTypeService;
    }
    getConditionsForTrail() {
        const conditions = this.getMockConditions().map((contract) => new Condition(contract));
        return orderBy(conditions, 'reportedTime', 'desc');
    }
    getConditionsForPublicWaypoint() {
        const conditions = this.getMockConditions().map((contract) => new Condition(contract));
        return orderBy(conditions, 'reportedTime', 'desc');
    }
    getMockConditions() {
        const now = new Date();
        const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
        if (this.rideTypeService.$rideType() === 'ORV') {
            const properties = { reportedTime: yesterday.toString(), rideType: 'ORV' };
            return [
                { ...properties, id: UuidService.generate(), type: 'Closed' },
                { ...properties, id: UuidService.generate(), type: 'Dry' },
                { ...properties, id: UuidService.generate(), type: 'Dusty' },
                { ...properties, id: UuidService.generate(), type: 'FallenTree' },
                { ...properties, id: UuidService.generate(), type: 'Flooded' },
                { ...properties, id: UuidService.generate(), type: 'Good' },
                { ...properties, id: UuidService.generate(), type: 'Hazard' },
                { ...properties, id: UuidService.generate(), type: 'Mud' },
                { ...properties, id: UuidService.generate(), type: 'OK' },
                { ...properties, id: UuidService.generate(), type: 'OK' },
                { ...properties, id: UuidService.generate(), type: 'OK' },
                { ...properties, id: UuidService.generate(), type: 'Poor' },
                { ...properties, id: UuidService.generate(), type: 'Rocks' },
                {
                    ...properties,
                    description: "There's a bypass on the right, but watch out for water!",
                    id: UuidService.generate(),
                    reportedByRiderId: '1234',
                    reportedTime: now.toString(),
                    type: 'Washout',
                },
            ];
        }
        else {
            const properties = { reportedTime: yesterday.toString(), rideType: 'SNO' };
            return [
                { ...properties, id: UuidService.generate(), type: 'Closed' },
                { ...properties, id: UuidService.generate(), type: 'FallenTree' },
                { ...properties, id: UuidService.generate(), type: 'Good' },
                { ...properties, id: UuidService.generate(), type: 'Hazard' },
                { ...properties, id: UuidService.generate(), type: 'Hole' },
                { ...properties, id: UuidService.generate(), type: 'Hole' },
                { ...properties, id: UuidService.generate(), type: 'Hole' },
                { ...properties, id: UuidService.generate(), type: 'OK' },
                { ...properties, id: UuidService.generate(), type: 'OpenWater' },
                { ...properties, id: UuidService.generate(), type: 'Poor' },
                {
                    ...properties,
                    description: "There's a bypass on the right, but watch out for water!",
                    id: UuidService.generate(),
                    reportedTime: now.toString(),
                    type: 'Rocky',
                },
            ];
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConditionService, deps: [{ token: RideTypeService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConditionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConditionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RideTypeService }] });

class ConditionDetailComponent {
    constructor(conditionService, userProfileService) {
        this.$trailId = input('');
        this.$publicWaypointId = input('');
        this.$conditions = input([]);
        this.back = output();
        this.close = output();
        this.confirm = output();
        this.remove = output();
        this.edit = output();
        const $riderId = toSignal(userProfileService.getUserRiderId$(), { initialValue: '' });
        this.$vm = computed(() => {
            const riderId = $riderId();
            const conditionsInput = this.$conditions();
            const trailId = this.$trailId();
            const waypointId = this.$publicWaypointId();
            const conditions = conditionsInput.length
                ? conditionsInput
                : trailId
                    ? conditionService.getConditionsForTrail() //trailId
                    : waypointId
                        ? conditionService.getConditionsForPublicWaypoint() // waypointId
                        : [];
            return {
                conditions: conditions.map((condition) => ({
                    description: condition.description,
                    icon: condition.icon,
                    id: condition.id,
                    isOwner: Boolean(condition.reportedByRiderId) && condition.reportedByRiderId === riderId,
                    reportedTime: condition.reportedTime,
                    type: condition.type,
                })),
            };
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConditionDetailComponent, deps: [{ token: ConditionService }, { token: i3.UserProfileService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: ConditionDetailComponent, isStandalone: true, selector: "pii-condition-detail", inputs: { $trailId: { classPropertyName: "$trailId", publicName: "$trailId", isSignal: true, isRequired: false, transformFunction: null }, $publicWaypointId: { classPropertyName: "$publicWaypointId", publicName: "$publicWaypointId", isSignal: true, isRequired: false, transformFunction: null }, $conditions: { classPropertyName: "$conditions", publicName: "$conditions", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { back: "back", close: "close", confirm: "confirm", remove: "remove", edit: "edit" }, ngImport: i0, template: "<div class=\"detail-container condition-detail-container\">\n  <div class=\"header-container\">\n    <h2>\n      @if ($trailId() || $publicWaypointId()) {\n        <a id=\"backConditions\" href=\"javascript:void(0);\" aria-label=\"back\" (click)=\"back.emit()\" i18n-aria-label>\n          <mat-icon svgIcon=\"pii:arrow\" />\n        </a>\n      }\n      @if ($trailId()) {\n        <span i18n>Trail Conditions</span>\n      } @else if ($publicWaypointId()) {\n        <span i18n>Waypoint Conditions</span>\n      } @else {\n        <span i18n>Conditions</span>\n      }\n    </h2>\n    <div class=\"helper-align-right\">\n      <a id=\"closeConditions\" href=\"javascript:void(0);\" aria-label=\"close\" (click)=\"close.emit()\" i18n-aria-label>\n        <mat-icon svgIcon=\"pii:close\" class=\"close-icon black\" />\n      </a>\n    </div>\n  </div>\n  <div class=\"content-container\">\n    @for (condition of $vm().conditions; track condition.id) {\n      <div class=\"condition\">\n        <div class=\"condition-header\">\n          <mat-icon [svgIcon]=\"condition.icon\" />\n          <div>{{ condition.type }}</div>\n          <div class=\"time gray\">{{ condition.reportedTime | updateTime: 10 }}</div>\n        </div>\n        <div class=\"gray\">{{ condition.description }}</div>\n        <div class=\"report-buttons\">\n          <pii-button\n            text=\"Still Here\"\n            [elementId]=\"'confirm'\"\n            [variant]=\"'secondary'\"\n            [fullWidth]=\"true\"\n            [iconName]=\"'checkmark'\"\n            [iconClass]=\"'primary'\"\n            (clicked)=\"confirm.emit(condition.id)\"\n            i18n-text\n          />\n          <pii-button\n            text=\"Remove\"\n            [elementId]=\"'remove'\"\n            [variant]=\"'secondary'\"\n            [fullWidth]=\"true\"\n            [iconName]=\"'close'\"\n            (clicked)=\"remove.emit(condition.id)\"\n            i18n-text\n          />\n        </div>\n        @if (condition.isOwner) {\n          <pii-button\n            text=\"Edit\"\n            [elementId]=\"'edit'\"\n            [variant]=\"'secondary'\"\n            [fullWidth]=\"true\"\n            [iconName]=\"'edit'\"\n            (clicked)=\"edit.emit(condition.id)\"\n            i18n-text\n          />\n        }\n      </div>\n    }\n  </div>\n  <div class=\"detail-footer\"></div>\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.detail-container{display:flex;flex-direction:column;height:100%;min-height:100%;overflow:hidden}.detail-container .header-container{align-items:center;background:#fff;border-bottom:1px solid #d8d8d8;display:grid;flex:0 0 auto;grid-template-columns:1fr auto;padding:16px}.detail-container .header-container h2{font-size:1.2rem;line-height:1.2rem;margin:0}.detail-container .content-container{background:#f5f6f7f0;display:flex;flex:1 1 auto;flex-direction:column;overflow:auto}.detail-container .footer-container{background:#fff;flex:0 0 auto}.condition-detail-container h2{align-items:center;display:flex;gap:8px}.condition-detail-container .content-container{background:#fff;box-sizing:border-box;display:flex;flex-direction:column}.condition-detail-container .content-container .condition{background-color:#fff;border-bottom:1px solid #d8d8d8;display:flex;flex-direction:column;gap:8px;padding:16px}.condition-detail-container .content-container .condition .condition-header{align-items:center;display:flex;flex-direction:row;gap:8px}.condition-detail-container .content-container .condition .condition-header div{flex-grow:1}.condition-detail-container .content-container .condition .condition-header .time{flex-grow:0}.condition-detail-container .content-container .condition .gray{color:gray}.condition-detail-container .content-container .condition .report-buttons{display:flex;gap:8px}.condition-detail-container .content-container .condition .report-buttons pii-button{flex-grow:1}\n"], dependencies: [{ kind: "component", type: MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: ButtonComponent, selector: "pii-button", inputs: ["align", "disabled", "elementId", "expanded", "fullWidth", "iconClass", "iconName", "maxWidth", "text", "textColor", "variant"], outputs: ["clicked"] }, { kind: "pipe", type: UpdateTimePipe, name: "updateTime" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConditionDetailComponent, decorators: [{
            type: Component,
            args: [{ imports: [MatIcon, ButtonComponent, UpdateTimePipe], selector: 'pii-condition-detail', standalone: true, template: "<div class=\"detail-container condition-detail-container\">\n  <div class=\"header-container\">\n    <h2>\n      @if ($trailId() || $publicWaypointId()) {\n        <a id=\"backConditions\" href=\"javascript:void(0);\" aria-label=\"back\" (click)=\"back.emit()\" i18n-aria-label>\n          <mat-icon svgIcon=\"pii:arrow\" />\n        </a>\n      }\n      @if ($trailId()) {\n        <span i18n>Trail Conditions</span>\n      } @else if ($publicWaypointId()) {\n        <span i18n>Waypoint Conditions</span>\n      } @else {\n        <span i18n>Conditions</span>\n      }\n    </h2>\n    <div class=\"helper-align-right\">\n      <a id=\"closeConditions\" href=\"javascript:void(0);\" aria-label=\"close\" (click)=\"close.emit()\" i18n-aria-label>\n        <mat-icon svgIcon=\"pii:close\" class=\"close-icon black\" />\n      </a>\n    </div>\n  </div>\n  <div class=\"content-container\">\n    @for (condition of $vm().conditions; track condition.id) {\n      <div class=\"condition\">\n        <div class=\"condition-header\">\n          <mat-icon [svgIcon]=\"condition.icon\" />\n          <div>{{ condition.type }}</div>\n          <div class=\"time gray\">{{ condition.reportedTime | updateTime: 10 }}</div>\n        </div>\n        <div class=\"gray\">{{ condition.description }}</div>\n        <div class=\"report-buttons\">\n          <pii-button\n            text=\"Still Here\"\n            [elementId]=\"'confirm'\"\n            [variant]=\"'secondary'\"\n            [fullWidth]=\"true\"\n            [iconName]=\"'checkmark'\"\n            [iconClass]=\"'primary'\"\n            (clicked)=\"confirm.emit(condition.id)\"\n            i18n-text\n          />\n          <pii-button\n            text=\"Remove\"\n            [elementId]=\"'remove'\"\n            [variant]=\"'secondary'\"\n            [fullWidth]=\"true\"\n            [iconName]=\"'close'\"\n            (clicked)=\"remove.emit(condition.id)\"\n            i18n-text\n          />\n        </div>\n        @if (condition.isOwner) {\n          <pii-button\n            text=\"Edit\"\n            [elementId]=\"'edit'\"\n            [variant]=\"'secondary'\"\n            [fullWidth]=\"true\"\n            [iconName]=\"'edit'\"\n            (clicked)=\"edit.emit(condition.id)\"\n            i18n-text\n          />\n        }\n      </div>\n    }\n  </div>\n  <div class=\"detail-footer\"></div>\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.detail-container{display:flex;flex-direction:column;height:100%;min-height:100%;overflow:hidden}.detail-container .header-container{align-items:center;background:#fff;border-bottom:1px solid #d8d8d8;display:grid;flex:0 0 auto;grid-template-columns:1fr auto;padding:16px}.detail-container .header-container h2{font-size:1.2rem;line-height:1.2rem;margin:0}.detail-container .content-container{background:#f5f6f7f0;display:flex;flex:1 1 auto;flex-direction:column;overflow:auto}.detail-container .footer-container{background:#fff;flex:0 0 auto}.condition-detail-container h2{align-items:center;display:flex;gap:8px}.condition-detail-container .content-container{background:#fff;box-sizing:border-box;display:flex;flex-direction:column}.condition-detail-container .content-container .condition{background-color:#fff;border-bottom:1px solid #d8d8d8;display:flex;flex-direction:column;gap:8px;padding:16px}.condition-detail-container .content-container .condition .condition-header{align-items:center;display:flex;flex-direction:row;gap:8px}.condition-detail-container .content-container .condition .condition-header div{flex-grow:1}.condition-detail-container .content-container .condition .condition-header .time{flex-grow:0}.condition-detail-container .content-container .condition .gray{color:gray}.condition-detail-container .content-container .condition .report-buttons{display:flex;gap:8px}.condition-detail-container .content-container .condition .report-buttons pii-button{flex-grow:1}\n"] }]
        }], ctorParameters: () => [{ type: ConditionService }, { type: i3.UserProfileService }] });

class ConditionWidgetComponent {
    constructor() {
        this.$conditions = input([]);
        this.clicked = output();
        this.$overflowCount = signal(0);
        this.gapWidth = 8;
        this.itemWidth = 90;
    }
    ngAfterViewInit() {
        this.resizeObserver = new ResizeObserver(() => {
            this.recalcVisibleItems();
        });
        this.resizeObserver.observe(this.containerRef.nativeElement);
    }
    ngOnDestroy() {
        this.resizeObserver?.disconnect();
    }
    recalcVisibleItems() {
        const fit = floor((this.containerRef.nativeElement.clientWidth + this.gapWidth) / (this.itemWidth + this.gapWidth));
        this.$overflowCount.set(fit > this.$conditions().length ? 0 : this.$conditions().length - fit);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConditionWidgetComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: ConditionWidgetComponent, isStandalone: true, selector: "pii-condition-widget", inputs: { $conditions: { classPropertyName: "$conditions", publicName: "$conditions", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { clicked: "clicked" }, viewQueries: [{ propertyName: "containerRef", first: true, predicate: ["conditionList"], descendants: true }], ngImport: i0, template: "@if ($conditions().length) {\n  <a class=\"condition-widget\" href=\"javascript:void(0);\" (click)=\"clicked.emit()\">\n    <div #conditionList class=\"condition-list\">\n      @for (condition of $conditions(); track condition.id) {\n        <div class=\"condition\">\n          <mat-icon [svgIcon]=\"condition.icon\" />\n          <div>{{ condition.typeName }}</div>\n          <div>{{ condition.reportedTime }}</div>\n        </div>\n      }\n    </div>\n    @if ($overflowCount()) {\n      <div class=\"overflow-count\">+ {{ $overflowCount() }}</div>\n    }\n    <div class=\"conditions-click\"><mat-icon svgIcon=\"pii:chevron\" /></div>\n  </a>\n}\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.condition-widget{align-content:center;color:#000;display:flex;height:50px;overflow:hidden}.condition-widget .condition-list{display:flex;flex-grow:1;flex-wrap:wrap;gap:8px}.condition-widget .condition-list .condition{align-items:center;display:flex;flex-direction:column;gap:8px;width:90px}.condition-widget .overflow-count{align-self:center;flex-shrink:0;width:45px}.condition-widget .conditions-click{align-content:center;display:flex;flex-grow:0;flex-wrap:wrap}.condition-widget .conditions-click mat-icon{height:16px;width:16px}\n"], dependencies: [{ kind: "component", type: MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConditionWidgetComponent, decorators: [{
            type: Component,
            args: [{ imports: [MatIcon], selector: 'pii-condition-widget', standalone: true, template: "@if ($conditions().length) {\n  <a class=\"condition-widget\" href=\"javascript:void(0);\" (click)=\"clicked.emit()\">\n    <div #conditionList class=\"condition-list\">\n      @for (condition of $conditions(); track condition.id) {\n        <div class=\"condition\">\n          <mat-icon [svgIcon]=\"condition.icon\" />\n          <div>{{ condition.typeName }}</div>\n          <div>{{ condition.reportedTime }}</div>\n        </div>\n      }\n    </div>\n    @if ($overflowCount()) {\n      <div class=\"overflow-count\">+ {{ $overflowCount() }}</div>\n    }\n    <div class=\"conditions-click\"><mat-icon svgIcon=\"pii:chevron\" /></div>\n  </a>\n}\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.condition-widget{align-content:center;color:#000;display:flex;height:50px;overflow:hidden}.condition-widget .condition-list{display:flex;flex-grow:1;flex-wrap:wrap;gap:8px}.condition-widget .condition-list .condition{align-items:center;display:flex;flex-direction:column;gap:8px;width:90px}.condition-widget .overflow-count{align-self:center;flex-shrink:0;width:45px}.condition-widget .conditions-click{align-content:center;display:flex;flex-grow:0;flex-wrap:wrap}.condition-widget .conditions-click mat-icon{height:16px;width:16px}\n"] }]
        }], propDecorators: { containerRef: [{
                type: ViewChild,
                args: ['conditionList']
            }] } });

class ConfirmDialogOptions {
    constructor(options = {}) {
        this.dialogId = options.dialogId ?? '';
        this.hideCancelButton = options.hideCancelButton ?? false;
        this.showCloseButton = options.showCloseButton ?? false;
        this.titleText = options.titleText ?? '';
        this.contentText = options.contentText ?? '';
        this.cancelText = typeof options.cancelText === 'string' ? options.cancelText : $localize `Cancel`;
        this.confirmText = typeof options.confirmText === 'string' ? options.confirmText : $localize `OK`;
        this.closeButtonId = options.closeButtonId ?? 'close';
        this.cancelButtonId = options.cancelButtonId ?? 'cancel';
        this.confirmButtonId = options.confirmButtonId ?? 'confirm';
        this.cancelAriaLabel = typeof options.cancelAriaLabel === 'string' ? options.cancelAriaLabel : $localize `cancel`;
        this.confirmAriaLabel =
            typeof options.confirmAriaLabel === 'string' ? options.confirmAriaLabel : $localize `confirm`;
        this.hideAppStoreButtons = options.hideAppStoreButtons ?? true;
        this.appStoreUrl = options.appStoreUrl ?? '';
        this.playStoreUrl = options.playStoreUrl ?? '';
        this.maxWidth = options.maxWidth ?? false;
        this.fullWidth = options.fullWidth ?? true;
    }
}

class RoutingHelpersService {
    static { this.culturePrefixRegex = /^\/(\w{2}(-\w{2})?)\//; }
    constructor(config, document, router, window) {
        this.config = config;
        this.router = router;
        this.window = window;
        this.className = 'RoutingHelpersService';
        this.schemeUrlRegex = /^\w+:\/\/$/;
        this.absoluteUrlRegex = /^\w+:\/\//;
        this.remoteUrlRegex = /^[a-z]+:\/\//;
        this.siteUrlSansCulture = siteUrlFactory(document);
        const codes = Object.keys(supportedCultures);
        this.urlPartsRegex = new RegExp(`((https?:\\/{2})?[^/]+\\.[^/]+|https?:\\/{2}localhost:\\d+)?(\\/(${codes.join('|')}))?(.*)`);
    }
    cleanResourceUrl(src) {
        if (src.startsWith('data:')) {
            return src;
        }
        let source = src;
        // Add protocol if missing but continue processing after.
        if (source.startsWith('//')) {
            source = `${this.window.location.protocol}${source}`;
        }
        // Convert internal resource absolute URL to relative.
        source = source.replace(this.siteUrlSansCulture, '');
        // Convert riderx-pidd S3 urls to relative.
        source = source.replace(/(https:\/\/)?riderx-pidd\.s3\.amazonaws\.com/, '/assets/images/display-regions');
        // Lowercase IVI in riderx-pidd URLs.
        source = source.replace('polarisIVI', 'polarisivi');
        if (this.remoteUrlRegex.test(source)) {
            // This is an external resource, apply replacements.
            source = source.replace('riderx-images-prod.s3.amazonaws.com', 'rdc-images.polaris.com');
        }
        else {
            // This is an internal resource, apply public path.
            source = this.getPathForInternalResource(source);
        }
        return source;
    }
    /**
     * @param {...any} urlParts
     * @description - Joins path parts, ensuring a single forward slash between them.
     * Adds leading slash to relative URLs if missing, does not remove trailing slash.
     */
    combineUrl(...urlParts) {
        let [base] = urlParts;
        const [, ...otherParts] = urlParts;
        if (this.schemeUrlRegex.test(base)) {
            base = base + (otherParts.shift() || '');
        }
        if (this.absoluteUrlRegex.test(base)) {
            const [, domain = '', , , culture = '', urlPath = ''] = base.match(this.urlPartsRegex) || [];
            const pathString = this.join(culture, urlPath, ...otherParts);
            let result;
            try {
                result = new URL(pathString, domain).toString();
            }
            catch (error) {
                result = pathString;
            }
            return result;
        }
        return this.join('/', base, ...otherParts);
    }
    getRouteChildParam(activatedRoute, paramName) {
        if (!paramName) {
            return '';
        }
        let result;
        let currentRoute = activatedRoute;
        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
            result = currentRoute.snapshot.paramMap.get(paramName);
            if (result) {
                return result;
            }
        }
        return '';
    }
    getAllRouteParams() {
        let params = {};
        const stack = [this.router.routerState.snapshot.root];
        while (stack.length > 0) {
            const route = stack.pop();
            params = { ...params, ...route?.params };
            if (route?.children)
                stack.push(...route.children);
        }
        return params;
    }
    getRouteChildParamMap$(activatedRoute) {
        return this.router.events.pipe(filter((event) => event instanceof NavigationEnd), startWith(activatedRoute.paramMap), switchMap(() => {
            let lastChild = activatedRoute.firstChild;
            while (lastChild?.firstChild) {
                lastChild = lastChild.firstChild;
            }
            if (!lastChild?.paramMap) {
                throw new Error('Found route child is missing ParamMap');
            }
            return lastChild.paramMap;
        }));
    }
    /**
     * @description - Takes a URL string and returns a URL with the active
     * culture code included. If the passed URL includes another culture code,
     * it will be replaced.
     * @param url - Relative URL string that may or may not include a culture code.
     */
    getUrlWithCulture(url) {
        if (typeof url !== 'string' || url.length === 0) {
            return url;
        }
        // pull just the domain (if any) and url path without culture from url
        const [, domain = '', , , , urlPath = ''] = url.match(this.urlPartsRegex) ?? [];
        return this.combineUrl(domain, this.config.cultureCode.toLowerCase(), urlPath);
    }
    getPathForInternalResource(url) {
        const baseHref = this.config.assetCdnUrl;
        return this.combineUrl(baseHref, url);
    }
    join(...parts) {
        const filtered = parts.filter(Boolean);
        const path = filtered.join('/').replace(/\/+/g, '/');
        // Check if the last part had a trailing slash
        const hasTrailingSlash = filtered[filtered.length - 1]?.endsWith('/');
        let result = path;
        // Remove trailing slash unless it was explicitly present in the last part
        if (!hasTrailingSlash) {
            result = result.replace(/\/$/, '');
        }
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RoutingHelpersService, deps: [{ token: i1$1.ConfigService }, { token: DOCUMENT }, { token: i2.Router }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RoutingHelpersService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: RoutingHelpersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$1.ConfigService }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i2.Router }, { type: Window, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }] });

/* eslint-disable @angular-eslint/directive-selector */
class ImageCdnSrcDirective {
    constructor(el, renderer, routingHelpersService) {
        this.el = el;
        this.renderer = renderer;
        this.routingHelpersService = routingHelpersService;
    }
    ngOnChanges() {
        let source = this.src || this.ngSrc;
        if (!source) {
            source = this.el.nativeElement.src;
        }
        if (!source) {
            return;
        }
        // Src was set with SafeResourceUrl, set element src.
        // This is necessary because the existence of this directive broke the SafeResourceUrl functionality.
        if (typeof source !== 'string') {
            if (has(source, 'changingThisBreaksApplicationSecurity')) {
                source = this.routingHelpersService.cleanResourceUrl(get(source, 'changingThisBreaksApplicationSecurity', ''));
            }
        }
        else {
            source = this.routingHelpersService.cleanResourceUrl(source);
        }
        this.renderer.setProperty(this.el.nativeElement, 'src', source);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ImageCdnSrcDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: RoutingHelpersService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.9", type: ImageCdnSrcDirective, isStandalone: true, selector: "img[src], img[ngSrc]", inputs: { src: "src", ngSrc: "ngSrc" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ImageCdnSrcDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'img[src], img[ngSrc]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: RoutingHelpersService }], propDecorators: { src: [{
                type: Input
            }], ngSrc: [{
                type: Input
            }] } });

class ConfirmDialogComponent {
    constructor(config, data, dialogRef) {
        this.config = config;
        this.data = data;
        this.dialogRef = dialogRef;
        this.appStoreUrl = '';
        this.playStoreUrl = '';
        this.options = data;
        this.appStoreUrl = data.appStoreUrl || this.config.appStoreUrl.apple;
        this.playStoreUrl = data.playStoreUrl || this.config.appStoreUrl.google;
    }
    onConfirm() {
        this.dialogRef.close('confirm');
    }
    onCancel() {
        this.dialogRef.close('cancel');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConfirmDialogComponent, deps: [{ token: i1$1.ConfigService }, { token: MAT_DIALOG_DATA }, { token: MatDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: ConfirmDialogComponent, isStandalone: true, selector: "pii-confirmation-dialog", ngImport: i0, template: "<div class=\"mat-dialog-custom confirmation-dialog-container\" [id]=\"options.dialogId\">\n  @if (options.titleText) {\n    <div class=\"title-container\">\n      <h1 class=\"title\">{{ options.titleText }}</h1>\n      @if (options.showCloseButton) {\n        <div>\n          <a\n            href=\"javascript:void(0)\"\n            aria-label=\"close-icon\"\n            [id]=\"options.closeButtonId\"\n            [mat-dialog-close]=\"'cancel'\"\n            i18n-aria-label\n          >\n            <mat-icon svgIcon=\"pii:close\" class=\"black\" />\n          </a>\n        </div>\n      }\n    </div>\n  }\n  @if (options.contentText) {\n    <div class=\"body-container\">\n      <div [innerHTML]=\"options.contentText\"></div>\n      @if (!options.hideAppStoreButtons) {\n        <div class=\"store-buttons-container\">\n          <div class=\"app-store\">\n            <a id=\"appStore\" target=\"_blank\" [href]=\"appStoreUrl\">\n              <img alt=\"App Store\" width=\"145\" height=\"43\" ngSrc=\"/assets/images/apple-app-store.svg\" i18n-alt />\n            </a>\n          </div>\n          <div class=\"google-play\">\n            <a id=\"googlePlay\" target=\"_blank\" [href]=\"playStoreUrl\">\n              <img alt=\"Google Play\" width=\"145\" height=\"43\" ngSrc=\"/assets/images/google-play-store.svg\" i18n-alt />\n            </a>\n          </div>\n        </div>\n      }\n      <div class=\"buttons-container\">\n        <div class=\"left\">\n          <pii-button\n            [elementId]=\"options.confirmButtonId\"\n            [variant]=\"'primary'\"\n            [text]=\"options.confirmText\"\n            [fullWidth]=\"options.fullWidth\"\n            [maxWidth]=\"options.maxWidth\"\n            (clicked)=\"onConfirm()\"\n          />\n        </div>\n        @if (!options.hideCancelButton) {\n          <div class=\"right\">\n            <pii-button\n              [elementId]=\"options.cancelButtonId\"\n              [variant]=\"'secondary'\"\n              [text]=\"options.cancelText\"\n              [fullWidth]=\"true\"\n              (clicked)=\"onCancel()\"\n            />\n          </div>\n        }\n      </div>\n    </div>\n  }\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.confirmation-dialog-container .body-container{padding:20px}.confirmation-dialog-container .body-container .confirmation-dialog .store-buttons-container{align-items:center;display:grid;grid-gap:30px;grid-template-columns:1fr 1fr;padding:20px 0 0;text-align:center}#noBrowserLocationPermission{max-width:530px}#noBrowserLocationPermission .no-location-text{display:flex;flex-direction:column;gap:15px}#noBrowserLocationPermission .no-location-text p{font-size:1rem;line-height:1rem;margin:0}\n"], dependencies: [{ kind: "directive", type: ImageCdnSrcDirective, selector: "img[src], img[ngSrc]", inputs: ["src", "ngSrc"] }, { kind: "ngmodule", type: MatDialogModule }, { kind: "directive", type: i2$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "ngmodule", type: MatIconModule }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: ButtonComponent, selector: "pii-button", inputs: ["align", "disabled", "elementId", "expanded", "fullWidth", "iconClass", "iconName", "maxWidth", "text", "textColor", "variant"], outputs: ["clicked"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConfirmDialogComponent, decorators: [{
            type: Component,
            args: [{ imports: [ImageCdnSrcDirective, MatDialogModule, MatIconModule, ButtonComponent], selector: 'pii-confirmation-dialog', standalone: true, template: "<div class=\"mat-dialog-custom confirmation-dialog-container\" [id]=\"options.dialogId\">\n  @if (options.titleText) {\n    <div class=\"title-container\">\n      <h1 class=\"title\">{{ options.titleText }}</h1>\n      @if (options.showCloseButton) {\n        <div>\n          <a\n            href=\"javascript:void(0)\"\n            aria-label=\"close-icon\"\n            [id]=\"options.closeButtonId\"\n            [mat-dialog-close]=\"'cancel'\"\n            i18n-aria-label\n          >\n            <mat-icon svgIcon=\"pii:close\" class=\"black\" />\n          </a>\n        </div>\n      }\n    </div>\n  }\n  @if (options.contentText) {\n    <div class=\"body-container\">\n      <div [innerHTML]=\"options.contentText\"></div>\n      @if (!options.hideAppStoreButtons) {\n        <div class=\"store-buttons-container\">\n          <div class=\"app-store\">\n            <a id=\"appStore\" target=\"_blank\" [href]=\"appStoreUrl\">\n              <img alt=\"App Store\" width=\"145\" height=\"43\" ngSrc=\"/assets/images/apple-app-store.svg\" i18n-alt />\n            </a>\n          </div>\n          <div class=\"google-play\">\n            <a id=\"googlePlay\" target=\"_blank\" [href]=\"playStoreUrl\">\n              <img alt=\"Google Play\" width=\"145\" height=\"43\" ngSrc=\"/assets/images/google-play-store.svg\" i18n-alt />\n            </a>\n          </div>\n        </div>\n      }\n      <div class=\"buttons-container\">\n        <div class=\"left\">\n          <pii-button\n            [elementId]=\"options.confirmButtonId\"\n            [variant]=\"'primary'\"\n            [text]=\"options.confirmText\"\n            [fullWidth]=\"options.fullWidth\"\n            [maxWidth]=\"options.maxWidth\"\n            (clicked)=\"onConfirm()\"\n          />\n        </div>\n        @if (!options.hideCancelButton) {\n          <div class=\"right\">\n            <pii-button\n              [elementId]=\"options.cancelButtonId\"\n              [variant]=\"'secondary'\"\n              [text]=\"options.cancelText\"\n              [fullWidth]=\"true\"\n              (clicked)=\"onCancel()\"\n            />\n          </div>\n        }\n      </div>\n    </div>\n  }\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.confirmation-dialog-container .body-container{padding:20px}.confirmation-dialog-container .body-container .confirmation-dialog .store-buttons-container{align-items:center;display:grid;grid-gap:30px;grid-template-columns:1fr 1fr;padding:20px 0 0;text-align:center}#noBrowserLocationPermission{max-width:530px}#noBrowserLocationPermission .no-location-text{display:flex;flex-direction:column;gap:15px}#noBrowserLocationPermission .no-location-text p{font-size:1rem;line-height:1rem;margin:0}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.ConfigService }, { type: ConfirmDialogOptions, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i2$1.MatDialogRef, decorators: [{
                    type: Inject,
                    args: [MatDialogRef]
                }] }] });

const NUMBER_KEYS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const FUNCTION_KEYS = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12'];
const COMMON_KEYS = ['Delete', 'Backspace', 'Tab', 'Enter', 'Shift', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];
const ALLOWED_KEYS = [...NUMBER_KEYS, ...FUNCTION_KEYS, ...COMMON_KEYS];
const ESCAPE_KEY = 'Escape';
const MINUS_SIGN = '-';
class I18nNumberInputDirective {
    constructor(el, locale) {
        this.locale = locale;
        this.digitsInfo = '1.0-2';
        this.onlyPositive = true;
        this.selectAllOnFocus = true;
        this.max = '';
        this.i18nInputNumberChanges = new EventEmitter();
        this.inputValue = '';
        this.formattedValue = '';
        this.numberValue = NaN;
        this.initialValue = '';
        this.onModelChange = () => null;
        this.onTouch = () => null;
        this.input = el.nativeElement;
        this.decimalSeparator = getLocaleNumberSymbol(this.locale, NumberSymbol.Decimal);
        this.groupSeparator = getLocaleNumberSymbol(this.locale, NumberSymbol.Group);
    }
    //#region Host Listener
    onFocus() {
        this.setInputValue(this.inputValue);
        if (this.selectAllOnFocus) {
            this.input.select();
        }
    }
    onBlur() {
        this.setInputValue(this.formattedValue);
        this.initialValue = this.inputValue;
    }
    onKeyDown(event) {
        if (this.isTypingEscKey(event)) {
            this.onChangeNumber(this.initialValue);
            return;
        }
        if (this.isTypingAllowedKey(event)) {
            return;
        }
        event.preventDefault();
    }
    onInput(event) {
        const value = this.removeGroupSeparator(event.target.value);
        this.onChangeNumber(value);
    }
    //#endregion
    ngOnChanges(changes) {
        if (changes['digitsInfo'] && !changes['digitsInfo'].firstChange) {
            // Format process needs to be re-processed if the format value changes
            this.writeValue(this.inputValue);
        }
    }
    //#region Control Value Accessor
    writeValue(value) {
        if (typeof value === 'number') {
            value = Number.isNaN(value) ? '' : value.toString();
        }
        this.initialValue = value;
        this.calculateValues(value);
        this.setInputValue(this.formattedValue);
        this.updateOutputValues();
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    //#endregion
    onChange(value) {
        this.onModelChange(value);
        this.onTouch();
        this.updateOutputValues();
    }
    onChangeNumber(value) {
        this.calculateValues(value);
        this.onChange(this.numberValue);
    }
    //#region Process Values
    calculateValues(value) {
        value = this.sanitizeValue(value);
        if (this.max && value) {
            value = this.evaluateMaxValue(this.parseFormattedFloat(value));
        }
        this.formattedValue = this.getFormattedValue(value);
        this.numberValue = this.getNumberValue(this.formattedValue);
        this.inputValue = this.getInputValue(value);
    }
    sanitizeValue(value) {
        if (value) {
            // Remove spaces
            value = value.replace(/\s/g, '');
            // check "minus" sign
            const minusIndex = value.indexOf(MINUS_SIGN);
            const minusNumberParts = value.split(MINUS_SIGN);
            if (minusNumberParts.length > 1) {
                value = minusNumberParts.reduce((acc, part) => acc + part);
            }
            value = minusIndex === 0 && !this.onlyPositive ? `-${value}` : value;
            // check multiple decimal separators
            const numberParts = value.split(this.decimalSeparator).filter((a) => a.length > 0);
            if (numberParts.length > 1) {
                value = `${numberParts[0]}${this.decimalSeparator}${numberParts[1]}`;
            }
        }
        this.setInputValue(value);
        return value;
    }
    getFormattedValue(value) {
        if (!value) {
            return '';
        }
        const parsedValue = this.parseFormattedFloat(value);
        return formatNumber(Number(parsedValue), this.locale, this.digitsInfo);
    }
    getNumberValue(value) {
        return value ? this.parseFormattedFloat(this.removeGroupSeparator(value)) : NaN;
    }
    getInputValue(value) {
        return value ? value.replace(/\./g, this.decimalSeparator) : '';
    }
    evaluateMaxValue(value) {
        if (value === null || value === undefined) {
            return '';
        }
        const maxValue = Number(this.max);
        let stringValue = value.toString();
        if (value > maxValue) {
            stringValue = stringValue.slice(0, this.max.length);
            if (Number(stringValue) > maxValue) {
                stringValue = this.max;
            }
        }
        return stringValue;
    }
    parseFormattedFloat(value) {
        const parsedValue = parseFloat(value.replace(',', '.'));
        // if (Number.isNaN(parsedValue)) {
        //   return null;
        // }
        return parsedValue;
    }
    removeGroupSeparator(value) {
        if (typeof value?.replace !== 'function') {
            return '';
        }
        return value.replace(new RegExp(this.escapeRegExp(this.groupSeparator), 'g'), '');
    }
    escapeRegExp(find) {
        return find.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
    setInputValue(value) {
        this.input.value = value;
    }
    updateOutputValues() {
        this.i18nInputNumberChanges.emit({
            formattedValue: this.formattedValue,
            inputValue: this.inputValue,
            numberValue: this.numberValue,
        });
    }
    //#endregion
    //#region Keys
    isTypingEscKey(event) {
        return event.key === ESCAPE_KEY;
    }
    isTypingAllowedKey(event) {
        return (ALLOWED_KEYS.includes(event.key) || this.isTypingCommandKeys(event) || this.isTypingDecimalSeparatorOrMinus(event));
    }
    isTypingCommandKeys(event) {
        return ((event.key === 'a' && (event.ctrlKey || event.metaKey)) ||
            (event.key === 'c' && (event.ctrlKey || event.metaKey)) ||
            (event.key === 'v' && (event.ctrlKey || event.metaKey)) ||
            (event.key === 'x' && (event.ctrlKey || event.metaKey)));
    }
    isTypingDecimalSeparatorOrMinus(event) {
        return Boolean((event.key === this.decimalSeparator &&
            this.inputValue &&
            !this.inputValue.toString().includes(this.decimalSeparator)) ||
            (event.key === MINUS_SIGN &&
                !this.onlyPositive &&
                this.inputValue &&
                !this.inputValue.toString().includes(MINUS_SIGN)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: I18nNumberInputDirective, deps: [{ token: i0.ElementRef }, { token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.9", type: I18nNumberInputDirective, isStandalone: true, selector: "input [piiI18nNumberInput]", inputs: { digitsInfo: "digitsInfo", onlyPositive: "onlyPositive", selectAllOnFocus: "selectAllOnFocus", max: "max" }, outputs: { i18nInputNumberChanges: "i18nInputNumberChanges" }, host: { listeners: { "focus": "onFocus()", "blur": "onBlur()", "keydown": "onKeyDown($event)", "input": "onInput($event)" } }, providers: [
            {
                multi: true,
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => I18nNumberInputDirective),
            },
        ], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: I18nNumberInputDirective, decorators: [{
            type: Directive,
            args: [{
                    providers: [
                        {
                            multi: true,
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => I18nNumberInputDirective),
                        },
                    ],
                    selector: 'input [piiI18nNumberInput]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }], propDecorators: { digitsInfo: [{
                type: Input
            }], onlyPositive: [{
                type: Input
            }], selectAllOnFocus: [{
                type: Input
            }], max: [{
                type: Input
            }], i18nInputNumberChanges: [{
                type: Output
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

/* eslint-disable @angular-eslint/directive-selector */
class ImageCdnSrcSetDirective {
    constructor(el, renderer, routingHelpersService) {
        this.el = el;
        this.renderer = renderer;
        this.routingHelpersService = routingHelpersService;
    }
    ngOnChanges() {
        let source = this.srcset || this.ngSrcset;
        if (!source) {
            source = this.el.nativeElement.srcset;
        }
        if (!source) {
            return;
        }
        // Src was set with SafeResourceUrl, set element src.
        // This is necessary because the existence of this directive broke the SafeResourceUrl functionality.
        if (typeof source !== 'string' && !Array.isArray(source)) {
            if (has(source, 'changingThisBreaksApplicationSecurity')) {
                source = this.routingHelpersService.cleanResourceUrl(get(source, 'changingThisBreaksApplicationSecurity', ''));
            }
        }
        else if (Array.isArray(source)) {
            // example ['/path/image.png', '/path/image@2x.png 2x', '/path/image@3x.png 3x']
            for (let i = 0; i < source.length; i++) {
                source[i] = this.cleanSegment(source[i]);
            }
        }
        else {
            // example: '/path/image.png, /path/image@2x.png 2x, /path/image@3x.png 3x'
            source = this.cleanSegment(source);
        }
        this.renderer.setProperty(this.el.nativeElement, 'srcset', source);
    }
    cleanSegment(segment) {
        return segment
            .replace(/,\s+/g, ',') // remove extra spaces before splitting
            .split(',')
            .map((set) => {
            const newSet = set.split(' ');
            newSet[0] = this.routingHelpersService.cleanResourceUrl(newSet[0]);
            return newSet.join(' ');
        })
            .join(', ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ImageCdnSrcSetDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: RoutingHelpersService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.9", type: ImageCdnSrcSetDirective, isStandalone: true, selector: "img[srcset], img[ngSrcset]", inputs: { srcset: "srcset", ngSrcset: "ngSrcset" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ImageCdnSrcSetDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'img[srcset], img[ngSrcset]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: RoutingHelpersService }], propDecorators: { srcset: [{
                type: Input
            }], ngSrcset: [{
                type: Input
            }] } });

class UppercaseDirective {
    constructor(el) {
        this.el = el;
    }
    onInput() {
        this.el.nativeElement.value = this.el.nativeElement.value.toUpperCase();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UppercaseDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.9", type: UppercaseDirective, isStandalone: true, selector: "[piiUppercase]", host: { listeners: { "input": "onInput($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UppercaseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[piiUppercase]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { onInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

class DistanceDisplayComponent {
    constructor(distanceDisplayService, profileService) {
        this.distanceDisplayService = distanceDisplayService;
        this.profileService = profileService;
        this.format = 'MiKm';
        this.zeroIsValid = false;
        this.isZeroDefault = false;
        this.isNotRounded = false;
        this.boldUnit = false;
        this.boldValue = false;
        this.isCondensed = false;
        this.fontSize = 'default';
        this.isMetric = false;
        this.invalid = false;
        this.isDestroyed = false;
    }
    ngOnInit() {
        this.profileService
            .getIsMetric$()
            .pipe(takeWhile(() => !this.isDestroyed))
            .subscribe((isMetric) => {
            this.isMetric = isMetric;
            this.getMeasurementFormat();
        });
    }
    ngOnChanges(changes) {
        if (changes['distanceInMeters']) {
            this.getMeasurementFormat();
        }
    }
    ngOnDestroy() {
        this.isDestroyed = true;
    }
    getMeasurementFormat() {
        if (this.isZeroDefault) {
            this.distanceInMeters = this.distanceInMeters || 0;
        }
        if (typeof this.distanceInMeters !== 'number') {
            this.invalid = true;
            return;
        }
        const result = this.distanceDisplayService.getMeasurementFormat(this.distanceInMeters, this.isMetric, this.format, this.isNotRounded);
        this.distance = result.value;
        this.units = result.units;
        this.invalid = result.invalid || (this.distanceInMeters === 0 && !this.zeroIsValid);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DistanceDisplayComponent, deps: [{ token: DistanceDisplayService }, { token: i3.UserProfileService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: DistanceDisplayComponent, isStandalone: true, selector: "pii-distance-display", inputs: { distanceInMeters: "distanceInMeters", format: "format", zeroIsValid: "zeroIsValid", isZeroDefault: "isZeroDefault", isNotRounded: "isNotRounded", boldUnit: "boldUnit", boldValue: "boldValue", isCondensed: "isCondensed", fontSize: "fontSize" }, usesOnChanges: true, ngImport: i0, template: "@if (!invalid) {\n  <span [class]=\"'number' + ' ' + fontSize\" [ngClass]=\"{ 'helper-bold': boldValue, condensed: isCondensed }\">{{\n    distance | localeNumberFormat\n  }}</span>\n  <span class=\"number-type\" [ngClass]=\"{ 'helper-bold': boldUnit }\">{{ units }}</span>\n} @else {\n  <span class=\"number\" [ngClass]=\"{ 'helper-bold': boldValue }\">--</span>\n}\n", styles: [".number{margin:0 3px 0 0}.number.condensed{margin:0}.number.medium{font-size:1.2rem;line-height:normal}.number.large{font-size:1.5rem;line-height:normal;font-weight:700}.number.extra-large{font-size:2rem;line-height:normal;font-weight:700}.number-type{padding:0 3px 0 0}.helper-bold{font-weight:700}@media (max-width: 767px){.number.medium{font-size:1rem;line-height:normal}}@media (max-width: 599px){.number-type.medium{font-size:.8rem;line-height:normal}}\n"], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "pipe", type: LocaleNumberFormatPipe, name: "localeNumberFormat" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DistanceDisplayComponent, decorators: [{
            type: Component,
            args: [{ imports: [NgIf, NgClass, LocaleNumberFormatPipe], selector: 'pii-distance-display', standalone: true, template: "@if (!invalid) {\n  <span [class]=\"'number' + ' ' + fontSize\" [ngClass]=\"{ 'helper-bold': boldValue, condensed: isCondensed }\">{{\n    distance | localeNumberFormat\n  }}</span>\n  <span class=\"number-type\" [ngClass]=\"{ 'helper-bold': boldUnit }\">{{ units }}</span>\n} @else {\n  <span class=\"number\" [ngClass]=\"{ 'helper-bold': boldValue }\">--</span>\n}\n", styles: [".number{margin:0 3px 0 0}.number.condensed{margin:0}.number.medium{font-size:1.2rem;line-height:normal}.number.large{font-size:1.5rem;line-height:normal;font-weight:700}.number.extra-large{font-size:2rem;line-height:normal;font-weight:700}.number-type{padding:0 3px 0 0}.helper-bold{font-weight:700}@media (max-width: 767px){.number.medium{font-size:1rem;line-height:normal}}@media (max-width: 599px){.number-type.medium{font-size:.8rem;line-height:normal}}\n"] }]
        }], ctorParameters: () => [{ type: DistanceDisplayService }, { type: i3.UserProfileService }], propDecorators: { distanceInMeters: [{
                type: Input
            }], format: [{
                type: Input
            }], zeroIsValid: [{
                type: Input
            }], isZeroDefault: [{
                type: Input
            }], isNotRounded: [{
                type: Input
            }], boldUnit: [{
                type: Input
            }], boldValue: [{
                type: Input
            }], isCondensed: [{
                type: Input
            }], fontSize: [{
                type: Input
            }] } });

class DisplayDuration {
}
function getHours(durationInSeconds, maximumUnit, minimumUnit, result) {
    if (maximumUnit !== 'hr') {
        return durationInSeconds;
    }
    if (durationInSeconds < 3600 && minimumUnit !== 'hr') {
        return durationInSeconds;
    }
    if (minimumUnit === 'hr') {
        result.hours = String(Math.round(durationInSeconds / 3600));
        return 0;
    }
    result.hours = String(Math.floor(durationInSeconds / 3600));
    return durationInSeconds % 3600;
}
function getMinutes(durationInSeconds, maximumUnit, minimumUnit, result) {
    if (maximumUnit === 's') {
        return durationInSeconds;
    }
    if (minimumUnit === 'hr') {
        return 0;
    }
    if (!result.hours && durationInSeconds < 60 && minimumUnit === 's') {
        return durationInSeconds;
    }
    const minute = Math.floor((durationInSeconds % 3600) / 60);
    if (minimumUnit === 'min') {
        result.minutes = String(minute);
        return 0;
    }
    result.minutes = String(minute);
    return durationInSeconds % 60;
}
function getSeconds(durationInSeconds, minimumUnit, result) {
    if (minimumUnit !== 's') {
        return;
    }
    result.seconds = String(Math.round(durationInSeconds));
}
function doRollUnitsUp(durationInSeconds, maximumUnit, result) {
    if (maximumUnit === 'hr' && durationInSeconds >= 3540) {
        result.hours = String(Math.round(durationInSeconds / 3600));
    }
    else if (maximumUnit !== 's' && durationInSeconds >= 59) {
        result.minutes = String(Math.round(durationInSeconds / 60));
    }
    else {
        result.seconds = String(Math.round(durationInSeconds));
    }
}
function getDurationDisplayTotals(durationInSeconds, rollUnitsUp, maximumUnit, minimumUnit, zeroIsValid = false) {
    const result = new DisplayDuration();
    if (typeof durationInSeconds === 'string' && durationInSeconds !== '') {
        durationInSeconds = Number(durationInSeconds);
    }
    if (!isNumber(durationInSeconds) || isNaN(durationInSeconds) || (!zeroIsValid && durationInSeconds === 0)) {
        result.invalid = true;
        return result;
    }
    if (rollUnitsUp) {
        doRollUnitsUp(durationInSeconds, maximumUnit, result);
        return result;
    }
    // order matters, later methods expect seconds to be diminished by previous methods if applicable.
    // also, getMinutes and getSeconds may check hours and/or minutes values
    durationInSeconds = getHours(durationInSeconds, maximumUnit, minimumUnit, result);
    durationInSeconds = getMinutes(durationInSeconds, maximumUnit, minimumUnit, result);
    getSeconds(durationInSeconds, minimumUnit, result);
    return result;
}
// remove once DurationDisplay references have been replaced with individual function imports
/** @deprecated - import individual functions instead */
//eslint-disable-next-line @typescript-eslint/no-extraneous-class
class DurationDisplayService {
    static getDurationTotals(durationInSeconds, rollUnitsUp, maximumUnit, minimumUnit, zeroIsValid = false) {
        return getDurationDisplayTotals(durationInSeconds, rollUnitsUp, maximumUnit, minimumUnit, zeroIsValid);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DurationDisplayService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DurationDisplayService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DurationDisplayService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class DurationDisplayComponent {
    constructor(locale) {
        this.locale = locale;
        this.minimumUnit = 'min';
        this.maximumUnit = 'hr';
        /** @description Roll units up to a single unit (e.g. only show hours when durationInSeconds is at least 3600) */
        this.rollUnitsUp = false;
        this.zeroIsValid = false;
        this.isZeroDefault = false;
        this.boldUnit = false;
        this.boldValue = false;
        this.isCondensed = false;
        this.fontSize = 'default';
        this.invalid = false;
    }
    ngOnChanges() {
        this.hours = undefined;
        this.minutes = undefined;
        this.seconds = undefined;
        this.invalid = undefined;
        this.getDurationTotals();
    }
    getDurationTotals() {
        if (this.isZeroDefault) {
            this.durationInSeconds = this.durationInSeconds || 0;
        }
        const result = getDurationDisplayTotals(this.durationInSeconds, this.rollUnitsUp, this.maximumUnit, this.minimumUnit, this.zeroIsValid);
        this.hours = result.hours ? formatNumber(Number(result.hours), this.locale, '1.0-0') : result.hours;
        this.minutes = result.minutes;
        this.seconds = result.seconds;
        this.invalid = result.invalid;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DurationDisplayComponent, deps: [{ token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: DurationDisplayComponent, isStandalone: true, selector: "pii-duration-display", inputs: { durationInSeconds: "durationInSeconds", minimumUnit: "minimumUnit", maximumUnit: "maximumUnit", rollUnitsUp: "rollUnitsUp", zeroIsValid: "zeroIsValid", isZeroDefault: "isZeroDefault", boldUnit: "boldUnit", boldValue: "boldValue", isCondensed: "isCondensed", fontSize: "fontSize" }, usesOnChanges: true, ngImport: i0, template: "@if (hours) {\n  <span [class]=\"'number' + ' ' + fontSize\" [ngClass]=\"{ bold: boldValue, condensed: isCondensed }\">{{ hours }}</span>\n  <span class=\"number-type\" [ngClass]=\"{ bold: boldUnit }\" i18n>hr</span>\n}\n@if (minutes && minutes !== '0') {\n  <span [class]=\"'number' + ' ' + fontSize\" [ngClass]=\"{ bold: boldValue, condensed: isCondensed }\">{{ minutes }}</span>\n  <span class=\"number-type\" [ngClass]=\"{ bold: boldUnit }\" i18n>min</span>\n}\n@if (seconds && seconds !== '0') {\n  <span [class]=\"'number' + ' ' + fontSize\" [ngClass]=\"{ bold: boldValue, condensed: isCondensed }\">{{ seconds }}</span>\n  <span class=\"number-type\" [ngClass]=\"{ bold: boldUnit }\" i18n>sec</span>\n}\n@if (invalid) {\n  <span class=\"number\" [ngClass]=\"{ bold: boldValue }\">--</span>\n}\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.number{margin:0 3px 0 0}.number.condensed{margin:0}.number.medium{font-size:1.2rem;line-height:normal}.number.large{font-size:1.5rem;line-height:normal;font-weight:700}.number.extra-large{font-size:2rem;line-height:normal;font-weight:700}.number-type{padding:0 3px 0 0}.bold{font-weight:700}@media (max-width: 767px){.number.medium{font-size:1rem;line-height:normal}}@media (max-width: 599px){.number-type.medium{font-size:.8rem;line-height:normal}}\n"], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DurationDisplayComponent, decorators: [{
            type: Component,
            args: [{ imports: [NgIf, NgClass], selector: 'pii-duration-display', standalone: true, template: "@if (hours) {\n  <span [class]=\"'number' + ' ' + fontSize\" [ngClass]=\"{ bold: boldValue, condensed: isCondensed }\">{{ hours }}</span>\n  <span class=\"number-type\" [ngClass]=\"{ bold: boldUnit }\" i18n>hr</span>\n}\n@if (minutes && minutes !== '0') {\n  <span [class]=\"'number' + ' ' + fontSize\" [ngClass]=\"{ bold: boldValue, condensed: isCondensed }\">{{ minutes }}</span>\n  <span class=\"number-type\" [ngClass]=\"{ bold: boldUnit }\" i18n>min</span>\n}\n@if (seconds && seconds !== '0') {\n  <span [class]=\"'number' + ' ' + fontSize\" [ngClass]=\"{ bold: boldValue, condensed: isCondensed }\">{{ seconds }}</span>\n  <span class=\"number-type\" [ngClass]=\"{ bold: boldUnit }\" i18n>sec</span>\n}\n@if (invalid) {\n  <span class=\"number\" [ngClass]=\"{ bold: boldValue }\">--</span>\n}\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.number{margin:0 3px 0 0}.number.condensed{margin:0}.number.medium{font-size:1.2rem;line-height:normal}.number.large{font-size:1.5rem;line-height:normal;font-weight:700}.number.extra-large{font-size:2rem;line-height:normal;font-weight:700}.number-type{padding:0 3px 0 0}.bold{font-weight:700}@media (max-width: 767px){.number.medium{font-size:1rem;line-height:normal}}@media (max-width: 599px){.number-type.medium{font-size:.8rem;line-height:normal}}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }], propDecorators: { durationInSeconds: [{
                type: Input
            }], minimumUnit: [{
                type: Input
            }], maximumUnit: [{
                type: Input
            }], rollUnitsUp: [{
                type: Input
            }], zeroIsValid: [{
                type: Input
            }], isZeroDefault: [{
                type: Input
            }], boldUnit: [{
                type: Input
            }], boldValue: [{
                type: Input
            }], isCondensed: [{
                type: Input
            }], fontSize: [{
                type: Input
            }] } });

class GeoBounds {
    constructor(west = 0, south = 0, east = 0, north = 0) {
        this.west = Math.max(west, -180);
        this.south = Math.max(south, -90);
        this.east = Math.min(east, 180);
        this.north = Math.min(north, 90);
        this._northEast = new GeoCoordinate(this.east, this.north);
        this._northWest = new GeoCoordinate(this.west, this.north);
        this._southEast = new GeoCoordinate(this.east, this.south);
        this._southWest = new GeoCoordinate(this.west, this.south);
    }
    get widthInDegrees() {
        return Math.abs(this.east - this.west);
    }
    get heightInDegrees() {
        return Math.abs(this.north - this.south);
    }
    get northEast() {
        return this._northEast;
    }
    get northWest() {
        return this._northWest;
    }
    get southEast() {
        return this._southEast;
    }
    get southWest() {
        return this._southWest;
    }
    /** @deprecated */
    get center() {
        return {
            lat: this.south + this.heightInDegrees / 2,
            lng: this.west + this.widthInDegrees / 2,
        };
    }
    get centerGeoCoordinate() {
        const longitude = this.west + this.widthInDegrees / 2;
        const latitude = this.south + this.heightInDegrees / 2;
        return new GeoCoordinate(longitude, latitude);
    }
    /**
     * @description Get the approximate zoom level for a bounding box. To be used when a zoom level is needed and
     * only the bounding box is known. This is a very crude approximation of the zoom level. A more accurate calculation
     * requires the height and width of the map in pixels. See https://wiki.openstreetmap.org/wiki/Zoom_levels.
     */
    get zoomApproximate() {
        const heightZoomApproximate = 10 - Math.log(this.heightInDegrees) / Math.log(2);
        const widthZoomApproximate = 10 - Math.log(this.widthInDegrees) / Math.log(2);
        return Math.max(Math.min(heightZoomApproximate, widthZoomApproximate, 22), 1.5);
    }
    static fromGeoJsonBoundingBox(boundingBox) {
        // bounding box is in west, south, east, north order
        return new GeoBounds(...boundingBox);
    }
    static fromCoordinateArrayPath(coords) {
        if (coords.length === 0) {
            return new GeoBounds();
        }
        const lngs = coords.map((point) => point[0]);
        const lats = coords.map((point) => point[1]);
        return GeoBounds.fromLngLatArrays(lngs, lats);
    }
    static fromGeoCoordinates(geoCoordinates) {
        if (geoCoordinates.length === 0) {
            return new GeoBounds();
        }
        const lngs = geoCoordinates.map((geoCoordinate) => geoCoordinate.lng);
        const lats = geoCoordinates.map((geoCoordinate) => geoCoordinate.lat);
        return GeoBounds.fromLngLatArrays(lngs, lats);
    }
    static fromLngLatArrays(lngs, lats) {
        return new GeoBounds(Math.min(...lngs), Math.min(...lats), Math.max(...lngs), Math.max(...lats));
    }
    static fromMapboxLngLatBounds(mapboxBounds) {
        return new GeoBounds(mapboxBounds.getWest(), mapboxBounds.getSouth(), mapboxBounds.getEast(), mapboxBounds.getNorth());
    }
    toArray() {
        return [
            [this.west, this.south],
            [this.east, this.north],
        ];
    }
    toGeoJsonBoundingBox() {
        return [this.west, this.south, this.east, this.north];
    }
    toMapboxLngLatBounds() {
        return [this.southWest, this.northEast];
    }
    isValid() {
        return (!isNaN(this.west) &&
            !isNaN(this.east) &&
            !isNaN(this.north) &&
            !isNaN(this.south) &&
            this.east !== 0 &&
            this.west !== 0 &&
            this.north !== 0 &&
            this.south !== 0);
    }
    /**
     * @description - Increase or decrease the geographic size of a bounds object.
     * Bounds increase/decrease is capped at the poles and antemeridian.
     * @param factor - Amount to increase or decrease the bounds. Factor > 1 will increase and factor < 1 will decrease.
     */
    resizedBy(factor) {
        if (factor === 1) {
            return new GeoBounds(this.west, this.south, this.east, this.north);
        }
        const boundsHalfHeight = this.heightInDegrees / 2;
        const heightDelta = boundsHalfHeight * factor - boundsHalfHeight;
        const boundsHalfWidth = this.widthInDegrees / 2;
        const widthDelta = boundsHalfWidth * factor - boundsHalfWidth;
        return new GeoBounds(Math.max(this.west - widthDelta, -180), Math.max(this.south - heightDelta, -90), Math.min(this.east + widthDelta, 180), Math.min(this.north + heightDelta, 90));
    }
    clone() {
        return new GeoBounds(this.west, this.south, this.east, this.north);
    }
    containsLat(lat) {
        return this.southContainsLat(lat) && this.northContainsLat(lat);
    }
    containsLng(lng) {
        return this.eastContainsLng(lng) && this.westContainsLng(lng);
    }
    containsGeoCoordinate(coordinate) {
        return this.containsLat(coordinate.latitude) && this.containsLng(coordinate.longitude);
    }
    containsGeoCoordinatePath(path) {
        return every(path, (coordinate) => this.containsGeoCoordinate(coordinate));
    }
    containsGeoBounds(bounds) {
        return this.containsGeoCoordinate(bounds.southWest) && this.containsGeoCoordinate(bounds.northEast);
    }
    /**
     * @description Finds all bounding box edges a geoCoordinate can be considered outside of and returns the distance of the
     * closest edge in degrees. Note that to be considered "outside an edge", a line drawn between the geoCoordinate
     * and edge must not cross another bounding box edge. There can be a maximum of two edges that fit this definition
     * for any given geoCoordinate.
     * @param geoCoordinate - GeoCoordinate to test.
     */
    geoCoordinateDistanceToClosestOutsideEdge(geoCoordinate) {
        const lngLat = geoCoordinate.toCoordinateArray();
        const southWest = this.southWest.toCoordinateArray();
        const southEast = this.southEast.toCoordinateArray();
        const northEast = this.northEast.toCoordinateArray();
        const northWest = this.northWest.toCoordinateArray();
        const westOffset = !this.westContainsLng(geoCoordinate.lng)
            ? getCoordinateDistanceFromLineInDegrees(lngLat, southWest, northWest)
            : 0;
        const southOffset = !this.southContainsLat(geoCoordinate.lat)
            ? getCoordinateDistanceFromLineInDegrees(lngLat, southEast, southWest)
            : 0;
        const eastOffset = !this.eastContainsLng(geoCoordinate.lng)
            ? getCoordinateDistanceFromLineInDegrees(lngLat, northEast, southEast)
            : 0;
        const northOffset = !this.northContainsLat(geoCoordinate.lat)
            ? getCoordinateDistanceFromLineInDegrees(lngLat, northWest, northEast)
            : 0;
        return this.findSmallestNonZeroNumber(eastOffset, southOffset, westOffset, northOffset);
    }
    /**
     * @description Get the latitude offset of a GeoCoordinate compared to the bounds in degrees. Returns negative if the coordinate
     * is south of the southern edge of the bounds, positive if the coordinate is north of the northern edge of the
     * bounds and zero if the coordinate is inside the bounds.
     * @param geoCoordinate - GeoCoordinate to test.
     */
    getLatOffsetOfGeoCoordinate(geoCoordinate) {
        if (geoCoordinate.lat < this.south) {
            return geoCoordinate.lat - this.south;
        }
        else if (geoCoordinate.lat > this.north) {
            return geoCoordinate.lat - this.north;
        }
        return 0;
    }
    /**
     * @description Get the longitude offset of a GeoCoordinate compared to the bounds in degrees. Returns negative if the coordinate
     * is west of the western edge of the bounds, positive if the coordinate is east of the eastern edge of the
     * bounds and zero if the coordinate is inside the bounds.
     * @param geoCoordinate - GeoCoordinate to test.
     */
    getLngOffsetOfGeoCoordinate(geoCoordinate) {
        if (geoCoordinate.lng < this.west) {
            return geoCoordinate.lng - this.west;
        }
        else if (geoCoordinate.lng > this.east) {
            return geoCoordinate.lng - this.east;
        }
        return 0;
    }
    intersectsGeoCoordinatePath(path) {
        return some(path, (coordinate) => this.containsGeoCoordinate(coordinate));
    }
    intersectsGeoBounds(bounds) {
        return (this.intersectsGeoCoordinatePath([bounds.southWest, bounds.northEast]) ||
            bounds.intersectsGeoCoordinatePath([this.southWest, this.northEast]));
    }
    isLargerThan(bounds) {
        return this.widthInDegrees > bounds.widthInDegrees && this.heightInDegrees > bounds.heightInDegrees;
    }
    /**
     * @description Return a new bounds shifted the minimum amount to include the specified coordinate, maintaining the bounds' size.
     * @param coordinate - The coordinate this bounds should shift to include.
     */
    shiftedToIncludeGeoCoordinate(coordinate) {
        const lngOffset = this.getLngOffsetOfGeoCoordinate(coordinate);
        const latOffset = this.getLatOffsetOfGeoCoordinate(coordinate);
        return new GeoBounds(this.west + lngOffset, this.south + latOffset, this.east + lngOffset, this.north + latOffset);
    }
    /**
     * @description Return a new bounds shifted the minimum amount to include the specified bounds, maintaining this bounds' size.
     * If target bounds width or height is larger than current bounds, new bounds is centered on target bounds in that
     * direction. Resulting bounds width and height will be the larger of original bounds and target bounds.
     * @param targetBounds - The bounds this bounds should shift to include.
     */
    shiftedToIncludeBounds(targetBounds) {
        let newWest;
        let newSouth;
        let newEast;
        let newNorth;
        // if target width is greater than current width, center new lngs around target center
        if (targetBounds.widthInDegrees > this.widthInDegrees) {
            newWest = targetBounds.west;
            newEast = targetBounds.east;
        }
        else if (targetBounds.east > this.east) {
            newWest = targetBounds.east - this.widthInDegrees;
            newEast = targetBounds.east;
        }
        else if (targetBounds.west < this.west) {
            newWest = targetBounds.west;
            newEast = targetBounds.west + this.widthInDegrees;
        }
        else {
            newWest = this.west;
            newEast = this.east;
        }
        // if target height is greater than current height, center new lats around target center
        if (targetBounds.heightInDegrees > this.heightInDegrees) {
            newSouth = targetBounds.south;
            newNorth = targetBounds.north;
        }
        else if (targetBounds.north > this.north) {
            newSouth = targetBounds.north - this.heightInDegrees;
            newNorth = targetBounds.north;
        }
        else if (targetBounds.south < this.south) {
            newSouth = targetBounds.south;
            newNorth = targetBounds.south + this.heightInDegrees;
        }
        else {
            newSouth = this.south;
            newNorth = this.north;
        }
        return new GeoBounds(newWest, newSouth, newEast, newNorth);
    }
    expandToIncludeGeoCoordinate(coordinate) {
        if (this.containsGeoCoordinate(coordinate)) {
            return this.clone();
        }
        else {
            const newWest = this.westContainsLng(coordinate.lng) ? this.west : coordinate.lng;
            const newSouth = this.southContainsLat(coordinate.lat) ? this.south : coordinate.lat;
            const newEast = this.eastContainsLng(coordinate.lng) ? this.east : coordinate.lng;
            const newNorth = this.northContainsLat(coordinate.lat) ? this.north : coordinate.lat;
            return new GeoBounds(newWest, newSouth, newEast, newNorth);
        }
    }
    eastContainsLng(lng) {
        return lng <= this.east;
    }
    southContainsLat(lat) {
        return lat >= this.south;
    }
    westContainsLng(lng) {
        return lng >= this.west;
    }
    northContainsLat(lat) {
        return lat <= this.north;
    }
    findSmallestNonZeroNumber(...numbers) {
        return numbers.reduce((result, testNumber) => {
            if (testNumber > 0 && (result === 0 || testNumber < result)) {
                result = testNumber;
            }
            return result;
        }, 0);
    }
}

class CartesianTile {
    constructor(column, row, zoom = 8) {
        this._column = 0;
        this._row = 0;
        this._zoom = 0;
        this.column = column;
        this.row = row;
        this.zoom = zoom;
    }
    get column() {
        return this._column;
    }
    set column(column) {
        this._column = column;
        this._geoBounds = undefined;
    }
    get geoBounds() {
        if (!this._geoBounds) {
            const left = this.column / this.scale;
            const bottom = (this.row + 1) / this.scale;
            const right = (this.column + 1) / this.scale;
            const top = this.row / this.scale;
            const northWest = GeoCoordinate.fromNormalizedPoint(left, top);
            const southEast = GeoCoordinate.fromNormalizedPoint(right, bottom);
            this._geoBounds = new GeoBounds(northWest.lng, southEast.lat, southEast.lng, northWest.lat);
        }
        return this._geoBounds;
    }
    get id() {
        return `${this.column},${this.row}`;
    }
    get row() {
        return this._row;
    }
    set row(row) {
        this._row = row;
        this._geoBounds = undefined;
    }
    get zoom() {
        return this._zoom;
    }
    set zoom(zoom) {
        this._zoom = zoom;
        this._geoBounds = undefined;
    }
    get scale() {
        // eslint-disable-next-line eqeqeq
        if (this._scale == undefined) {
            // eslint-disable-next-line no-bitwise
            this._scale = 1 << this.zoom;
        }
        return this._scale;
    }
    static fromGeoCoordinate(coordinate, zoom = 8) {
        const point = coordinate.toNormalizedPoint();
        // eslint-disable-next-line no-bitwise
        const scale = 1 << zoom;
        // Prevent an out-of-range exception with max lng or lat.
        const x = Math.min(point.x, 0.999999999999);
        const y = Math.min(point.y, 0.999999999999);
        return new CartesianTile(Math.floor(x * scale), Math.floor(y * scale), zoom);
    }
}

class GeoBoundsTileService {
    getTiles(bounds) {
        const upperLeftTile = CartesianTile.fromGeoCoordinate(bounds.northWest);
        const lowerRightTile = CartesianTile.fromGeoCoordinate(bounds.southEast);
        // get all tiles between (and including) upper left and lower right
        const tiles = [];
        for (let col = upperLeftTile.column, endCol = lowerRightTile.column; col <= endCol; col++) {
            for (let row = upperLeftTile.row, endRow = lowerRightTile.row; row <= endRow; row++) {
                tiles.push(new CartesianTile(col, row));
            }
        }
        return tiles;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeoBoundsTileService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeoBoundsTileService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeoBoundsTileService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class GeocoderResource {
    constructor(http, appConfig) {
        this.http = http;
        this.appConfig = appConfig;
        this.baseUrl = 'https://api.mapbox.com/geocoding/v5/mapbox.places-permanent/';
    }
    getLngLatByPlaceName(placeName, proximity) {
        // Optional params
        // country - ISO 3166 alpha 2 country codes, separated by commas
        // proximity - Location around which to bias results, given as [lng, lat]
        // types - Filter results by one or more type. Options are: country, region, postcode, place, locality,
        //         neighborhood, address, poi. Multiple options can be comma-separated.
        // autocomplete - Whether or not to return autocomplete results. Options are: true and false. Defaults to true.
        // bbox - Bounding box within which to limit results, given as [minLng, minLat, maxLng, maxLat].
        let params = new HttpParams();
        if (proximity) {
            params = params.set('proximity', String(proximity));
        }
        const url = `${this.baseUrl}${placeName}.json?access_token=${this.appConfig.mapboxToken}`;
        return this.http.get(url, { params });
    }
    getPlaceNamesByLngLat(lng, lat) {
        const url = `${this.baseUrl}${lng},${lat}.json?access_token=${this.appConfig.mapboxToken}`;
        return this.http.get(url);
    }
    getAddressByLngLat(lng, lat) {
        const url = `${this.baseUrl}${lng},${lat}.json?types=address&access_token=${this.appConfig.mapboxToken}`;
        return this.http.get(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeocoderResource, deps: [{ token: i1$2.WebComponentHttpClient }, { token: i1$1.ConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeocoderResource, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeocoderResource, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.WebComponentHttpClient }, { type: i1$1.ConfigService }] });

class MailingAddress {
    constructor(contract = {}) {
        this.contract = cloneDeep(contract);
    }
    get city() {
        return this.contract.city ?? '';
    }
    get county() {
        if (!has(this.contract, 'county')) {
            return '';
        }
        return this.contract.county ?? '';
    }
    get country() {
        if (has(this.contract, 'country')) {
            return this.contract.country ?? '';
        }
        else if (has(this.contract, 'countryCode')) {
            return this.contract.countryCode ?? '';
        }
        return '';
    }
    get postalCode() {
        return this.contract.postalCode ?? '';
    }
    get state() {
        if (has(this.contract, 'state')) {
            return this.contract.state ?? '';
        }
        else if (has(this.contract, 'region')) {
            return this.contract.region ?? '';
        }
        return '';
    }
    get street() {
        if (has(this.contract, 'street')) {
            return this.contract.street ?? '';
        }
        else if (has(this.contract, 'addressLine1')) {
            if (has(this.contract, 'addressLine2')) {
                const address2 = (this.contract.addressLine2 ?? '');
                return `${this.contract.addressLine1}, ${address2}`;
            }
            return this.contract.addressLine1 ?? '';
        }
        else if (has(this.contract, 'address')) {
            return this.contract.address ?? '';
        }
        return '';
    }
    clone() {
        return new MailingAddress(this.toContract());
    }
    isEmpty() {
        return !some(Object.values(this.contract));
    }
    toContract() {
        return cloneDeep(this.contract);
    }
    toShortString() {
        const parts = [this.city, this.state];
        if (!this.city) {
            parts.push(this.country);
        }
        return compact(parts).join(', ');
    }
    toCityStateString() {
        return compact([this.city || this.county, this.state]).join(', ');
    }
    toString() {
        const parts = [this.street, this.city, this.state];
        if (!this.street) {
            if (!this.city && !this.state) {
                parts.push(this.postalCode);
            }
            parts.push(this.country);
        }
        return compact(parts).join(', ');
    }
    toStreetString() {
        if (!this.street) {
            return this.toString();
        }
        return this.street;
    }
}

class GeocoderService {
    constructor(resource) {
        this.resource = resource;
        this.geocodeCache = new CacheCollection();
    }
    getLngLatByPlaceName(name, proximity) {
        return this.resource.getLngLatByPlaceName(name, proximity);
    }
    getPlaceNamesByLngLat(lng, lat) {
        return this.resource.getPlaceNamesByLngLat(lng, lat);
    }
    getAddressByGeoCoordinate(geoCoordinate, isStateAbbreviated = false) {
        const key = `${geoCoordinate.lng}${geoCoordinate.lat}`;
        this.geocodeCache.purgeOld(3600000);
        const cached = this.geocodeCache.getItem(key);
        if (cached) {
            return of(cached);
        }
        return this.resource.getAddressByLngLat(geoCoordinate.lng, geoCoordinate.lat).pipe(map((result) => {
            const feature = result.features[0];
            const contract = {};
            if (result.features.length === 0) {
                return null;
            }
            if (feature.address) {
                contract['street'] = `${feature.address} `;
            }
            if (feature.text) {
                contract['street'] = `${contract['street'] || ''}${feature.text}`;
            }
            if (feature.context.length > 0) {
                contract['city'] = feature.context.find((data) => data.id.includes('place'))?.text || '';
                const region = feature.context.find((data) => data.id.includes('region'));
                contract['state'] = (isStateAbbreviated ? region?.short_code?.split('-').pop() : region?.text) || '';
                contract['postalCode'] = feature.context.find((data) => data.id.includes('postcode'))?.text || '';
                contract['country'] = feature.context.find((data) => data.id.includes('country'))?.text || '';
            }
            const address = new MailingAddress(contract);
            return address.isEmpty() ? null : address;
        }), tap((address) => {
            this.geocodeCache.setItem(address, key);
        }));
    }
    /**
     * @param geoCoordinate
     * @param address
     * @description - Turn address or geoCoordinate into array of two strings.
     * @returns [ address1, address2 ] if address is valid, otherwise [ lat, lng ], each to 4 places.
     */
    getLocationString(geoCoordinate, address) {
        if (address && !address.isEmpty()) {
            return [address.street, address.toShortString()];
        }
        return [`lat: ${geoCoordinate.lat.toFixed(4)}`, `lng: ${geoCoordinate.lng.toFixed(4)}`];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeocoderService, deps: [{ token: GeocoderResource }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeocoderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: GeocoderService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: GeocoderResource }] });

class GeoJsonFeatureCollection {
    constructor(geojsonFeatures = []) {
        this.type = 'FeatureCollection';
        this.features = cloneDeep(geojsonFeatures);
    }
}

class GeoJsonLineString {
    constructor(coordinates = [], properties = {}, id) {
        this.type = 'Feature';
        this.geometry = {
            coordinates: [...coordinates],
            type: 'LineString',
        };
        this.properties = cloneDeep(properties || {});
        if (id) {
            this.properties['id'] = id;
        }
    }
}

class GeoJsonMultiPoint {
    constructor(points = [], properties = {}, id) {
        this.type = 'Feature';
        this.geometry = {
            coordinates: cloneDeep(points),
            type: 'MultiPoint',
        };
        this.properties = cloneDeep(properties);
        if (id) {
            this.properties['id'] = id;
        }
    }
}

class GeoJsonPoint {
    constructor(lat = 0, lng = 0, properties = {}, id) {
        this.type = 'Feature';
        if (lat < -90 || lat > 90) {
            throw new Error('lat out of range');
        }
        if (lng < -180 || lng > 180) {
            throw new Error('lng out of range');
        }
        this.geometry = {
            coordinates: [lng, lat],
            type: 'Point',
        };
        this.properties = cloneDeep(properties);
        if (id) {
            this.properties['id'] = id;
        }
    }
}

class GeoJsonPolygon {
    constructor(paths = [], properties = {}, id) {
        this.type = 'Feature';
        const closedPaths = paths.map((path) => this.closePath(path));
        this.geometry = {
            coordinates: cloneDeep(closedPaths),
            type: 'Polygon',
        };
        this.properties = cloneDeep(properties);
        this.properties ??= {};
        if (id) {
            this.properties['id'] = id;
        }
    }
    closePath(coordinates) {
        const outCoordinates = [...coordinates];
        const first = coordinates[0];
        const last = outCoordinates[outCoordinates.length - 1];
        if (first[0] !== last[0] || first[1] !== last[1]) {
            outCoordinates.push(first);
        }
        return outCoordinates;
    }
}

class IconModule {
    constructor(configService, iconRegistry, sanitizer, routingHelpersService) {
        this.configService = configService;
        this.sanitizer = sanitizer;
        this.routingHelpersService = routingHelpersService;
        const options = {
            withCredentials: true,
        };
        iconRegistry.addSvgIconSetInNamespace('pii', this.getSafeUrl('icons'), options);
    }
    getSafeUrl(name) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.routingHelpersService.cleanResourceUrl(`assets/images/${name}.svg?v=${this.configService.version}`));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IconModule, deps: [{ token: i1$1.ConfigService }, { token: i2$2.MatIconRegistry }, { token: i3$1.DomSanitizer }, { token: RoutingHelpersService }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: IconModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IconModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IconModule, decorators: [{
            type: NgModule,
            args: [{}]
        }], ctorParameters: () => [{ type: i1$1.ConfigService }, { type: i2$2.MatIconRegistry }, { type: i3$1.DomSanitizer }, { type: RoutingHelpersService }] });

class Image {
    constructor(imageContract) {
        this._lat = null;
        this._lng = null;
        this.rawImage = cloneDeep(imageContract);
    }
    get id() {
        return this.rawImage.id ?? '';
    }
    get imageUrl() {
        return this.rawImage.imageUrl ?? '';
    }
    get lat() {
        if (this._lat === null) {
            this._lat = get(this.rawImage.geometry, ['coordinates', 1], null) ?? 0;
        }
        return this._lat;
    }
    get lng() {
        if (this._lng === null) {
            this._lng = get(this.rawImage.geometry, ['coordinates', 0], null) ?? 0;
        }
        return this._lng;
    }
    get photoLink() {
        return {
            imageId: this.id,
            imageUrl: this.imageUrl,
        };
    }
    get thumbnailUrl() {
        return this.rawImage.thumbnailImageUrl ?? '';
    }
    get timeCreated() {
        const timestamp = this.rawImage.timestamp;
        return timestamp ? new Date(timestamp) : undefined;
    }
    toContract() {
        return cloneDeep(this.rawImage);
    }
}

class PhotoLink {
    constructor(id, url) {
        this.imageId = id;
        this.imageUrl = url;
    }
}

class IsMobileViewService {
    constructor(breakpointObserver) {
        this.breakpointObserver = breakpointObserver;
        this.$isMobileView = toSignal(this.breakpointObserver
            .observe('(max-width: 959px)')
            .pipe(map((breakpoint) => breakpoint.matches)), {
            initialValue: false,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IsMobileViewService, deps: [{ token: i1$3.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IsMobileViewService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IsMobileViewService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.BreakpointObserver }] });

class ConsoleLogService {
    debug(message, ...optionalParams) {
        if (typeof console.debug === 'function') {
            console.debug(message, ...optionalParams);
        }
    }
    error(message, ...optionalParams) {
        if (typeof console.error === 'function') {
            console.error(message, ...optionalParams);
        }
    }
    info(message, ...optionalParams) {
        if (typeof console.info === 'function') {
            console.info(message, ...optionalParams);
        }
    }
    log(message, ...optionalParams) {
        if (typeof console.log === 'function') {
            console.log(message, ...optionalParams);
        }
    }
    trace(message, ...optionParams) {
        if (typeof console.trace === 'function') {
            console.trace(message, ...optionParams);
        }
    }
    warn(message, ...optionalParams) {
        if (typeof console.warn === 'function') {
            console.warn(message, ...optionalParams);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConsoleLogService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConsoleLogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ConsoleLogService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class LogService {
    constructor(config, consoleLogService, authService, http // private userProfileService: UserProfileService
    ) {
        this.config = config;
        this.consoleLogService = consoleLogService;
        this.authService = authService;
        this.http = http;
    }
    /**
     * @description Logs error message to the cloud and to the console.
     * @param sourceName - Name of the calling class or file.
     * reference for existing code, but this does not work when code is minified.
     * @param error - Error object or string.
     * @param persist - true if the message should be persisted to the database.
     */
    error(sourceName, error, persist) {
        let data;
        if (typeof error === 'object' && error !== null && 'data' in error) {
            data = error.data;
        }
        else {
            data = error;
        }
        this.log(LogLevel.Error, sourceName, data, persist);
    }
    /**
     * @description Logs warn message to the cloud and to the console.
     * @param sourceName - Name of the calling class or file.
     * reference for existing code, but this does not work when code is minified.
     * @param data - Message or keyed map of messages to log.
     * @param persist - true if the message should be persisted to the database.
     */
    warn(sourceName, data, persist) {
        this.log(LogLevel.Warn, sourceName, data, persist);
    }
    /**
     * @description Logs info message to the cloud and to the console.
     * @param sourceName - Name of the calling class or file.
     * reference for existing code, but this does not work when code is minified.
     * @param data - Message or keyed map of messages to log.
     * @param persist - true if the message should be persisted to the database.
     */
    info(sourceName, data, persist) {
        this.log(LogLevel.Info, sourceName, data, persist);
    }
    /**
     * @description Logs debug message to the cloud and to the console.
     * @param sourceName - Name of the calling class or file.
     * reference for existing code, but this does not work when code is minified.
     * @param data - Message or keyed map of messages to log.
     * @param persist - true if the message should be persisted to the database.
     */
    debug(sourceName, data, persist) {
        this.log(LogLevel.Debug, sourceName, data, persist);
    }
    /**
     * @description Logs trace message to the cloud and to the console.
     * @param sourceName - Name of the calling class or file.
     * reference for existing code, but this does not work when code is minified.
     * @param data - Message or keyed map of messages to log.
     * @param persist - true if the message should be persisted to the database.
     */
    trace(sourceName, data, persist) {
        this.log(LogLevel.Trace, sourceName, data, persist);
    }
    log(level, sourceName, data, persist) {
        this.logToConsole(logLevelName[level], sourceName, data);
        void this.logToCloud(level, sourceName, this.dataToMessage(data, logLevelName[level]), persist);
    }
    logToConsole(levelName, sourceName, data) {
        attempt(this.consoleLogService[levelName], sourceName, data);
    }
    async logToCloud(level, sourceName, data, persist) {
        if (!this.shouldPostLog(sourceName, level)) {
            return Promise.resolve();
        }
        try {
            // TODO: remove mock profile
            const mockProfile = {
                email: 'test@email.com',
            };
            const profile = await firstValueFrom(
            // this.userProfileService.getUserProfile()
            of(mockProfile));
            defaults(data, { user: profile.email });
            const entry = {
                data,
                dateTime: new Date(),
                level: capitalize(logLevelName[level]),
                persist,
                source: `Portal.${sourceName}`,
            };
            if (persist != null) {
                entry.persist = persist;
            }
            const logData = { entries: [entry] };
            await this.postLogData(logData);
        }
        catch (error) {
            this.consoleLogService.error('failed to post log', error);
        }
    }
    dataToMessage(data, levelName) {
        if (!data) {
            return {};
        }
        else if (typeof data === 'string') {
            return { [`${levelName}Message`]: data };
        }
        else if (data instanceof HttpErrorResponse) {
            const result = {};
            if (data.message) {
                result[`${levelName}Message`] = data.message;
            }
            if (typeof data.error === 'object' && data.error !== null && 'traceId' in data.error) {
                const error = data.error;
                result['traceId'] = error.traceId;
            }
            return result;
        }
        return Object.entries(data).reduce((message, [key, value]) => {
            const valueString = JSON.stringify(value);
            const newKey = key === 'message' ? `${levelName}Message` : key;
            set(message, newKey, valueString);
            return message;
        }, {});
    }
    shouldPostLog(sourceName, level) {
        const logLevels = this.config.logLevels;
        const sourceLogLevel = logLevels[sourceName] || logLevels['LogService'] || LogLevel.Error;
        return level <= sourceLogLevel;
    }
    async postLogData(data) {
        const isAuthenticated = await firstValueFrom(this.authService.isAuthenticated$());
        const params = new HttpParams();
        if (isAuthenticated) {
            params.set('skipAuthorization', 'true');
        }
        this.http.post(`${this.config.apiUrl.rideCommand}/log`, data, { params }).subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LogService, deps: [{ token: i1$1.ConfigService }, { token: ConsoleLogService }, { token: i3$2.AuthService }, { token: i1$2.WebComponentHttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LogService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.ConfigService }, { type: ConsoleLogService }, { type: i3$2.AuthService }, { type: i1$2.WebComponentHttpClient }] });

const getLocaleIdFromUrl = () => (window) => {
    const parse = window.location.pathname.match(/^\/(\w{2}(-\w{2})?)\//);
    return getSupportedCulture(parse?.[1] || defaultCulture);
};

function provideLocaleFromUrl() {
    return [
        {
            deps: [WINDOW],
            provide: LOCALE_ID,
            useFactory: getLocaleIdFromUrl(),
        },
    ];
}
function provideWebComponentHttpClient() {
    return [
        WebComponentHttpClient,
        { multi: true, provide: WEB_COMPONENT_HTTP_INTERCEPTORS, useClass: LanguageInterceptor },
        { multi: true, provide: WEB_COMPONENT_HTTP_INTERCEPTORS, useClass: AuthInterceptor },
        { multi: true, provide: WEB_COMPONENT_HTTP_INTERCEPTORS, useClass: SkuInterceptor },
    ];
}
function provideWebComponentNoInterceptHttpClient() {
    return [WebComponentNoInterceptHttpClient];
}
function provideIcons() {
    return [importProvidersFrom(MatIconModule, IconModule)];
}
function provideSharedComponents(options) {
    return [
        provideWebComponentHttpClient(),
        provideWebComponentNoInterceptHttpClient(),
        provideIcons(),
        provideConfig(options),
    ];
}

class MqttService {
    constructor(configService) {
        this.configService = configService;
    }
    async getClient(url, riderId) {
        const options = {
            clientId: `web-${this.configService.appSku}-${riderId}-${Math.random().toString(16).substr(2, 8)}`,
        };
        // The weird mqtt import here is due to the mqtt lib still figuring out esm imports.
        // This code was written with mqtt at 5.3.5. Hopefully a future update will allow a clean import.
        return await mqtt.default.connectAsync(url, options);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MqttService, deps: [{ token: i1$1.ConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MqttService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: MqttService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.ConfigService }] });

class MqttEmptyClient {
    constructor() {
        this.connected = true;
        this.reconnecting = false;
    }
    on() { }
    subscribeAsync() {
        return Promise.resolve([]);
    }
}

class PushService {
    constructor(authService, configService, consoleLogService, logService, mqttService, userProfileService) {
        this.authService = authService;
        this.configService = configService;
        this.consoleLogService = consoleLogService;
        this.logService = logService;
        this.mqttService = mqttService;
        this.userProfileService = userProfileService;
        this.className = 'PushService';
        this.allMessages$ = new BehaviorSubject(undefined);
        this.maxRetries = 10;
        this.retryCount = 0;
        this.authorizer = configService.mqtt.authorizer;
        this.endpoint = configService.mqtt.endpoint;
    }
    subscribeToConnectedFeature(vin) {
        this.consoleLogService.debug(`subscribing to connected feature for ${vin}`);
        return this.subscribe(`vin/${vin}/state/feat`).pipe(
        // change pascalCase values to camelCase to match other contracts
        map$1((connectedFeature) => {
            connectedFeature.deltas.map((delta) => {
                if (delta.name === 'IgnitionSecurity') {
                    delta.value.status = camelCase(delta.value.status);
                }
                if (delta.name === 'LocationSecurity') {
                    if (delta.value.bumpAlert?.state) {
                        delta.value.bumpAlert.state = camelCase(delta.value.bumpAlert.state);
                    }
                    if (delta.value.locationAlert?.state) {
                        delta.value.locationAlert.state = camelCase(delta.value.locationAlert.state);
                    }
                }
            });
            return connectedFeature;
        }));
    }
    subscribeToRemoteCommands(vin) {
        this.consoleLogService.debug(`subscribing to remote commands for ${vin}`);
        return this.subscribe(`vin/${vin}/rc/upd`, this.configService.mqtt.remoteCommandQos).pipe(
        // change pascalCase values to camelCase to match other contracts
        map$1((remoteCommand) => {
            remoteCommand.failureReason = camelCase(remoteCommand.failureReason);
            remoteCommand.status = camelCase(remoteCommand.status);
            remoteCommand.priority = camelCase(remoteCommand.priority);
            remoteCommand.externalIdSource = camelCase(remoteCommand.externalIdSource);
            return remoteCommand;
        }));
    }
    subscribeToRemoteEligibility(vin) {
        this.consoleLogService.debug(`subscribing to remote eligibility for ${vin}`);
        return this.subscribe(`vin/${vin}/rc/elg`, this.configService.mqtt.remoteCommandQos);
    }
    subscribeToRideEvents(vin) {
        this.consoleLogService.debug(`subscribing to ride events for ${vin}`);
        return this.subscribe(`vin/${vin}/ride/evn`);
    }
    subscribeToTelemetry(vin) {
        this.consoleLogService.debug(`subscribing to telemetry for ${vin}`);
        return this.subscribe(`vin/${vin}/tel`);
    }
    subscribeToVehicleLocation(vin) {
        this.consoleLogService.debug(`subscribing to vehicle location for ${vin}`);
        return this.subscribe(`vin/${vin}/loc`);
    }
    subscribeToActiveAlert(vin) {
        this.consoleLogService.debug(`subscribing to active alerts for ${vin}`);
        return this.subscribe(`vin/${vin}/alr`, this.configService.mqtt.alertQos).pipe(map$1((activeAlert) => {
            activeAlert.Status = camelCase(activeAlert.Status);
            return activeAlert;
        }));
    }
    subscribe(topic, qos = 0) {
        return from(this.doSubscription(topic, qos)).pipe(switchMap(() => this.allMessages$.asObservable()), filter((message) => {
            if (message === undefined || !message.topic) {
                return false;
            }
            return message.topic === topic;
        }), map$1((message) => message?.value), catchError((error) => {
            this.consoleLogService.error(error);
            return NEVER;
        }));
    }
    // For possible future use. Currently, we allow the connection to be broken when the application is destroyed.
    // private unsubscribe(topic: string): Promise<void> {
    //   if (!this.client || this.client.disconnected) {
    //     this.logService.error(this.className, 'tried to unsubscribe from topic when client disconnected');
    //     return Promise.resolve();
    //   }
    //   return new Promise((resolve) => {
    //     this.client?.unsubscribe(topic, (err) => {
    //       if (err) {
    //         this.logService.error(this.className, err);
    //       }
    //       resolve();
    //     });
    //   });
    // }
    async doSubscription(topics, qos = 0) {
        this.consoleLogService.debug('subscribing to mqtt');
        const client = await this.setupClient();
        return client.subscribeAsync(topics, {
            qos,
        });
    }
    async setupClient() {
        if (this.client) {
            const client = await this.client;
            if (client.connected || client.reconnecting) {
                return this.client;
            }
        }
        this.client = new Promise((resolve) => {
            Promise.all([
                firstValueFrom(this.authService.getToken$()),
                firstValueFrom(this.userProfileService.getUserRiderId$()),
            ])
                .then(([token, riderId]) => {
                if (!token) {
                    this.logService.error(this.className, 'attempted to subscribe to mqtt when user not authenticated');
                    return undefined;
                }
                const url = `wss://${this.endpoint}:443/mqtt?x-amz-customauthorizer-name=${this.authorizer}&token=${token}`;
                return this.mqttService.getClient(url, riderId);
            })
                .then((client) => {
                if (!client) {
                    resolve(new MqttEmptyClient());
                    return;
                }
                client.on('message', (topic, message) => {
                    let messageValue;
                    try {
                        const messageString = message.toString();
                        messageValue = JSON.parse(messageString);
                        this.consoleLogService.debug('mqtt message', topic, messageValue);
                        this.allMessages$.next({ topic, value: messageValue });
                        this.retryCount = 0;
                    }
                    catch {
                        this.logService.error(this.className, `failed to parse mqtt message for ${topic}`);
                    }
                });
                client.on('error', (err) => {
                    this.logService.error(this.className, err);
                });
                client.on('reconnect', () => {
                    this.retryCount++;
                    if (this.retryCount > this.maxRetries) {
                        this.logService.error(this.className, 'Max Reconnect Attempts Reached');
                        client.end();
                    }
                });
                resolve(client);
            })
                .catch((error) => {
                this.logService.error(this.className, error);
                resolve(new MqttEmptyClient());
            });
        });
        return this.client;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PushService, deps: [{ token: i3$2.AuthService }, { token: i1$1.ConfigService }, { token: ConsoleLogService }, { token: LogService }, { token: MqttService }, { token: i3.UserProfileService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PushService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PushService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i3$2.AuthService }, { type: i1$1.ConfigService }, { type: ConsoleLogService }, { type: LogService }, { type: MqttService }, { type: i3.UserProfileService }] });

class SaveCancelDeleteBarComponent {
    constructor() {
        this.showDelete = true;
        this.deleteEnabled = true;
        this.saveEnabled = true;
        this.isSubmitting = false;
        this.cancelButtonId = 'cancelButton';
        this.deleteButtonId = 'deleteButton';
        this.saveButtonId = 'saveButton';
        this.saveButtonText = $localize `Save`;
        this.savingButtonText = $localize `Saving...`;
        this.doCancel = new EventEmitter();
        this.doDelete = new EventEmitter();
        this.doSave = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SaveCancelDeleteBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: SaveCancelDeleteBarComponent, isStandalone: true, selector: "pii-save-cancel-delete-bar", inputs: { showDelete: "showDelete", deleteEnabled: "deleteEnabled", saveEnabled: "saveEnabled", isSubmitting: "isSubmitting", cancelButtonId: "cancelButtonId", cancelAnalytics: "cancelAnalytics", deleteButtonId: "deleteButtonId", deleteAnalytics: "deleteAnalytics", saveButtonId: "saveButtonId", saveAnalytics: "saveAnalytics", saveAnalyticsData: "saveAnalyticsData", saveButtonText: "saveButtonText", savingButtonText: "savingButtonText" }, outputs: { doCancel: "doCancel", doDelete: "doDelete", doSave: "doSave" }, ngImport: i0, template: "<div class=\"save-cancel-delete-bar-container\">\n  <div class=\"save-container\">\n    <pii-button\n      aria-label=\"save\"\n      [elementId]=\"saveButtonId\"\n      [text]=\"isSubmitting ? savingButtonText : saveButtonText\"\n      [fullWidth]=\"true\"\n      [disabled]=\"!saveEnabled\"\n      (clicked)=\"doSave.emit()\"\n      i18n-aria-label\n      i18n\n    />\n  </div>\n  <div class=\"cancel-container\">\n    <pii-button\n      aria-label=\"cancel\"\n      [elementId]=\"cancelButtonId\"\n      [text]=\"'Cancel'\"\n      [variant]=\"'secondary'\"\n      [fullWidth]=\"true\"\n      (clicked)=\"doCancel.emit()\"\n      i18n-aria-label\n      i18n\n      >Cancel</pii-button\n    >\n  </div>\n  @if (showDelete) {\n    <div class=\"delete-container\">\n      <pii-button\n        [elementId]=\"deleteButtonId\"\n        [disabled]=\"!deleteEnabled\"\n        [iconName]=\"'trash'\"\n        [iconClass]=\"'primary'\"\n        [variant]=\"'secondary'\"\n        (clicked)=\"doDelete.emit()\"\n      />\n    </div>\n  }\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.save-cancel-delete-bar-container{column-gap:8px;display:grid;grid-template-columns:1fr 1fr auto}.save-cancel-delete-bar-container .delete-button{background-color:#fff;border:0;border-radius:5px;box-shadow:0 2px 6px 0 var(--shadow-color);color:var(--primary-color);padding:7px}.save-cancel-delete-bar-container .delete-button mat-icon{height:21px;width:21px}.save-cancel-delete-bar-container .save-container button,.save-cancel-delete-bar-container .cancel-container button{width:100%}\n"], dependencies: [{ kind: "ngmodule", type: MatIconModule }, { kind: "component", type: ButtonComponent, selector: "pii-button", inputs: ["align", "disabled", "elementId", "expanded", "fullWidth", "iconClass", "iconName", "maxWidth", "text", "textColor", "variant"], outputs: ["clicked"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SaveCancelDeleteBarComponent, decorators: [{
            type: Component,
            args: [{ imports: [NgIf, MatIconModule, ButtonComponent], selector: 'pii-save-cancel-delete-bar', standalone: true, template: "<div class=\"save-cancel-delete-bar-container\">\n  <div class=\"save-container\">\n    <pii-button\n      aria-label=\"save\"\n      [elementId]=\"saveButtonId\"\n      [text]=\"isSubmitting ? savingButtonText : saveButtonText\"\n      [fullWidth]=\"true\"\n      [disabled]=\"!saveEnabled\"\n      (clicked)=\"doSave.emit()\"\n      i18n-aria-label\n      i18n\n    />\n  </div>\n  <div class=\"cancel-container\">\n    <pii-button\n      aria-label=\"cancel\"\n      [elementId]=\"cancelButtonId\"\n      [text]=\"'Cancel'\"\n      [variant]=\"'secondary'\"\n      [fullWidth]=\"true\"\n      (clicked)=\"doCancel.emit()\"\n      i18n-aria-label\n      i18n\n      >Cancel</pii-button\n    >\n  </div>\n  @if (showDelete) {\n    <div class=\"delete-container\">\n      <pii-button\n        [elementId]=\"deleteButtonId\"\n        [disabled]=\"!deleteEnabled\"\n        [iconName]=\"'trash'\"\n        [iconClass]=\"'primary'\"\n        [variant]=\"'secondary'\"\n        (clicked)=\"doDelete.emit()\"\n      />\n    </div>\n  }\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.save-cancel-delete-bar-container{column-gap:8px;display:grid;grid-template-columns:1fr 1fr auto}.save-cancel-delete-bar-container .delete-button{background-color:#fff;border:0;border-radius:5px;box-shadow:0 2px 6px 0 var(--shadow-color);color:var(--primary-color);padding:7px}.save-cancel-delete-bar-container .delete-button mat-icon{height:21px;width:21px}.save-cancel-delete-bar-container .save-container button,.save-cancel-delete-bar-container .cancel-container button{width:100%}\n"] }]
        }], propDecorators: { showDelete: [{
                type: Input
            }], deleteEnabled: [{
                type: Input
            }], saveEnabled: [{
                type: Input
            }], isSubmitting: [{
                type: Input
            }], cancelButtonId: [{
                type: Input
            }], cancelAnalytics: [{
                type: Input
            }], deleteButtonId: [{
                type: Input
            }], deleteAnalytics: [{
                type: Input
            }], saveButtonId: [{
                type: Input
            }], saveAnalytics: [{
                type: Input
            }], saveAnalyticsData: [{
                type: Input
            }], saveButtonText: [{
                type: Input
            }], savingButtonText: [{
                type: Input
            }], doCancel: [{
                type: Output
            }], doDelete: [{
                type: Output
            }], doSave: [{
                type: Output
            }] } });

class Hours {
    constructor(contract = {}) {
        this.contract = cloneDeep(contract);
    }
    get close() {
        return this.contract.close ?? '';
    }
    get hasHours() {
        return Boolean(this.open && this.close);
    }
    get open() {
        return this.contract.open ?? '';
    }
    clone() {
        return new Hours(this.contract);
    }
    toContract() {
        return cloneDeep(this.contract);
    }
}

class DayHours {
    constructor(contract = {}) {
        this.contract = cloneDeep(contract);
    }
    get sunday() {
        return new Hours(this.contract.sunday);
    }
    set sunday(hours) {
        this.contract.sunday = hours.toContract();
    }
    get monday() {
        return new Hours(this.contract.monday);
    }
    set monday(hours) {
        this.contract.monday = hours.toContract();
    }
    get tuesday() {
        return new Hours(this.contract.tuesday);
    }
    set tuesday(hours) {
        this.contract.tuesday = hours.toContract();
    }
    get wednesday() {
        return new Hours(this.contract.wednesday);
    }
    set wednesday(hours) {
        this.contract.wednesday = hours.toContract();
    }
    get thursday() {
        return new Hours(this.contract.thursday);
    }
    set thursday(hours) {
        this.contract.thursday = hours.toContract();
    }
    get friday() {
        return new Hours(this.contract.friday);
    }
    set friday(hours) {
        this.contract.friday = hours.toContract();
    }
    get saturday() {
        return new Hours(this.contract.saturday);
    }
    set saturday(hours) {
        this.contract.saturday = hours.toContract();
    }
    get hasHours() {
        return (this.sunday.hasHours ||
            this.monday.hasHours ||
            this.tuesday.hasHours ||
            this.wednesday.hasHours ||
            this.thursday.hasHours ||
            this.friday.hasHours ||
            this.saturday.hasHours);
    }
    static fromHoursArrayContract(contract = []) {
        return new DayHours(DayHours.arrayToDictionaryContract(contract));
    }
    /**
     * @param contract
     * @deprecated - Use constructor.
     */
    static create(contract) {
        return DayHours.fromHoursArrayContract(contract);
    }
    /**
     * @param dayHours
     * @deprecated - Use instance method.
     */
    static hasHours(dayHours) {
        return (DayHours.dayHasValidHours(dayHours, 'monday') ||
            DayHours.dayHasValidHours(dayHours, 'tuesday') ||
            DayHours.dayHasValidHours(dayHours, 'wednesday') ||
            DayHours.dayHasValidHours(dayHours, 'thursday') ||
            DayHours.dayHasValidHours(dayHours, 'friday') ||
            DayHours.dayHasValidHours(dayHours, 'saturday') ||
            DayHours.dayHasValidHours(dayHours, 'sunday'));
    }
    static dayHasValidHours(dayHours, day) {
        return Boolean(get(dayHours, [day, 'open'], false));
    }
    static dictionaryToArrayContract(hoursContract) {
        return Object.keys(hoursContract).map((key) => {
            return {
                close: get(hoursContract, [key, 'close'], ''),
                day: key.toUpperCase(),
                open: get(hoursContract, [key, 'open'], ''),
            };
        });
    }
    static arrayToDictionaryContract(contract) {
        return contract.reduce((hoursContract, dayHour) => {
            const dayName = dayHour.day.toLowerCase();
            set(hoursContract, dayName, {
                close: dayHour.close,
                open: dayHour.open,
            });
            return hoursContract;
        }, {});
    }
    clone() {
        return new DayHours(this.toDictionaryContract());
    }
    toDictionaryContract() {
        return cloneDeep(this.contract);
    }
    toArrayContract() {
        return DayHours.dictionaryToArrayContract(this.contract);
    }
}

class UserItemPromoComponent {
    constructor(config, authService) {
        this.authService = authService;
        this.userItemType = 'tracked';
        this.closePromo = new EventEmitter();
        this.sku = 'ORV';
        this.appStoreUrl = '';
        this.playStoreUrl = '';
        this.isAuthenticated$ = this.authService.isAuthenticated$();
        this.sku = config.appSku;
        this.appStoreUrl = config.appStoreUrl.apple;
        this.playStoreUrl = config.appStoreUrl.google;
    }
    ngOnChanges() {
        this.trackedIcons = [
            {
                icon: 'pii:tracked',
            },
            {
                icon: 'pii:route',
            },
            {
                icon: 'pii:place',
            },
            {
                icon: 'pii:area',
            },
            {
                icon: 'pii:collection',
            },
            {
                icon: 'pii:group',
            },
        ];
        if (this.sku === 'ORV') {
            if (this.userItemType === 'tracked') {
                this.header = 'Save and share the places you ride with your vehicle or Polaris mobile app.';
            }
            else if (this.userItemType === 'route') {
                this.header = 'Create a Route to plan your next ride.';
                this.notes = [
                    {
                        description: 'Easily route along snow or off-road trails with Snap-to-Trails feature.',
                        icon: 'pii:route',
                    },
                    {
                        description: 'Share with friends so everyone knows the plan.',
                        icon: 'pii:share',
                    },
                    {
                        description: 'Follow on your vehicle display or the mobile app.',
                        icon: 'pii:follow',
                    },
                ];
            }
            else if (this.userItemType === 'place') {
                this.header = 'Add your favorite Places.';
                this.notes = [
                    {
                        description: 'Easily navigate to your places and share them with your friends.',
                        icon: '',
                    },
                ];
            }
            else if (this.userItemType === 'area') {
                this.header = 'Know where to go with Areas.';
                this.notes = [
                    {
                        description: 'Mark boundaries or property lines on the map.',
                        icon: 'pii:area',
                    },
                    {
                        description: 'Set speed limits for equipped vehicles.',
                        icon: 'pii:speed',
                    },
                ];
            }
            else if (this.userItemType === 'collection') {
                this.header = 'Stay organized with Collections.';
                this.notes = [
                    {
                        description: 'Group your rides and places into collections to organize and share.',
                        icon: '',
                    },
                ];
            }
            else {
                this.header = 'See friends on the map with Group Ride.';
                this.notes = [
                    {
                        description: 'Send messages without a cellular signal.',
                        icon: 'pii:offroad-snow',
                    },
                    {
                        description: 'Join groups using the free Polaris app.',
                        icon: 'pii:phone',
                    },
                ];
            }
        }
        if (this.sku === 'IND') {
            if (this.userItemType === 'tracked') {
                this.header = 'Save and share the places you ride using your bike or the Indian Motorcycle app.';
            }
            else if (this.userItemType === 'route') {
                this.header = 'Create a Route to plan your next ride.';
                this.notes = [
                    {
                        description: 'Easily plan an epic ride with stops along the way.',
                        icon: 'pii:route',
                    },
                    {
                        description: 'Share with friends so everyone knows the plan.',
                        icon: 'pii:share',
                    },
                    {
                        description: 'Follow turn-by-turn directions on the bike display or Indian Motorcycle app.',
                        icon: 'pii:follow',
                    },
                ];
            }
            else if (this.userItemType === 'place') {
                this.header = 'Add your favorite Places.';
                this.notes = [
                    {
                        description: 'Easily navigate to your places and share them with your friends.',
                        icon: '',
                    },
                ];
            }
            else if (this.userItemType === 'collection') {
                this.header = 'Stay organized with Collections.';
                this.notes = [
                    {
                        description: 'Group your rides and places into collections to organize and share.',
                        icon: '',
                    },
                ];
            }
            else if (this.userItemType === 'group') {
                this.header = 'See friends on the map with Group Ride.';
                this.notes = [
                    {
                        description: 'Join groups using the free Indian Motorcycle app.',
                        icon: 'pii:phone',
                    },
                ];
            }
        }
        if (this.sku === 'SLG') {
            if (this.userItemType === 'tracked') {
                this.header = 'Save and share the places you ride using your vehicle or the Slingshot app.';
            }
            else if (this.userItemType === 'route') {
                this.header = 'Create a Route to plan your next ride.';
                this.notes = [
                    {
                        description: 'Easily plan an epic ride with stops along the way.',
                        icon: 'pii:route',
                    },
                    {
                        description: 'Share with friends so everyone knows the plan.',
                        icon: 'pii:share',
                    },
                    {
                        description: 'Follow turn-by-turn directions on the vehicle display or Slingshot app.',
                        icon: 'pii:follow',
                    },
                ];
            }
            else if (this.userItemType === 'place') {
                this.header = 'Add your favorite Places.';
                this.notes = [
                    {
                        description: 'Easily navigate to your places and share them with your friends.',
                        icon: '',
                    },
                ];
            }
            else if (this.userItemType === 'area') {
                this.header = 'Know where to go with Areas.';
                this.notes = [
                    {
                        description: 'Mark boundaries or property lines on the map.',
                        icon: 'pii:area',
                    },
                    {
                        description: 'Set speed limits for equipped vehicles.',
                        icon: 'pii:speed',
                    },
                ];
            }
            else if (this.userItemType === 'collection') {
                this.header = 'Stay organized with Collections.';
                this.notes = [
                    {
                        description: 'Group your rides and places into collections to organize and share.',
                        icon: '',
                    },
                ];
            }
            else {
                this.header = 'See friends on the map with Group Ride.';
                this.notes = [
                    {
                        description: 'Join groups using the free Slingshot app.',
                        icon: 'pii:phone',
                    },
                ];
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserItemPromoComponent, deps: [{ token: i1$1.ConfigService }, { token: i3$2.AuthService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: UserItemPromoComponent, isStandalone: true, selector: "pii-user-item-promo", inputs: { userItemType: "userItemType" }, outputs: { closePromo: "closePromo" }, usesOnChanges: true, ngImport: i0, template: "<div [class]=\"'user-item-promo-container' + ' ' + (sku | lowercase) + ' ' + userItemType\">\n  <div class=\"promo-cta\">\n    <div>\n      <h1>{{ header }}</h1>\n      @for (note of notes; track note) {\n        <div class=\"notes-row\">\n          <mat-icon class=\"white\" [svgIcon]=\"note.icon\" />\n          <p>{{ note.description }}</p>\n        </div>\n      }\n      @if (userItemType === 'tracked' && trackedIcons) {\n        <div class=\"tracked-icons\">\n          @for (icon of trackedIcons; track icon) {\n            @if (!(sku === 'IND' || sku === 'SLG') || icon.icon !== 'pii:area') {\n              <mat-icon class=\"white\" [svgIcon]=\"icon.icon\" />\n            }\n          }\n        </div>\n      }\n    </div>\n  </div>\n\n  @if (isAuthenticated$ | async) {\n    <a class=\"close-container\" href=\"javascript:void(0);\" (click)=\"closePromo.emit()\">\n      <mat-icon svgIcon=\"pii:close\" class=\"white\" />\n    </a>\n  }\n\n  @if (userItemType === 'tracked') {\n    <div class=\"stores-container\">\n      <a id=\"appStore\" target=\"_blank\" [href]=\"appStoreUrl\">\n        <img\n          class=\"app-store-image\"\n          alt=\"App Store\"\n          width=\"104\"\n          height=\"31\"\n          ngSrc=\"/assets/images/apple-app-store.svg\"\n          i18n-alt\n        />\n      </a>\n      <a id=\"googlePlay\" target=\"_blank\" [href]=\"playStoreUrl\">\n        <img\n          class=\"play-store-image\"\n          alt=\"Google Play\"\n          width=\"104\"\n          height=\"31\"\n          ngSrc=\"/assets/images/google-play-store.svg\"\n          i18n-alt\n        />\n      </a>\n    </div>\n  }\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.user-item-promo-container{border-radius:5px;display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;height:437px;padding:30px;position:relative;width:100%}.user-item-promo-container.orv.tracked .promo-cta{grid-column:1;grid-row:1;max-width:320px}.user-item-promo-container.orv.route .promo-cta{grid-column:1;grid-row:1;max-width:300px}.user-item-promo-container.orv.place{height:535px}.user-item-promo-container.orv.place .promo-cta{grid-column:1;grid-row:1;max-width:330px}.user-item-promo-container.orv.area .promo-cta{align-self:end;grid-column:2;grid-row:2;justify-self:end;max-width:280px}.user-item-promo-container.orv.collection .promo-cta{align-self:end;grid-column:2;grid-row:2;justify-self:end;max-width:330px}.user-item-promo-container.orv.group .promo-cta{align-self:end;grid-column:2;grid-row:2;justify-self:end;max-width:270px}.user-item-promo-container.ind.tracked .promo-cta{grid-column:1;grid-row:1;max-width:330px}.user-item-promo-container.ind.route .promo-cta{grid-column:2;grid-row:1;max-width:295px}.user-item-promo-container.ind.place{height:535px}.user-item-promo-container.ind.place .promo-cta{grid-column:2;grid-row:1;justify-self:end;max-width:270px}.user-item-promo-container.ind.collection .promo-cta{grid-column:2;grid-row:1;max-width:340px}.user-item-promo-container.ind.group .promo-cta{grid-column:2;grid-row:1;justify-self:end;max-width:330px}.user-item-promo-container.slg.tracked .promo-cta{grid-column:1;grid-row:1;max-width:330px}.user-item-promo-container.slg.route .promo-cta{grid-column:2;grid-row:1;max-width:343px}.user-item-promo-container.slg.place{height:535px}.user-item-promo-container.slg.place .promo-cta{grid-column:1;grid-row:1;max-width:260px}.user-item-promo-container.slg.collection .promo-cta{grid-column:1;grid-row:1;max-width:330px}.user-item-promo-container.slg.group .promo-cta{grid-column:2;grid-row:1;justify-self:end;max-width:285px}.user-item-promo-container .promo-cta{background:#0006;border-radius:10px;color:#fff;height:fit-content;padding:30px;width:max-content}.user-item-promo-container .promo-cta h1{font-size:1.675rem;line-height:1.675rem;font-family:var(--brand-font);margin-bottom:15px}.user-item-promo-container .promo-cta .notes-row{display:grid;gap:10px;grid-template-columns:auto 1fr;margin-bottom:20px}.user-item-promo-container .promo-cta .notes-row:last-of-type{margin-bottom:0}.user-item-promo-container .promo-cta .notes-row p{line-height:1.3;margin:0}.user-item-promo-container .tracked-icons{display:flex;flex-direction:row;justify-content:space-between;margin-top:20px}.user-item-promo-container .close-container{-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);background:#0006;border-radius:50%;height:34px;padding:3px 3px 1px 1px;position:absolute;right:20px;top:20px;width:34px}.user-item-promo-container .close-container mat-icon{position:relative;right:0}.user-item-promo-container .stores-container{bottom:40px;display:flex;gap:10px;left:40px;position:absolute}.user-item-promo-container .stores-container img{max-width:104px}.user-item-promo-container mat-icon{height:26px;width:26px}@media (max-width: 834px){.user-item-promo-container{width:inherit}}@media (max-width: 480px){.user-item-promo-container{grid-template-columns:1fr;grid-template-rows:1fr;padding:16px;width:inherit}.user-item-promo-container .promo-cta{padding:16px;width:fit-content}}@media (max-width: 320px){.user-item-promo-container{padding:8px}.user-item-promo-container .promo-cta{padding:16px}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.LowerCasePipe, name: "lowercase" }, { kind: "component", type: MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: ImageCdnSrcDirective, selector: "img[src], img[ngSrc]", inputs: ["src", "ngSrc"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserItemPromoComponent, decorators: [{
            type: Component,
            args: [{ imports: [CommonModule, MatIcon, ImageCdnSrcDirective], selector: 'pii-user-item-promo', standalone: true, template: "<div [class]=\"'user-item-promo-container' + ' ' + (sku | lowercase) + ' ' + userItemType\">\n  <div class=\"promo-cta\">\n    <div>\n      <h1>{{ header }}</h1>\n      @for (note of notes; track note) {\n        <div class=\"notes-row\">\n          <mat-icon class=\"white\" [svgIcon]=\"note.icon\" />\n          <p>{{ note.description }}</p>\n        </div>\n      }\n      @if (userItemType === 'tracked' && trackedIcons) {\n        <div class=\"tracked-icons\">\n          @for (icon of trackedIcons; track icon) {\n            @if (!(sku === 'IND' || sku === 'SLG') || icon.icon !== 'pii:area') {\n              <mat-icon class=\"white\" [svgIcon]=\"icon.icon\" />\n            }\n          }\n        </div>\n      }\n    </div>\n  </div>\n\n  @if (isAuthenticated$ | async) {\n    <a class=\"close-container\" href=\"javascript:void(0);\" (click)=\"closePromo.emit()\">\n      <mat-icon svgIcon=\"pii:close\" class=\"white\" />\n    </a>\n  }\n\n  @if (userItemType === 'tracked') {\n    <div class=\"stores-container\">\n      <a id=\"appStore\" target=\"_blank\" [href]=\"appStoreUrl\">\n        <img\n          class=\"app-store-image\"\n          alt=\"App Store\"\n          width=\"104\"\n          height=\"31\"\n          ngSrc=\"/assets/images/apple-app-store.svg\"\n          i18n-alt\n        />\n      </a>\n      <a id=\"googlePlay\" target=\"_blank\" [href]=\"playStoreUrl\">\n        <img\n          class=\"play-store-image\"\n          alt=\"Google Play\"\n          width=\"104\"\n          height=\"31\"\n          ngSrc=\"/assets/images/google-play-store.svg\"\n          i18n-alt\n        />\n      </a>\n    </div>\n  }\n</div>\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.user-item-promo-container{border-radius:5px;display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;height:437px;padding:30px;position:relative;width:100%}.user-item-promo-container.orv.tracked .promo-cta{grid-column:1;grid-row:1;max-width:320px}.user-item-promo-container.orv.route .promo-cta{grid-column:1;grid-row:1;max-width:300px}.user-item-promo-container.orv.place{height:535px}.user-item-promo-container.orv.place .promo-cta{grid-column:1;grid-row:1;max-width:330px}.user-item-promo-container.orv.area .promo-cta{align-self:end;grid-column:2;grid-row:2;justify-self:end;max-width:280px}.user-item-promo-container.orv.collection .promo-cta{align-self:end;grid-column:2;grid-row:2;justify-self:end;max-width:330px}.user-item-promo-container.orv.group .promo-cta{align-self:end;grid-column:2;grid-row:2;justify-self:end;max-width:270px}.user-item-promo-container.ind.tracked .promo-cta{grid-column:1;grid-row:1;max-width:330px}.user-item-promo-container.ind.route .promo-cta{grid-column:2;grid-row:1;max-width:295px}.user-item-promo-container.ind.place{height:535px}.user-item-promo-container.ind.place .promo-cta{grid-column:2;grid-row:1;justify-self:end;max-width:270px}.user-item-promo-container.ind.collection .promo-cta{grid-column:2;grid-row:1;max-width:340px}.user-item-promo-container.ind.group .promo-cta{grid-column:2;grid-row:1;justify-self:end;max-width:330px}.user-item-promo-container.slg.tracked .promo-cta{grid-column:1;grid-row:1;max-width:330px}.user-item-promo-container.slg.route .promo-cta{grid-column:2;grid-row:1;max-width:343px}.user-item-promo-container.slg.place{height:535px}.user-item-promo-container.slg.place .promo-cta{grid-column:1;grid-row:1;max-width:260px}.user-item-promo-container.slg.collection .promo-cta{grid-column:1;grid-row:1;max-width:330px}.user-item-promo-container.slg.group .promo-cta{grid-column:2;grid-row:1;justify-self:end;max-width:285px}.user-item-promo-container .promo-cta{background:#0006;border-radius:10px;color:#fff;height:fit-content;padding:30px;width:max-content}.user-item-promo-container .promo-cta h1{font-size:1.675rem;line-height:1.675rem;font-family:var(--brand-font);margin-bottom:15px}.user-item-promo-container .promo-cta .notes-row{display:grid;gap:10px;grid-template-columns:auto 1fr;margin-bottom:20px}.user-item-promo-container .promo-cta .notes-row:last-of-type{margin-bottom:0}.user-item-promo-container .promo-cta .notes-row p{line-height:1.3;margin:0}.user-item-promo-container .tracked-icons{display:flex;flex-direction:row;justify-content:space-between;margin-top:20px}.user-item-promo-container .close-container{-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);background:#0006;border-radius:50%;height:34px;padding:3px 3px 1px 1px;position:absolute;right:20px;top:20px;width:34px}.user-item-promo-container .close-container mat-icon{position:relative;right:0}.user-item-promo-container .stores-container{bottom:40px;display:flex;gap:10px;left:40px;position:absolute}.user-item-promo-container .stores-container img{max-width:104px}.user-item-promo-container mat-icon{height:26px;width:26px}@media (max-width: 834px){.user-item-promo-container{width:inherit}}@media (max-width: 480px){.user-item-promo-container{grid-template-columns:1fr;grid-template-rows:1fr;padding:16px;width:inherit}.user-item-promo-container .promo-cta{padding:16px;width:fit-content}}@media (max-width: 320px){.user-item-promo-container{padding:8px}.user-item-promo-container .promo-cta{padding:16px}}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.ConfigService }, { type: i3$2.AuthService }], propDecorators: { userItemType: [{
                type: Input
            }], closePromo: [{
                type: Output
            }] } });

class UserLocationService {
    constructor(window) {
        this.window = window;
    }
    getUserLocation() {
        const navigator = this.window.navigator;
        if (!navigator?.permissions) {
            return this.getUserLocationFromBrowser();
        }
        return defer(() => navigator.permissions.query({ name: 'geolocation' })).pipe(exhaustMap((permission) => {
            if (permission.state === 'denied') {
                return throwError(() => $localize `Geolocation permission not granted`);
            }
            return this.getUserLocationFromBrowser();
        }));
    }
    pollUserLocation() {
        const navigator = this.window.navigator;
        if (!navigator?.permissions) {
            return this.pollUserLocationFromBrowser();
        }
        return defer(() => navigator.permissions.query({ name: 'geolocation' })).pipe(exhaustMap((permission) => {
            if (permission.state === 'denied') {
                return this.returnDefaultLocation();
            }
            return this.pollUserLocationFromBrowser();
        }), share());
    }
    pollUserLocationFromBrowser() {
        return new Observable((subscriber) => {
            this.window.navigator.geolocation.watchPosition((position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                subscriber.next(GeoCoordinate.fromLongitudeAndLatitude(longitude, latitude));
            }, (error) => {
                subscriber.error(error.message);
            }, { maximumAge: 30000 });
        });
    }
    returnDefaultLocation() {
        return new Observable((subscriber) => {
            const latitude = 0;
            const longitude = 0;
            subscriber.next(GeoCoordinate.fromLongitudeAndLatitude(longitude, latitude));
            subscriber.complete();
        });
    }
    getUserLocationFromBrowser() {
        return new Observable((subscriber) => {
            this.window.navigator.geolocation.getCurrentPosition((position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                subscriber.next(GeoCoordinate.fromLongitudeAndLatitude(longitude, latitude));
                subscriber.complete();
            }, (error) => {
                subscriber.error(error.message);
            }, { timeout: 5000 });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserLocationService, deps: [{ token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserLocationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UserLocationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: Window, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }] });

class EfficiencyDisplayService {
    constructor(conversionService, valueDisplayService) {
        this.conversionService = conversionService;
        this.valueDisplayService = valueDisplayService;
    }
    getFormattedValue(kwhPerKm, isMetric) {
        if (!isFinite$1(kwhPerKm)) {
            return new FormattedValue();
        }
        const efficiency = isMetric ? kwhPerKm : this.conversionService.kwhPerKmToKwhPerMile(kwhPerKm);
        const unit = efficiency < 0.9995 ? 'Wh' : 'kWh';
        const efficiency2 = efficiency < 0.9995
            ? this.valueDisplayService.toFixed(efficiency * 1000, 0)
            : this.valueDisplayService.toFixed(efficiency, 1);
        let units = isMetric ? 'km' : 'mi';
        units = `${unit}/${units}`;
        return new FormattedValue({
            units,
            value: efficiency2,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EfficiencyDisplayService, deps: [{ token: ConversionService }, { token: ValueDisplayService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EfficiencyDisplayService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EfficiencyDisplayService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ConversionService }, { type: ValueDisplayService }] });

class SpeedDisplayService {
    constructor(conversionService, valueDisplayService) {
        this.conversionService = conversionService;
        this.valueDisplayService = valueDisplayService;
    }
    getMeasurementFormat(speedInMetersPerSecond, isMetric = true) {
        if (!isFinite(speedInMetersPerSecond)) {
            return new FormattedValue();
        }
        const speedInMetersPerHour = speedInMetersPerSecond * 3600;
        let speedValue;
        let units;
        if (isMetric) {
            speedValue = this.conversionService.metersToKm(speedInMetersPerHour);
            units = 'kph';
        }
        else {
            speedValue = this.conversionService.metersToMiles(speedInMetersPerHour);
            units = 'mph';
        }
        const value = this.valueDisplayService.toFixed(speedValue, 0);
        return new FormattedValue({ units, value });
    }
    /**
     *  Calculates the speed in meters per second
     * @param locations the array of vehicle locations
     * @param lastReportSecondsThreshold the maximum time in seconds that the most recent location is considered current and valid
     * @param distanceMetersThreshold the minimum distance in meters that a must be traveled to have a non-zero speed
     * @returns the speed in meters per second
     */
    calculateSpeed(locations, lastReportSecondsThreshold = 15, distanceMetersThreshold = 9) {
        let speed = 0;
        if (locations.length <= 1) {
            return speed;
        }
        const locationsByTimeDesc = [...locations].sort((a, b) => {
            if (a.time && b.time) {
                return new Date(b.time).getTime() - new Date(a.time).getTime();
            }
            return 0;
        });
        const currentLocation = locationsByTimeDesc[0];
        const previousLocation = locationsByTimeDesc[1];
        const currentLocationPosition = [currentLocation.longitude ?? 0, currentLocation.latitude ?? 0];
        const previousLocationPosition = [previousLocation.longitude ?? 0, previousLocation.latitude ?? 0];
        const currentLocationTime = currentLocation.time ? new Date(currentLocation.time).getTime() : 0;
        const previousLocationTime = previousLocation.time ? new Date(previousLocation.time).getTime() : 0;
        const distanceInMeters = turfLineLength(lineString([currentLocationPosition, previousLocationPosition]), {
            units: 'meters',
        });
        if (distanceInMeters < distanceMetersThreshold) {
            return speed;
        }
        const secondsSinceLastReport = (new Date().getTime() - currentLocationTime) / 1000;
        const secondsBetweenLocations = (currentLocationTime - previousLocationTime) / 1000;
        if (secondsBetweenLocations > 0 && secondsSinceLastReport < lastReportSecondsThreshold) {
            speed = distanceInMeters / secondsBetweenLocations;
        }
        return speed;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SpeedDisplayService, deps: [{ token: ConversionService }, { token: ValueDisplayService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SpeedDisplayService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SpeedDisplayService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ConversionService }, { type: ValueDisplayService }] });

class TemperatureDisplayService {
    constructor(conversionService, valueDisplayService) {
        this.conversionService = conversionService;
        this.valueDisplayService = valueDisplayService;
    }
    getMeasurementFormat(celsius, isMetric) {
        if (!isFinite$1(celsius)) {
            return new FormattedValue();
        }
        const temperature = isMetric ? celsius : this.conversionService.celsiusToFahrenheit(celsius);
        const units = isMetric ? 'C' : 'F';
        return new FormattedValue({
            units,
            value: `${this.valueDisplayService.toFixed(temperature, 0)}°`,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TemperatureDisplayService, deps: [{ token: ConversionService }, { token: ValueDisplayService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TemperatureDisplayService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: TemperatureDisplayService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ConversionService }, { type: ValueDisplayService }] });

class PublicWaypointService {
    constructor(conditionService) {
        this.activeWaypointIdSignal = signal('');
        this.$publicWaypointConditions = computed(() => {
            const id = this.activeWaypointIdSignal();
            if (!id) {
                return [];
            }
            const conditions = conditionService.getConditionsForPublicWaypoint();
            return conditions.reduce((list, item) => {
                if (!list.some((condition) => condition.type === item.type)) {
                    list.push(item);
                }
                return list;
            }, []);
        });
    }
    setActiveWaypointId(id) {
        this.activeWaypointIdSignal.set(id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PublicWaypointService, deps: [{ token: ConditionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PublicWaypointService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PublicWaypointService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ConditionService }] });

class WeatherCondition {
    constructor(contract = []) {
        this.contract = orderBy(contract, 'timestamp', 'desc');
    }
    get description() {
        return this.contract[0]?.weather ?? '';
    }
    get icon() {
        return this.contract[0]?.icon ?? '';
    }
    get rainFallIn() {
        return Math.round(this.contract.reduce((total, period) => total + (period.precipIN ?? 0), 0) * 10) / 10;
    }
    get rainFallMm() {
        return Math.round(this.contract.reduce((total, period) => total + (period.precipMM ?? 0), 0) * 10) / 10;
    }
    get tempF() {
        return Math.round(this.contract[0]?.tempF ?? 0);
    }
    get tempC() {
        return Math.round(this.contract[0]?.tempC ?? 0);
    }
}

class WeatherWidgetComponent {
    constructor(userProfileService) {
        this.$weather = input();
        this.$isMetric = toSignal(userProfileService.getIsMetric$(), { initialValue: false });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: WeatherWidgetComponent, deps: [{ token: i3.UserProfileService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: WeatherWidgetComponent, isStandalone: true, selector: "pii-weather-widget", inputs: { $weather: { classPropertyName: "$weather", publicName: "$weather", isSignal: true, isRequired: false, transformFunction: null } }, ngImport: i0, template: "@let weather = $weather();\n@if (weather) {\n  <div class=\"weather\">\n    <div class=\"weather-section\">\n      <div class=\"info\">\n        <img width=\"55px\" height=\"55px\" [alt]=\"'rainfall'\" [ngSrc]=\"'/assets/images/weather/rainfall.png'\" />\n        <div class=\"align-baseline\">\n          @if ($isMetric()) {\n            <div class=\"large-font\">{{ weather.rainFallMm }}</div>\n            <div i18n>mm</div>\n          } @else {\n            <div class=\"large-font\">{{ weather.rainFallIn }}</div>\n            <div i18n>in</div>\n          }\n        </div>\n      </div>\n      <div class=\"description\">\n        <span i18n>Recent Rainfall</span>\n      </div>\n    </div>\n    <div class=\"weather-section\">\n      <div class=\"info\">\n        <img width=\"55px\" height=\"55px\" [alt]=\"weather.icon\" [ngSrc]=\"'/assets/images/weather/' + weather.icon\" />\n        <div class=\"align-start\">\n          @if ($isMetric()) {\n            <div class=\"large-font\">{{ weather.tempC }}</div>\n            <div i18n>&deg;C</div>\n          } @else {\n            <div class=\"large-font\">{{ weather.tempF }}</div>\n            <div i18n>&deg;F</div>\n          }\n        </div>\n      </div>\n      <div class=\"description\">\n        <span>{{ weather.description }}</span>\n      </div>\n    </div>\n  </div>\n}\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.weather{display:flex;flex-direction:row;gap:16px}.weather .weather-section{align-items:center;display:flex;flex:1;flex-direction:column;gap:8px}.weather .weather-section .info{align-items:center;display:flex;gap:4px}.weather .weather-section .info .align-baseline{align-items:baseline;display:flex;gap:4px}.weather .weather-section .info .align-start{align-items:start;display:flex;gap:4px}.weather .weather-section .large-font{font-size:2rem;line-height:2rem;font-weight:700}\n"], dependencies: [{ kind: "directive", type: ImageCdnSrcDirective, selector: "img[src], img[ngSrc]", inputs: ["src", "ngSrc"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: WeatherWidgetComponent, decorators: [{
            type: Component,
            args: [{ imports: [ImageCdnSrcDirective], selector: 'pii-weather-widget', standalone: true, template: "@let weather = $weather();\n@if (weather) {\n  <div class=\"weather\">\n    <div class=\"weather-section\">\n      <div class=\"info\">\n        <img width=\"55px\" height=\"55px\" [alt]=\"'rainfall'\" [ngSrc]=\"'/assets/images/weather/rainfall.png'\" />\n        <div class=\"align-baseline\">\n          @if ($isMetric()) {\n            <div class=\"large-font\">{{ weather.rainFallMm }}</div>\n            <div i18n>mm</div>\n          } @else {\n            <div class=\"large-font\">{{ weather.rainFallIn }}</div>\n            <div i18n>in</div>\n          }\n        </div>\n      </div>\n      <div class=\"description\">\n        <span i18n>Recent Rainfall</span>\n      </div>\n    </div>\n    <div class=\"weather-section\">\n      <div class=\"info\">\n        <img width=\"55px\" height=\"55px\" [alt]=\"weather.icon\" [ngSrc]=\"'/assets/images/weather/' + weather.icon\" />\n        <div class=\"align-start\">\n          @if ($isMetric()) {\n            <div class=\"large-font\">{{ weather.tempC }}</div>\n            <div i18n>&deg;C</div>\n          } @else {\n            <div class=\"large-font\">{{ weather.tempF }}</div>\n            <div i18n>&deg;F</div>\n          }\n        </div>\n      </div>\n      <div class=\"description\">\n        <span>{{ weather.description }}</span>\n      </div>\n    </div>\n  </div>\n}\n", styles: [".helper-bold{font-weight:700}.helper-full-width{width:100%}.material-switch-input{display:none}.material-switch-label{cursor:pointer;display:inline-block;min-width:42px;position:relative;text-align:start}.material-switch-label:before,.material-switch-label:after{content:\"\";margin:0;outline:0;position:absolute;top:50%;transform:translateY(-50%);transition:all .3s ease}.material-switch-label:before{height:14px;width:34px;background-color:gray;border-radius:8px;left:1px}.material-switch-label:after{height:26px;width:26px;background-color:#d8d8d8;border-radius:50%;box-shadow:0 3px 1px -2px #00000024,0 2px 2px #00000019,0 1px 5px #00000015;left:0}.material-switch-label .toggle-on{display:none}.material-switch-label .toggle-off{display:inline-block}.material-switch-input:checked+.material-switch-label:before{background-color:var(--primary-color-lighter)}.material-switch-input:checked+.material-switch-label:after{background-color:var(--primary-color);transform:translate(80%,-50%)}.material-switch-input:checked+.material-switch-label .toggle-on{display:inline-block}.material-switch-input:checked+.material-switch-label .toggle-off{display:none}mat-expansion-panel-header{box-shadow:0 1px 3px 0 var(--shadow-color);height:54px}mat-expansion-panel-header.mat-expanded{height:54px}.default-color,.profile-blue{background:#09c}.profile-darkblue,.profile-dark-blue{background:#05f}.profile-brown{background:#7f4f04}.profile-gold{background:#fc0}.profile-green{background:#26c407}.profile-darkgreen{background:#090}.profile-orange{background:#ff7e00}.profile-purple{background:#90c}.profile-red{background:#c00}.profile-salmon{background:#f66}.primary-bg{background:var(--primary-color)}a{text-decoration:none}h1{font-size:2.25rem;line-height:2.25rem;font-family:var(--brand-font);margin:0}h1.small-h1{font-size:1.1rem;line-height:1.1rem;font-family:Helvetica,serif}.story-wrapper{background-color:#ffffffd9;border-radius:10px;box-shadow:0 2px 8px #57192133;font-family:Helvetica,serif;padding:24px;width:max-content}.story-wrapper.narrow{max-width:300px}.story-wrapper .zero-padding{padding:0}.story-wrapper .small-padding{padding:0 4px}.story-wrapper .medium-padding{padding:0 8px}.story-wrapper .large-padding{padding:0 16px}.story-wrapper .x-large-padding{padding:0 24px}.story-wrapper .xx-large-padding{padding:0 32px}.weather{display:flex;flex-direction:row;gap:16px}.weather .weather-section{align-items:center;display:flex;flex:1;flex-direction:column;gap:8px}.weather .weather-section .info{align-items:center;display:flex;gap:4px}.weather .weather-section .info .align-baseline{align-items:baseline;display:flex;gap:4px}.weather .weather-section .info .align-start{align-items:start;display:flex;gap:4px}.weather .weather-section .large-font{font-size:2rem;line-height:2rem;font-weight:700}\n"] }]
        }], ctorParameters: () => [{ type: i3.UserProfileService }] });

class WeatherResourceService {
    constructor(config, http) {
        this.http = http;
        this.baseUrl = config.weather.url;
        this.hoursPast = config.weather.hoursPast;
        this.clientParams = `client_id=${config.weather.clientId}&client_secret=${config.weather.clientSecret}`;
    }
    getWeatherForCoordinate(coordinate) {
        return this.http.get(`${this.baseUrl}/conditions?${this.clientParams}&p=${coordinate.lat},${coordinate.lng}&from=-${this.hoursPast}hours&to=now`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: WeatherResourceService, deps: [{ token: i1$1.ConfigService }, { token: i1$2.WebComponentHttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: WeatherResourceService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: WeatherResourceService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.ConfigService }, { type: i1$2.WebComponentHttpClient }] });

class WeatherService {
    constructor(weatherResourceService) {
        this.weatherResourceService = weatherResourceService;
        this.className = 'WeatherService';
    }
    getWeatherForCoordinate(coordinate) {
        return this.weatherResourceService
            .getWeatherForCoordinate(coordinate)
            .pipe(map$1((res) => new WeatherCondition(res.response?.[0]?.periods)));
    }
    getWeatherForLineString(geometry) {
        const coord = center(geometry).geometry.coordinates;
        return this.getWeatherForCoordinate(GeoCoordinate.fromCoordinateArray(coord));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: WeatherService, deps: [{ token: WeatherResourceService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: WeatherService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: WeatherService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: WeatherResourceService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, CartesianPoint, CartesianTile, Condition, ConditionDetailComponent, ConditionService, ConditionWidgetComponent, ConfirmDialogComponent, ConfirmDialogOptions, ConsoleLogService, ConversionService, DateTimeService, DayHours, DisplayDuration, DistanceDisplayComponent, DistanceDisplayService, DurationDisplayComponent, DurationDisplayService, EfficiencyDisplayService, FormattedValue, GeoBounds, GeoBoundsTileService, GeoCoordinate, GeoJsonFeatureCollection, GeoJsonLineString, GeoJsonMultiPoint, GeoJsonPoint, GeoJsonPolygon, GeoService, GeocoderResource, GeocoderService, Hours, I18nNumberInputDirective, IconModule, Image, ImageCdnSrcDirective, ImageCdnSrcSetDirective, IsMobileViewService, LocaleNumberCoordinateFormatPipe, LocaleNumberFormatPipe, LogService, MailingAddress, MqttService, PhotoLink, PublicWaypointService, PushService, RelativeWeekdayPipe, RemoveWhiteSpacePipe, RideTypeService, RoutingHelpersService, SaveCancelDeleteBarComponent, SnapshotToUrlPipe, SpeedDisplayService, StringPipe, TemperatureDisplayService, TimeDisplayService, ToDistancePipe, ToDistanceUnitsPipe, UpdateTimePipe, UppercaseDirective, UserItemPromoComponent, UserLocationService, UuidService, ValueDisplayService, WeatherCondition, WeatherService, WeatherWidgetComponent, arePointsEquivalent, distanceBetweenPointsInMeters, findClosestGeoCoordinate, findClosestPoint, findIndexToInsertPoint, findIntersectedSegmentIndices, getBoundLat, getBoundLng, getCenterBetweenPoints, getCoordinateDistanceFromLineInDegrees, getDurationDisplayTotals, pointsToRadians, polylineStringToGeoCoordinates, provideIcons, provideLocaleFromUrl, provideSharedComponents, provideWebComponentHttpClient, provideWebComponentNoInterceptHttpClient, radiansToMeters };
